// locales/ar.json
var ar_default = {
  $meta: {
    locale: "ar",
    direction: "rtl"
  },
  "common.save": "\u062D\u0641\u0638",
  "common.cancel": "\u0625\u0644\u063A\u0627\u0621",
  "common.delete": "\u062D\u0630\u0641",
  "common.close": "\u0625\u063A\u0644\u0627\u0642",
  "common.confirm": "\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F\u061F",
  "common.create": "\u0625\u0646\u0634\u0627\u0621",
  "common.edit": "\u062A\u0639\u062F\u064A\u0644",
  "common.clear": "\u0645\u0633\u062D",
  "common.title": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
  "common.view": "\u0639\u0631\u0636",
  "common.add": "\u0625\u0636\u0627\u0641\u0629",
  "common.remove": "\u0625\u0632\u0627\u0644\u0629",
  "common.search": "\u0628\u062D\u062B...",
  "common.filter": "\u062A\u0635\u0641\u064A\u0629",
  "common.actions": "\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
  "common.yes": "\u0646\u0639\u0645",
  "common.no": "\u0644\u0627",
  "common.ok": "\u062D\u0633\u0646\u064B\u0627",
  "common.done": "\u062A\u0645",
  "common.apply": "\u062A\u0637\u0628\u064A\u0642",
  "common.reset": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646",
  "common.refresh": "\u062A\u062D\u062F\u064A\u062B",
  "common.export": "\u062A\u0635\u062F\u064A\u0631",
  "common.import": "\u0627\u0633\u062A\u064A\u0631\u0627\u062F",
  "common.copy": "\u0646\u0633\u062E",
  "common.settings": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
  "nav.previous": "\u0627\u0644\u0633\u0627\u0628\u0642",
  "nav.next": "\u0627\u0644\u062A\u0627\u0644\u064A",
  "nav.back": "\u0631\u062C\u0648\u0639",
  "nav.home": "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
  "form.submit": "\u0625\u0631\u0633\u0627\u0644",
  "form.saving": "\u062C\u0627\u0631\u064D \u0627\u0644\u062D\u0641\u0638...",
  "form.required": "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0645\u0637\u0644\u0648\u0628",
  "form.invalidEmail": "\u0623\u062F\u062E\u0644 \u0628\u0631\u064A\u062F\u064B\u0627 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 \u0635\u062D\u064A\u062D\u064B\u0627",
  "form.selectPlaceholder": "\u0627\u062E\u062A\u0631 {{label}}...",
  "form.searchPlaceholder": "\u0627\u0628\u062D\u062B \u0639\u0646 {{entity}}...",
  "table.empty.title": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631",
  "table.empty.description": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u0644\u0644\u0639\u0631\u0636.",
  "table.search.placeholder": "\u0628\u062D\u062B...",
  "table.pagination.showing": "\u0639\u0631\u0636 {{start}} \u0625\u0644\u0649 {{end}} \u0645\u0646 {{total}} \u0646\u062A\u064A\u062C\u0629",
  "table.pagination.page": "\u0635\u0641\u062D\u0629 {{page}} \u0645\u0646 {{totalPages}}",
  "table.bulk.selected": "{{count}} \u0645\u062D\u062F\u062F",
  "table.loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
  "status.loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
  "status.scheduled": "\u0645\u062C\u062F\u0648\u0644",
  "status.inProgress": "\u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0641\u064A\u0630",
  "status.completed": "\u0645\u0643\u062A\u0645\u0644",
  "status.cancelled": "\u0645\u0644\u063A\u0649",
  "status.pending": "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
  "status.active": "\u0646\u0634\u0637",
  "status.inactive": "\u063A\u064A\u0631 \u0646\u0634\u0637",
  "status.draft": "\u0645\u0633\u0648\u062F\u0629",
  "status.archived": "\u0645\u0624\u0631\u0634\u0641",
  "error.generic": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627",
  "error.traitMountFailed": "\u062A\u0639\u0630\u0651\u0631 \u0628\u062F\u0621 {{trait}}",
  "error.retry": "\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "error.notFound": "\u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F",
  "error.loadFailed": "\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0645\u064A\u0644: {{message}}",
  "error.configMissing": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0625\u0639\u062F\u0627\u062F: {{id}}",
  "common.loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
  "common.saveChanges": "\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
  "common.retry": "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
  "common.open": "\u0641\u062A\u062D",
  "common.back": "\u0631\u062C\u0648\u0639",
  "empty.noItems": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631",
  "empty.noData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
  "empty.noItemsYet": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u0628\u0639\u062F",
  "empty.noItemsAdded": "\u0644\u0645 \u062A\u062A\u0645 \u0625\u0636\u0627\u0641\u0629 \u0639\u0646\u0627\u0635\u0631 \u0628\u0639\u062F",
  "empty.noOptionsFound": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062E\u064A\u0627\u0631\u0627\u062A",
  "list.addItemPlaceholder": "\u0625\u0636\u0627\u0641\u0629 \u0639\u0646\u0635\u0631 \u062C\u062F\u064A\u062F...",
  "error.occurred": "\u062D\u062F\u062B \u062E\u0637\u0623",
  "error.failedToLoad": "\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  "wizard.back": "\u0631\u062C\u0648\u0639",
  "wizard.next": "\u0627\u0644\u062A\u0627\u0644\u064A",
  "wizard.complete": "\u0625\u0643\u0645\u0627\u0644",
  "wizard.stepOf": "\u0627\u0644\u062E\u0637\u0648\u0629 {{current}} \u0645\u0646 {{total}}",
  "pagination.previous": "\u0627\u0644\u0633\u0627\u0628\u0642",
  "pagination.next": "\u0627\u0644\u062A\u0627\u0644\u064A",
  "pagination.total": "\u0627\u0644\u0645\u062C\u0645\u0648\u0639:",
  "pagination.show": "\u0639\u0631\u0636:",
  "pagination.goTo": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649:",
  "pagination.go": "\u0627\u0646\u062A\u0642\u0627\u0644",
  "auth.signIn": "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
  "auth.signOut": "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C",
  "auth.welcomeTo": "\u0645\u0631\u062D\u0628\u064B\u0627 \u0628\u0643 \u0641\u064A {{appName}}",
  "auth.brandingSubtitle": "\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0644\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645 \u0648\u0625\u062F\u0627\u0631\u0629 \u062D\u0633\u0627\u0628\u0643.",
  "dialog.confirm": "\u062A\u0623\u0643\u064A\u062F",
  "dialog.cancel": "\u0625\u0644\u063A\u0627\u0621",
  "dialog.loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
  "dialog.delete.title": "\u062D\u0630\u0641 {{item}}\u061F",
  "dialog.delete.message": "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0625\u062C\u0631\u0627\u0621.",
  "trait.availableActions": "\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
  "trait.transitions": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "trait.availableNow": "\u0645\u062A\u0627\u062D \u0627\u0644\u0622\u0646",
  "book.startReading": "\u0627\u0628\u062F\u0623 \u0627\u0644\u0642\u0631\u0627\u0621\u0629",
  "book.tableOfContents": "\u0641\u0647\u0631\u0633 \u0627\u0644\u0645\u062D\u062A\u0648\u064A\u0627\u062A",
  "book.partNumber": "\u0627\u0644\u062C\u0632\u0621 {{number}}",
  "book.print": "\u0637\u0628\u0627\u0639\u0629",
  "book.previousPage": "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "book.nextPage": "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "quiz.showAnswer": "\u0623\u0638\u0647\u0631 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  "quiz.hideAnswer": "\u0623\u062E\u0641\u0650 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  "aria.closeModal": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0646\u0627\u0641\u0630\u0629",
  "aria.closeToast": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062A\u0646\u0628\u064A\u0647",
  "aria.closeAlert": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062A\u0646\u0628\u064A\u0647",
  "aria.removeFilter": "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0641\u0644\u062A\u0631",
  "aria.closeDrawer": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629",
  "aria.closePanel": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0644\u0648\u062D\u0629",
  "aria.dockPanel": "\u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629",
  "aria.previousImage": "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "aria.nextImage": "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "aria.dismiss": "\u062A\u062C\u0627\u0647\u0644",
  "aria.previousSlide": "\u0627\u0644\u0634\u0631\u064A\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "aria.nextSlide": "\u0627\u0644\u0634\u0631\u064A\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "aria.previousDays": "\u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "aria.nextDays": "\u0627\u0644\u0623\u064A\u0627\u0645 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "aria.decrease": "\u062A\u0642\u0644\u064A\u0644",
  "aria.increase": "\u0632\u064A\u0627\u062F\u0629",
  "aria.breadcrumb": "\u0645\u0633\u0627\u0631 \u0627\u0644\u062A\u0646\u0642\u0644",
  "aria.tableOfContents": "\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u062D\u062A\u0648\u064A\u0627\u062A",
  "aria.docsSidebar": "\u0634\u0631\u064A\u0637 \u062A\u0648\u062B\u064A\u0642 \u062C\u0627\u0646\u0628\u064A",
  "aria.selectAllRows": "\u062A\u062D\u062F\u064A\u062F \u0643\u0644 \u0627\u0644\u0635\u0641\u0648\u0641",
  "aria.selectAll": "\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644",
  "aria.upvote": "\u062A\u0635\u0648\u064A\u062A \u0625\u064A\u062C\u0627\u0628\u064A",
  "aria.downvote": "\u062A\u0635\u0648\u064A\u062A \u0633\u0644\u0628\u064A",
  "aria.qrScanner": "\u0645\u0627\u0633\u062D QR",
  "aria.openMenu": "\u0641\u062A\u062D \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  "aria.closeMenu": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  "aria.openSidebar": "\u0641\u062A\u062D \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A",
  "aria.openRow": "\u0641\u062A\u062D \u0627\u0644\u0639\u0646\u0635\u0631 {{position}}",
  "sidebar.expand": "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A",
  "sidebar.collapse": "\u0637\u064A \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A",
  "sidebar.close": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0634\u0631\u064A\u0637 \u0627\u0644\u062C\u0627\u0646\u0628\u064A",
  "loading.items": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0646\u0627\u0635\u0631...",
  "card.imageAlt": "\u0635\u0648\u0631\u0629",
  "canvas.emptyMessage": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u062D\u062A\u0648\u0649",
  "canvas.errorTitle": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0644\u0648\u062D\u0629",
  "book.noData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A",
  "common.notifications": "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A",
  "common.remaining": "{{count}} \u0645\u062A\u0628\u0642\u064A",
  "error.somethingWentWrong": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627",
  "error.loadingItems": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0639\u0646\u0627\u0635\u0631...",
  "error.noItemsFound": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0639\u0646\u0627\u0635\u0631",
  "debug.noEntityData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0643\u064A\u0627\u0646",
  "debug.noEntities": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0643\u064A\u0627\u0646\u0627\u062A",
  "debug.noTicks": "\u0644\u0627 \u062A\u0648\u062C\u062F ticks \u0645\u0633\u062C\u0644\u0629",
  "debug.noActiveTraits": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0641\u0627\u062A \u0646\u0634\u0637\u0629",
  "debug.noGuardEvaluations": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u0642\u064A\u064A\u0645\u0627\u062A \u062D\u0627\u0631\u0633\u0629",
  "debug.noBridgeData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A bridge",
  "debug.status": "\u0627\u0644\u062D\u0627\u0644\u0629",
  "debug.eventsForwarded": "\u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0645\u0631\u0633\u0644\u0629 (\u0639\u0645\u064A\u0644 \u2192 \u062E\u0627\u062F\u0645)",
  "debug.eventsReceived": "\u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629 (\u062E\u0627\u062F\u0645 \u2192 \u0639\u0645\u064A\u0644)",
  "debug.lastHeartbeat": "\u0622\u062E\u0631 \u0646\u0628\u0636\u0629",
  "debug.noEventsYet": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0628\u0639\u062F",
  "debug.noTransitionsRecorded": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0645\u0633\u062C\u0644\u0629",
  "debug.noVerificationChecks": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0645\u0644\u064A\u0627\u062A \u062A\u062D\u0642\u0642 \u0628\u0639\u062F",
  "display.chartError": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u062E\u0637\u0637",
  "display.codeViewerError": "\u062E\u0637\u0623 \u0641\u064A \u0639\u0627\u0631\u0636 \u0627\u0644\u0643\u0648\u062F",
  "display.noCode": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0643\u0648\u062F",
  "display.documentError": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
  "display.noDocument": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0633\u062A\u0646\u062F",
  "display.graphError": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0631\u0633\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u064A",
  "display.noGraphData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A",
  "display.galleryError": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0639\u0631\u0636",
  "display.noMedia": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u0633\u0627\u0626\u0637",
  "display.meterError": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0624\u0634\u0631",
  "display.signaturePadError": "\u062E\u0637\u0623 \u0641\u064A \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u0648\u0642\u064A\u0639",
  "display.timelineError": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062E\u0637 \u0627\u0644\u0632\u0645\u0646\u064A",
  "display.noEvents": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B",
  "display.details": "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
  "display.itemNotFound": "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u0645\u0637\u0644\u0648\u0628.",
  "display.noTimelineEvents": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0632\u0645\u0646\u064A\u0629 \u0644\u0639\u0631\u0636\u0647\u0627.",
  "template.features": "\u0627\u0644\u0645\u064A\u0632\u0627\u062A",
  "template.howItWorks": "\u0643\u064A\u0641 \u064A\u0639\u0645\u0644",
  "template.showcase": "\u0645\u0639\u0631\u0636 \u0627\u0644\u0623\u0639\u0645\u0627\u0644",
  "template.faq": "\u0627\u0644\u0623\u0633\u0626\u0644\u0629 \u0627\u0644\u0634\u0627\u0626\u0639\u0629",
  "template.ourTeam": "\u0641\u0631\u064A\u0642\u0646\u0627",
  "template.caseStudies": "\u062F\u0631\u0627\u0633\u0627\u062A \u0627\u0644\u062D\u0627\u0644\u0629",
  "versionDiff.compare": "\u0645\u0642\u0627\u0631\u0646\u0629",
  "versionDiff.changes": "\u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
  "versionDiff.to": "\u0625\u0644\u0649",
  "versionDiff.beforeRevision": "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "versionDiff.afterRevision": "\u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629 \u0627\u0644\u0644\u0627\u062D\u0642\u0629",
  "versionDiff.switchToInline": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0636\u0645\u0646",
  "versionDiff.switchToSideBySide": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0636 \u062C\u0646\u0628\u064B\u0627 \u0625\u0644\u0649 \u062C\u0646\u0628",
  "versionDiff.revert": "\u062A\u0631\u0627\u062C\u0639",
  "versionDiff.byAuthor": " \u0628\u0648\u0627\u0633\u0637\u0629 {{author}}",
  "versionDiff.unchangedLines": "{{count}} \u0633\u0637\u0631\u064B\u0627 \u062F\u0648\u0646 \u062A\u063A\u064A\u064A\u0631",
  "versionDiff.noChanges": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629.",
  "violationAlert.actionType.measure": "\u0625\u062C\u0631\u0627\u0621 \u062A\u0635\u062D\u064A\u062D\u064A",
  "violationAlert.actionType.admin": "\u0625\u062C\u0631\u0627\u0621 \u0625\u062F\u0627\u0631\u064A",
  "violationAlert.actionType.penalty": "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0639\u0642\u0648\u0628\u0629",
  "violationAlert.fallbackMessage": "\u0645\u062E\u0627\u0644\u0641\u0629",
  "violationAlert.adminLabel": "\u0625\u062F\u0627\u0631\u064A:",
  "violationAlert.penaltyLabel": "\u0639\u0642\u0648\u0628\u0629:",
  "violationAlert.goToField": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0627\u0644\u062D\u0642\u0644",
  "branchingLogic.title": "\u0645\u0646\u0637\u0642 \u0627\u0644\u062A\u0641\u0631\u0639",
  "branchingLogic.if": "\u0625\u0630\u0627",
  "branchingLogic.goTo": "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649",
  "branchingLogic.rules": "\u0627\u0644\u0642\u0648\u0627\u0639\u062F",
  "branchingLogic.logicGraph": "\u0631\u0633\u0645 \u0627\u0644\u0645\u0646\u0637\u0642",
  "branchingLogic.addRule": "\u0625\u0636\u0627\u0641\u0629 \u0642\u0627\u0639\u062F\u0629",
  "branchingLogic.deleteRule": "\u062D\u0630\u0641 \u0627\u0644\u0642\u0627\u0639\u062F\u0629",
  "branchingLogic.endOfSurvey": "\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0627\u0633\u062A\u0628\u064A\u0627\u0646",
  "branchingLogic.brokenReference": "\u0645\u0631\u062C\u0639 \u0645\u0639\u0637\u0651\u0644",
  "branchingLogic.selectQuestion": "\u0627\u062E\u062A\u0631 \u0633\u0624\u0627\u0644\u0627\u064B",
  "branchingLogic.selectTarget": "\u0627\u062E\u062A\u0631 \u0627\u0644\u0647\u062F\u0641",
  "branchingLogic.selectValue": "\u0627\u062E\u062A\u0631 \u0642\u064A\u0645\u0629",
  "branchingLogic.addValue": "\u0625\u0636\u0627\u0641\u0629 \u0642\u064A\u0645\u0629",
  "branchingLogic.value": "\u0627\u0644\u0642\u064A\u0645\u0629",
  "branchingLogic.typeValuePressEnter": "\u0627\u0643\u062A\u0628 \u0642\u064A\u0645\u0629\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 Enter",
  "branchingLogic.operatorEquals": "\u064A\u0633\u0627\u0648\u064A",
  "branchingLogic.operatorNotEquals": "\u0644\u0627 \u064A\u0633\u0627\u0648\u064A",
  "branchingLogic.operatorContains": "\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649",
  "branchingLogic.operatorIn": "\u0647\u0648 \u0623\u062D\u062F",
  "branchingLogic.graphAriaLabel": "\u0631\u0633\u0645 \u0645\u0646\u0637\u0642 \u0627\u0644\u062A\u0641\u0631\u0639",
  "branchingLogic.ruleCountOne": "{{count}} \u0642\u0627\u0639\u062F\u0629",
  "branchingLogic.ruleCountOther": "{{count}} \u0642\u0627\u0639\u062F\u0629",
  "branchingLogic.brokenCount": "{{count}} \u0645\u0639\u0637\u0651\u0644\u0629",
  "branchingLogic.emptyNoQuestions": "\u0623\u0636\u0641 \u0623\u0633\u0626\u0644\u0629 \u0642\u0628\u0644 \u0625\u0646\u0634\u0627\u0621 \u0642\u0648\u0627\u0639\u062F \u0627\u0644\u062A\u0641\u0631\u0639.",
  "branchingLogic.emptyNoRules": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0642\u0648\u0627\u0639\u062F \u0628\u0639\u062F. \u0623\u0636\u0641 \u0642\u0627\u0639\u062F\u0629 \u0644\u062A\u062D\u062F\u064A\u062F \u0645\u0646\u0637\u0642 \u0627\u0644\u062A\u0641\u0631\u0639.",
  "filterGroup.filters": "\u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
  "filterGroup.all": "\u0627\u0644\u0643\u0644",
  "filterGroup.clear": "\u0645\u0633\u062D",
  "filterGroup.clearAll": "\u0645\u0633\u062D \u0627\u0644\u0643\u0644",
  "filterGroup.from": "\u0645\u0646",
  "filterGroup.to": "\u0625\u0644\u0649",
  "filterGroup.allOf": "\u0643\u0644 {{label}}",
  "filterGroup.activeCount": "{{count}} \u0646\u0634\u0637\u0629",
  "debug.guardEvaluationsHint": "\u0633\u062A\u0638\u0647\u0631 \u062A\u0642\u064A\u064A\u0645\u0627\u062A \u0627\u0644\u062D\u0627\u0631\u0633 \u0639\u0646\u062F \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0623\u0648 \u0627\u0644\u0646\u0628\u0636\u0627\u062A \u0627\u0644\u0645\u0632\u0648\u062F\u0629 \u0628\u062D\u0631\u0627\u0633",
  "debug.expression": "\u0627\u0644\u062A\u0639\u0628\u064A\u0631",
  "debug.inputs": "\u0627\u0644\u0645\u062F\u062E\u0644\u0627\u062A",
  "debug.trait": "\u0627\u0644\u0633\u0645\u0629",
  "debug.filterAll": "\u0627\u0644\u0643\u0644",
  "debug.filterPassed": "\u0646\u0627\u062C\u062D",
  "debug.filterFailed": "\u0641\u0627\u0634\u0644",
  "debug.traitsInitHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0633\u0645\u0627\u062A \u0639\u0646\u062F \u062A\u0647\u064A\u0626\u0629 \u0622\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0629",
  "debug.traitsMountHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0633\u0645\u0627\u062A \u0639\u0646\u062F \u062A\u0631\u0643\u064A\u0628 \u0627\u0644\u0645\u0643\u0648\u0651\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0633\u062A\u062E\u062F\u0645\u0647\u0627",
  "debug.activeStates": "\u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
  "debug.availableEvents": "\u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
  "debug.noTransitionsFromState": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  "debug.guarded": "\u0645\u062D\u0631\u0648\u0633",
  "debug.otherEvents": "\u0623\u062D\u062F\u0627\u062B \u0623\u062E\u0631\u0649 (\u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u064A\u0629)",
  "debug.recentTransitions": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0627\u0644\u0623\u062E\u064A\u0631\u0629",
  "debug.transitionsCount": "{{count}} \u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "debug.states": "\u0627\u0644\u062D\u0627\u0644\u0627\u062A",
  "debug.transitions": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "debug.guards": "\u0627\u0644\u062D\u064F\u0631\u0651\u0627\u0633",
  "debug.debugModeHint": "\u0642\u062F \u0644\u0627 \u064A\u0643\u0648\u0646 \u0648\u0636\u0639 \u0627\u0644\u062A\u0635\u062D\u064A\u062D \u0645\u064F\u0641\u0639\u0651\u0644\u0627\u064B",
  "debug.entitiesSpawnHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0643\u064A\u0627\u0646\u0627\u062A \u0639\u0646\u062F \u0625\u0646\u0634\u0627\u0626\u0647\u0627",
  "debug.singleton": "\u0645\u0641\u0631\u062F",
  "debug.singletonsCount": "\u0627\u0644\u0645\u0641\u0631\u062F\u0627\u062A ({{count}})",
  "debug.runtimeCount": "\u0648\u0642\u062A \u0627\u0644\u062A\u0634\u063A\u064A\u0644 ({{count}})",
  "debug.moreEntities": "+{{count}} \u0643\u064A\u0627\u0646\u0627\u062A \u0623\u062E\u0631\u0649",
  "debug.persistent": "\u062F\u0627\u0626\u0645",
  "debug.loadedCount": "{{count}} \u0645\u064F\u062D\u0645\u0651\u0644",
  "debug.notLoaded": "\u063A\u064A\u0631 \u0645\u064F\u062D\u0645\u0651\u0644",
  "debug.eventsExecuteHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0623\u062B\u0646\u0627\u0621 \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u0633\u0645\u0627\u062A \u0648\u0627\u0644\u0646\u0628\u0636\u0627\u062A \u0648\u0627\u0644\u0623\u0646\u0638\u0645\u0629 \u0627\u0644\u0623\u062E\u0631\u0649",
  "debug.allCount": "\u0627\u0644\u0643\u0644 ({{count}})",
  "debug.autoScroll": "\u062A\u0645\u0631\u064A\u0631 \u062A\u0644\u0642\u0627\u0626\u064A",
  "debug.transitionsProcessHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0623\u062B\u0646\u0627\u0621 \u0645\u0639\u0627\u0644\u062C\u0629 \u0622\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0629 \u0644\u0644\u0623\u062D\u062F\u0627\u062B",
  "debug.transitionsRecorded": "\u062A\u0645 \u062A\u0633\u062C\u064A\u0644 {{count}} \u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "debug.guardLabel": "\u0627\u0644\u062D\u0627\u0631\u0633:",
  "debug.effectsCount": "{{count}} \u062A\u0623\u062B\u064A\u0631\u0627\u062A",
  "debug.bridgeInitHint": "\u0644\u0645 \u062A\u062A\u0645 \u062A\u0647\u064A\u0626\u0629 \u062C\u0633\u0631 \u0627\u0644\u062E\u0627\u062F\u0645. \u0633\u062A\u0638\u0647\u0631 \u0635\u062D\u0629 \u0627\u0644\u062C\u0633\u0631 \u0628\u0645\u062C\u0631\u062F \u0627\u062A\u0635\u0627\u0644 \u0648\u0642\u062A \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645.",
  "debug.never": "\u0623\u0628\u062F\u0627\u064B",
  "debug.connected": "\u0645\u062A\u0635\u0644",
  "debug.disconnected": "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644",
  "debug.lastError": "\u0622\u062E\u0631 \u062E\u0637\u0623",
  "debug.totalEventsProcessed": "\u062A\u0645\u062A \u0645\u0639\u0627\u0644\u062C\u0629 {{count}} \u062D\u062F\u062B\u0627\u064B \u0625\u062C\u0645\u0627\u0644\u0627\u064B",
  "debug.server": "\u0627\u0644\u062E\u0627\u062F\u0645",
  "debug.clientEffectsCount": "{{count}} \u062A\u0623\u062B\u064A\u0631\u0627\u062A \u0639\u0645\u064A\u0644",
  "debug.emitLabel": "\u0625\u0635\u062F\u0627\u0631:",
  "debug.rowsCount": "{{count}} \u0635\u0641\u0648\u0641",
  "debug.serverResponse": "\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u062E\u0627\u062F\u0645",
  "debug.collapseVerificationTimeline": "\u0637\u064A\u0651 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0644\u062A\u062D\u0642\u0642",
  "debug.expandVerificationTimeline": "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A \u0644\u0644\u062A\u062D\u0642\u0642",
  "debug.failCount": "{{count}} \u0641\u0634\u0644",
  "debug.ok": "\u062D\u0633\u0646\u0627\u064B",
  "debug.localCount": "{{count}} \u0645\u062D\u0644\u064A",
  "debug.serverCount": "{{count}} \u062E\u0627\u062F\u0645",
  "debug.waitingForTransitions": "\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A...",
  "debug.tabDispatch": "\u0627\u0644\u0625\u0631\u0633\u0627\u0644",
  "debug.tabVerify": "\u0627\u0644\u062A\u062D\u0642\u0642",
  "debug.tabVerifyAlert": "\u0627\u0644\u062A\u062D\u0642\u0642 (!)",
  "debug.tabTimeline": "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
  "debug.tabBridge": "\u0627\u0644\u062C\u0633\u0631",
  "debug.tabTraits": "\u0627\u0644\u0633\u0645\u0627\u062A",
  "debug.tabTicks": "\u0627\u0644\u0646\u0628\u0636\u0627\u062A",
  "debug.tabEntities": "\u0627\u0644\u0643\u064A\u0627\u0646\u0627\u062A",
  "debug.tabEvents": "\u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "debug.tabGuards": "\u0627\u0644\u062D\u064F\u0631\u0651\u0627\u0633",
  "debug.debugger": "\u0627\u0644\u0645\u0635\u062D\u0651\u062D",
  "debug.failedCount": "{{count}} \u0641\u0627\u0634\u0644",
  "debug.traitsCount": "{{count}} \u0633\u0645\u0627\u062A",
  "debug.idle": "\u062E\u0627\u0645\u0644",
  "debug.openDebugger": "\u0641\u062A\u062D \u0627\u0644\u0645\u0635\u062D\u0651\u062D (`)",
  "debug.kflowVerifier": "\u0645\u064F\u062A\u062D\u0642\u0651\u0642 KFlow",
  "debug.allPassing": "\u0627\u0644\u0643\u0644 \u0646\u0627\u062C\u062D",
  "debug.runtime": "\u0648\u0642\u062A \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  "debug.close": "\u0625\u063A\u0644\u0627\u0642 (`)",
  "debug.toggleHint": "\u0627\u0636\u063A\u0637 ` \u0644\u0644\u062A\u0628\u062F\u064A\u0644 | window.__orbitalVerification \u0644\u0644\u0623\u062A\u0645\u062A\u0629",
  "replyTree.expandReplies": "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0631\u062F\u0648\u062F",
  "replyTree.collapseReplies": "\u0637\u064A \u0627\u0644\u0631\u062F\u0648\u062F",
  "replyTree.voteOnReplyBy": "\u0627\u0644\u062A\u0635\u0648\u064A\u062A \u0639\u0644\u0649 \u0631\u062F {{author}}",
  "replyTree.replyTo": "\u0627\u0644\u0631\u062F \u0639\u0644\u0649 {{author}}",
  "replyTree.replyToPlaceholder": "\u0627\u0644\u0631\u062F \u0639\u0644\u0649 {{author}}\u2026",
  "replyTree.reply": "\u0631\u062F",
  "replyTree.flagReplyBy": "\u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0631\u062F {{author}}",
  "replyTree.flag": "\u0625\u0628\u0644\u0627\u063A",
  "replyTree.send": "\u0625\u0631\u0633\u0627\u0644",
  "replyTree.continueThread": "\u0645\u062A\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629",
  "replyTree.noRepliesYet": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u062F\u0648\u062F \u0628\u0639\u062F.",
  "signaturePad.label": "\u0627\u0644\u062A\u0648\u0642\u064A\u0639",
  "signaturePad.helperText": "\u0627\u0631\u0633\u0645 \u062A\u0648\u0642\u064A\u0639\u0643 \u0623\u0639\u0644\u0627\u0647",
  "signaturePad.clear": "\u0645\u0633\u062D",
  "signaturePad.confirm": "\u062A\u0623\u0643\u064A\u062F",
  "qrScanner.cameraUnavailable": "\u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629",
  "qrScanner.paused": "\u0645\u062A\u0648\u0642\u0641 \u0645\u0624\u0642\u062A\u064B\u0627",
  "qrScanner.resumeScanning": "\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0627\u0644\u0645\u0633\u062D",
  "qrScanner.pauseScanning": "\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u0645\u0633\u062D \u0645\u0624\u0642\u062A\u064B\u0627",
  "qrScanner.switchToFrontCamera": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u0623\u0645\u0627\u0645\u064A\u0629",
  "qrScanner.switchToRearCamera": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u0627\u0644\u062E\u0644\u0641\u064A\u0629",
  "docSearch.placeholder": "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0648\u062B\u0627\u0626\u0642...",
  "stateMachine.loading": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0622\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0629\u2026",
  "stateMachine.noStateMachine": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0622\u0644\u0629 \u062D\u0627\u0644\u0629 \u0644\u0639\u0631\u0636\u0647\u0627",
  "avl.trigger": "\u0627\u0644\u0645\u064F\u0634\u063A\u0650\u0651\u0644",
  "avl.guard": "\u0627\u0644\u062D\u0627\u0631\u0633",
  "avl.effects": "\u0627\u0644\u062A\u0623\u062B\u064A\u0631\u0627\u062A",
  "avl.props": "\u0627\u0644\u062E\u0635\u0627\u0626\u0635",
  "avl.entity": "\u0627\u0644\u0643\u064A\u0627\u0646",
  "avl.traits": "\u0627\u0644\u0633\u0645\u0627\u062A",
  "avl.transition": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644",
  "avl.onEntity": "\u0639\u0644\u0649 {{entity}}",
  "avl.linkedTo": "\u0645\u0631\u062A\u0628\u0637 \u0628\u0640 {{entity}}",
  "avl.pressEscToZoomOut": "\u0627\u0636\u063A\u0637 Esc \u0644\u0644\u062A\u0635\u063A\u064A\u0631",
  "avl.zoomIn": "\u062A\u0643\u0628\u064A\u0631",
  "avl.zoomOut": "\u062A\u0635\u063A\u064A\u0631",
  "avl.orbitalLabel": "\u0645\u062F\u0627\u0631: {{name}}",
  "avl.orbitalLabelHighlighted": "\u0645\u062F\u0627\u0631: {{name}} (\u0645\u0645\u064A\u064E\u0651\u0632)",
  "avl.noTraitData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0633\u0645\u0629",
  "avl.computingLayout": "\u062C\u0627\u0631\u064D \u062D\u0633\u0627\u0628 \u0627\u0644\u062A\u062E\u0637\u064A\u0637...",
  "avl.noStateMachine": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0622\u0644\u0629 \u062D\u0627\u0644\u0627\u062A",
  "avl.listensFor": "\u064A\u0633\u062A\u0645\u0639 \u0625\u0644\u0649 {{event}}",
  "avl.emits": "\u064A\u064F\u0635\u062F\u0631 {{event}}",
  "avl.pageLayout": "\u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0635\u0641\u062D\u0629",
  "avl.overlaySuffix": "(\u062A\u0631\u0627\u0643\u0628)",
  "avl.stateCount": "\u0627\u0644\u062D\u0627\u0644\u0627\u062A: {{count}}",
  "avl.transitionCount": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A: {{count}}",
  "avl.listensRail": "\u064A\u0633\u062A\u0645\u0639",
  "avl.emitsRail": "\u064A\u064F\u0637\u0644\u0642",
  "avl.now": "\u0627\u0644\u0622\u0646",
  "avl.circuit.zone.entity": "\u0627\u0644\u0643\u064A\u0627\u0646",
  "avl.circuit.zone.store": "\u0627\u0644\u0645\u062E\u0632\u0646",
  "avl.circuit.zone.bus": "\u0627\u0644\u0646\u0627\u0642\u0644",
  "avl.circuit.zone.screen": "\u0627\u0644\u0634\u0627\u0634\u0629",
  "avl.circuit.zone.route": "\u0627\u0644\u0645\u0633\u0627\u0631",
  "avl.circuit.zone.toast": "\u0627\u0644\u0625\u0634\u0639\u0627\u0631",
  "avl.circuit.zone.remote": "\u0627\u0644\u062E\u0627\u062F\u0645 \u0627\u0644\u0628\u0639\u064A\u062F",
  "avl.circuit.zone.instances": "\u0627\u0644\u0646\u0633\u062E",
  "avl.circuit.zone.flow": "\u0627\u0644\u062A\u062F\u0641\u0642",
  "avl.circuit.zone.timer": "\u0627\u0644\u0645\u0624\u0642\u062A",
  "avl.circuit.zone.model": "\u0627\u0644\u0646\u0645\u0648\u0630\u062C",
  "avl.circuit.zone.system": "\u0627\u0644\u0646\u0638\u0627\u0645",
  "avl.circuit.evaluating": "\u062A\u0642\u064A\u064A\u0645 {{code}}",
  "avl.circuit.returned": "{{code}} \u2190 {{value}}",
  "avl.circuit.failed": "\u0641\u0634\u0644 {{code}}: {{error}}",
  "avl.circuit.skipped": "{{code}} \u0644\u0645 \u064A\u064F\u0646\u0641\u064E\u0651\u0630",
  "avl.circuit.nextItem": "\u0627\u0644\u0639\u0646\u0635\u0631 \u0627\u0644\u062A\u0627\u0644\u064A \u0639\u0628\u0631 {{code}}",
  "avl.circuit.step": "\u0627\u0644\u062E\u0637\u0648\u0629 {{n}} / {{total}}",
  "avl.circuit.stack": "\u0627\u0644\u0645\u0643\u062F\u0633",
  "avl.glyph.application": "\u062A\u0637\u0628\u064A\u0642",
  "avl.glyph.orbital": "\u0645\u062F\u0627\u0631",
  "avl.glyph.entity": "\u0643\u064A\u0627\u0646",
  "avl.glyph.trait": "\u0633\u0645\u0629",
  "avl.glyph.page": "\u0635\u0641\u062D\u0629",
  "avl.glyph.state": "\u062D\u0627\u0644\u0629",
  "avl.glyph.transition": "\u0627\u0646\u062A\u0642\u0627\u0644",
  "avl.glyph.event": "\u062D\u062F\u062B",
  "avl.glyph.guard": "\u0634\u0631\u0637",
  "avl.glyph.effect": "\u062A\u0623\u062B\u064A\u0631",
  "avl.glyph.field": "\u062D\u0642\u0644",
  "avl.glyph.fieldType": "\u0646\u0648\u0639 \u0627\u0644\u062D\u0642\u0644",
  "avl.glyph.binding": "\u0631\u0628\u0637",
  "avl.glyph.bindingRef": "\u0645\u0631\u062C\u0639 \u0631\u0628\u0637",
  "avl.glyph.persistence": "\u0627\u0644\u062D\u0641\u0638",
  "avl.glyph.operator": "\u0639\u0627\u0645\u0644",
  "avl.glyph.sexpr": "\u062A\u0639\u0628\u064A\u0631",
  "avl.glyph.literal": "\u0642\u064A\u0645\u0629 \u062B\u0627\u0628\u062A\u0629",
  "orbPreview.previewBadge": "\u0645\u0639\u0627\u064A\u0646\u0629",
  "orbPreview.doubleClickToOpen": "\u0627\u0646\u0642\u0631 \u0646\u0642\u0631\u064B\u0627 \u0645\u0632\u062F\u0648\u062C\u064B\u0627 \u0644\u0644\u0641\u062A\u062D",
  "orbPreview.dropToAddAndOpen": "\u0623\u0641\u0644\u062A \u0644\u0644\u0625\u0636\u0627\u0641\u0629 \u0648\u0627\u0644\u0641\u062A\u062D",
  "orbPreview.hasProblems": "\u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0645\u062F\u0627\u0631 \u0645\u0634\u0643\u0644\u0627\u062A \u2014 \u0627\u0641\u062A\u062D \u0627\u0644\u062A\u0646\u0628\u064A\u0647 \u0641\u064A \u0623\u0639\u0644\u0649 \u0627\u0644\u064A\u0645\u064A\u0646 \u0644\u0625\u0635\u0644\u0627\u062D\u0647\u0627",
  "orbPreview.dispatching": "\u0627\u0644\u0645\u0646\u0633\u0650\u0651\u0642 \u064A\u064F\u0631\u0633\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0645\u062F\u0627\u0631",
  "orbPreview.noPreview": "\u0644\u0627 \u062A\u062A\u0648\u0641\u0631 \u0645\u0639\u0627\u064A\u0646\u0629",
  "detailView.noTransitionData": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0646\u062A\u0642\u0627\u0644",
  "orbInspector.required": "\u0645\u0637\u0644\u0648\u0628",
  "orbInspector.addField": "\u0625\u0636\u0627\u0641\u0629 \u062D\u0642\u0644",
  "orbInspector.serviceMode": "\u0648\u0636\u0639 \u0627\u0644\u062E\u062F\u0645\u0629",
  "orbInspector.standalone": "\u0645\u0633\u062A\u0642\u0644",
  "orbInspector.embedded": "\u0645\u064F\u0636\u0645\u064E\u0651\u0646",
  "orbInspector.rendersOwnUi": "\u064A\u0639\u0631\u0636 \u0648\u0627\u062C\u0647\u062A\u0647 \u0627\u0644\u062E\u0627\u0635\u0629",
  "orbInspector.headless": "\u0628\u0644\u0627 \u0648\u0627\u062C\u0647\u0629\u060C \u0645\u0648\u0635\u0648\u0644 \u0628\u0633\u0644\u0648\u0643\u064A\u0627\u062A \u0623\u062E\u0631\u0649",
  "orbInspector.addEffect": "\u0625\u0636\u0627\u0641\u0629 \u062A\u0623\u062B\u064A\u0631",
  "orbInspector.guardExpression": "\u062A\u0639\u0628\u064A\u0631 \u0627\u0644\u062D\u0627\u0631\u0633",
  "orbInspector.selectPatternForStyles": "\u062D\u062F\u062F \u0646\u0645\u0637\u064B\u0627 \u0644\u0639\u0631\u0636 \u0631\u0645\u0648\u0632 \u0646\u0645\u0637\u0647.",
  "orbInspector.tokens": "\u0627\u0644\u0631\u0645\u0648\u0632",
  "orbInspector.noTokenContract": "\u0644\u0645 \u064A\u064F\u0639\u0644\u064E\u0646 \u0623\u064A \u0639\u0642\u062F \u0631\u0645\u0648\u0632 \u0644\u0647\u0630\u0627 \u0627\u0644\u0646\u0645\u0637.",
  "orbInspector.variant": "\u0627\u0644\u0646\u0648\u0639",
  "orbInspector.size": "\u0627\u0644\u062D\u062C\u0645",
  "orbInspector.statesCount": "{{count}} \u062D\u0627\u0644\u0627\u062A",
  "orbInspector.onEntity": " \u0639\u0644\u0649 {{entity}}",
  "orbInspector.projectThemeTokens": "\u0631\u0645\u0648\u0632 \u0633\u0645\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
  "orbInspector.tokenGroup.colors": "\u0627\u0644\u0623\u0644\u0648\u0627\u0646",
  "orbInspector.tokenGroup.radii": "\u0623\u0646\u0635\u0627\u0641 \u0627\u0644\u0623\u0642\u0637\u0627\u0631",
  "orbInspector.tokenGroup.spacing": "\u0627\u0644\u062A\u0628\u0627\u0639\u062F",
  "orbInspector.tokenGroup.shadows": "\u0627\u0644\u0638\u0644\u0627\u0644",
  "orbInspector.tab.inspector": "\u0627\u0644\u0645\u064F\u0641\u062A\u0650\u0651\u0634",
  "orbInspector.tab.styles": "\u0627\u0644\u0623\u0646\u0645\u0627\u0637",
  "orbInspector.tab.design": "\u0627\u0644\u062A\u0635\u0645\u064A\u0645",
  "orbInspector.tab.prototype": "\u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0623\u0648\u0644\u064A",
  "orbInspector.tab.code": "\u0627\u0644\u0643\u0648\u062F",
  "canvas.overview": "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
  "canvas.modulesCount": "{{count}} \u0648\u062D\u062F\u0627\u062A",
  "canvas.switchToView": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0639\u0631\u0636 {{label}}",
  "lawReference.viewFullText": "\u0639\u0631\u0636 \u0627\u0644\u0646\u0635 \u0627\u0644\u0643\u0627\u0645\u0644 \u0644\u0644\u0642\u0627\u0646\u0648\u0646",
  "statCard.defaultLabel": "\u0625\u062D\u0635\u0627\u0626\u064A\u0629",
  "statCard.vsLastPeriod": "\u0645\u0642\u0627\u0631\u0646\u0629 \u0628\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "mediaGallery.upload": "\u0631\u0641\u0639",
  "mediaGallery.noMediaDescription": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u0648\u0633\u0627\u0626\u0637 \u0644\u0639\u0631\u0636\u0647\u0627.",
  "pagination.jumpPlaceholder": "\u0635\u0641\u062D\u0629",
  "table.selectRow": "\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0635\u0641 {{id}}",
  "card.selectItem": "\u062A\u062D\u062F\u064A\u062F {{item}}",
  "card.itemFallback": "\u0639\u0646\u0635\u0631",
  "fileTree.noFiles": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A",
  "masterDetail.selectItem": "\u062D\u062F\u062F \u0639\u0646\u0635\u0631\u064B\u0627 \u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
  "empty.createFirst": "\u0623\u0646\u0634\u0626 \u0623\u0648\u0644 \u0639\u0646\u0635\u0631 \u0644\u0643 \u0644\u0644\u0628\u062F\u0621.",
  "upload.dropOrBrowse": "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627 \u0623\u0648 \u0627\u0646\u0642\u0631 \u0644\u0644\u0627\u0633\u062A\u0639\u0631\u0627\u0636",
  "upload.dropFilesHere": "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627",
  "upload.accepted": "\u0627\u0644\u0645\u0642\u0628\u0648\u0644: {{accept}}",
  "upload.maxSize": "\u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0623\u0642\u0635\u0649: {{size}}",
  "upload.maxFiles": "\u062D\u062A\u0649 {{count}} \u0645\u0644\u0641\u0627\u062A",
  "upload.error.maxFiles": "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 {{count}} \u0645\u0644\u0641\u0627\u062A",
  "upload.error.invalidType": "\u0646\u0648\u0639 \u0645\u0644\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D: {{name}}",
  "upload.error.tooLarge": "\u0627\u0644\u0645\u0644\u0641 \u0643\u0628\u064A\u0631 \u062C\u062F\u064B\u0627: {{name}} (\u0627\u0644\u0623\u0642\u0635\u0649 {{size}})",
  "optionConstraint.requiredOne": "\u0645\u0637\u0644\u0648\u0628\u060C \u0627\u062E\u062A\u0631 1",
  "optionConstraint.optionalOne": "\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u060C \u0627\u062E\u062A\u0631 \u062D\u062A\u0649 1",
  "optionConstraint.pickExactly": "\u0627\u062E\u062A\u0631 \u0628\u0627\u0644\u0636\u0628\u0637 {{count}}",
  "optionConstraint.pickRange": "\u0627\u062E\u062A\u0631 {{min}}-{{max}}",
  "optionConstraint.pickAtLeast": "\u0627\u062E\u062A\u0631 {{count}} \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  "optionConstraint.pickUpTo": "\u0627\u062E\u062A\u0631 \u062D\u062A\u0649 {{count}}",
  "optionConstraint.optional": "\u0627\u062E\u062A\u064A\u0627\u0631\u064A",
  "optionConstraint.outOfStock": "\u0646\u0641\u062F \u0645\u0646 \u0627\u0644\u0645\u062E\u0632\u0648\u0646",
  "optionConstraint.error.pickOne": "\u0627\u062E\u062A\u0631 \u062E\u064A\u0627\u0631\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627",
  "optionConstraint.error.pickOnlyOne": "\u0627\u062E\u062A\u0631 \u062E\u064A\u0627\u0631\u064B\u0627 \u0648\u0627\u062D\u062F\u064B\u0627 \u0641\u0642\u0637",
  "optionConstraint.error.pickMore": "\u0627\u062E\u062A\u0631 {{count}} \u0625\u0636\u0627\u0641\u064A\u0629 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  "optionConstraint.error.removeOptions": "\u0623\u0632\u0644 {{count}} \u062E\u064A\u0627\u0631\u0627\u062A",
  "stateMachine.pinned": "\u0645\u062B\u0628\u0651\u062A",
  "stateMachine.eventCount": "{{count}} \u0623\u062D\u062F\u0627\u062B",
  "stateMachine.externalEffects": "\u062A\u0623\u062B\u064A\u0631\u0627\u062A \u062E\u0627\u0631\u062C\u064A\u0629",
  "stateMachine.legend.initial": "\u0627\u0628\u062A\u062F\u0627\u0626\u064A",
  "stateMachine.legend.final": "\u0646\u0647\u0627\u0626\u064A",
  "stateMachine.legend.state": "\u062D\u0627\u0644\u0629",
  "stateMachine.legend.multiEvent": "\u0645\u062A\u0639\u062F\u062F \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "common.selected": "\u0645\u062D\u062F\u062F",
  "common.showMore": "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F",
  "common.showLess": "\u0639\u0631\u0636 \u0623\u0642\u0644",
  "common.noResults": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0646\u062A\u0627\u0626\u062C",
  "relationSelect.selectPlaceholder": "\u0627\u062E\u062A\u0631...",
  "battle.cancel": "\u0625\u0644\u063A\u0627\u0621",
  "battle.defeat": "\u0647\u0632\u064A\u0645\u0629",
  "battle.endTurn": "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062F\u0648\u0631",
  "battle.playAgain": "\u0627\u0644\u0644\u0639\u0628 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "battle.turnsPlayed": "\u0627\u0644\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u0645\u0644\u0639\u0648\u0628\u0629",
  "battle.victory": "\u0627\u0646\u062A\u0635\u0627\u0631",
  "builder.allPlaced": "\u062A\u0645 \u0648\u0636\u0639 \u0627\u0644\u0643\u0644",
  "builder.blueprint": "\u0645\u062E\u0637\u0637",
  "builder.build": "\u0628\u0646\u0627\u0621",
  "builder.components": "\u0645\u0643\u0648\u0651\u0646\u0627\u062A",
  "builder.empty": "\u0641\u0627\u0631\u063A",
  "builder.reset": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646",
  "builder.success": "\u0646\u062C\u0627\u062D",
  "classifier.allCorrect": "\u0643\u0644\u0647\u0627 \u0635\u062D\u064A\u062D\u0629!",
  "classifier.check": "\u062A\u062D\u0642\u0642",
  "classifier.correct": "\u0635\u062D\u064A\u062D",
  "classifier.itemsToSort": "\u0639\u0646\u0627\u0635\u0631 \u0644\u0644\u0641\u0631\u0632",
  "classifier.reset": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646",
  "common.error": "\u062E\u0637\u0623",
  "debugger.allFound": "\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0643\u0644 \u0627\u0644\u0623\u062E\u0637\u0627\u0621!",
  "debugger.bugsFound": "\u0623\u062E\u0637\u0627\u0621 \u0645\u064F\u0639\u062B\u064E\u0631\u0629 \u0639\u0644\u064A\u0647\u0627",
  "debugger.findBugs": "\u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 {{count}} \u0623\u062E\u0637\u0627\u0621",
  "debugger.reset": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646",
  "debugger.submit": "\u0625\u0631\u0633\u0627\u0644",
  "error.genericLoad": "\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
  "error.loadingData": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  "eventHandler.addRule": "\u0625\u0636\u0627\u0641\u0629 \u0642\u0627\u0639\u062F\u0629",
  "eventHandler.chainComplete": "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u0633\u0644\u0633\u0644!",
  "eventHandler.clickObject": "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0643\u0627\u0626\u0646\u0627\u062A",
  "eventHandler.eventLog": "\u0633\u062C\u0644 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "eventHandler.heardEvent": "{{object}} \u0627\u0633\u062A\u0642\u0628\u0644 {{event}} \u2192 {{action}}",
  "eventHandler.noEvents": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u062D\u062F\u0627\u062B \u0628\u0639\u062F",
  "eventHandler.noListeners": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0633\u062A\u0645\u0639\u0648\u0646 \u0644\u0640 {{event}}",
  "eventHandler.rules": "{{count}}/{{max}} \u0642\u0648\u0627\u0639\u062F",
  "eventHandler.simulationStarted": "\u0645\u062D\u0627\u0643\u0627\u0629: {{events}}",
  "eventHandler.state": "\u0627\u0644\u062D\u0627\u0644\u0629",
  "eventHandler.then": "\u062B\u0645",
  "eventHandler.when": "\u0639\u0646\u062F\u0645\u0627",
  "game.goal": "\u0627\u0644\u0647\u062F\u0641",
  "game.hint": "\u062A\u0644\u0645\u064A\u062D",
  "game.play": "\u062A\u0634\u063A\u064A\u0644",
  "game.reset": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646",
  "game.runTests": "\u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A",
  "negotiator.chooseAction": "\u0627\u062E\u062A\u0631 \u0625\u062C\u0631\u0627\u0621\u064B",
  "negotiator.failed": "\u0641\u0634\u0644 \u0627\u0644\u062A\u0641\u0627\u0648\u0636",
  "negotiator.finalScore": "\u0627\u0644\u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629",
  "negotiator.history": "\u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  "negotiator.opponent": "\u0627\u0644\u062E\u0635\u0645",
  "negotiator.playAgain": "\u0627\u0644\u0644\u0639\u0628 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "negotiator.round": "\u0627\u0644\u062C\u0648\u0644\u0629 {{current}} \u0645\u0646 {{total}}",
  "negotiator.success": "\u0646\u062C\u062D \u0627\u0644\u062A\u0641\u0627\u0648\u0636",
  "negotiator.target": "\u0627\u0644\u0647\u062F\u0641",
  "negotiator.you": "\u0623\u0646\u062A",
  "platformer.level": "\u0627\u0644\u0645\u0633\u062A\u0648\u0649",
  "platformer.lost": "\u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0644\u0639\u0628\u0629",
  "platformer.nextLevel": "\u0627\u0644\u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u062A\u0627\u0644\u064A",
  "platformer.noLives": "\u0644\u0645 \u062A\u062A\u0628\u0642\u064E \u0623\u0631\u0648\u0627\u062D",
  "platformer.playAgain": "\u0627\u0644\u0644\u0639\u0628 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "platformer.score": "\u0627\u0644\u0646\u0642\u0627\u0637",
  "platformer.won": "\u0644\u0642\u062F \u0641\u0632\u062A!",
  "puzzle.tryAgainButton": "\u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "roguelike.atk": "\u0647\u062C\u0648\u0645",
  "roguelike.cleared": "\u062A\u0645 \u062A\u0637\u0647\u064A\u0631 \u0627\u0644\u0632\u0646\u0632\u0627\u0646\u0629! \u0627\u0644\u0639\u0645\u0642 \u0627\u0644\u0645\u064F\u062D\u0642\u0642: {{depth}}",
  "roguelike.defeat": "\u0647\u064F\u0632\u0645\u062A!",
  "roguelike.depth": "\u0627\u0644\u0639\u0645\u0642",
  "roguelike.enemy": "\u0639\u062F\u0648",
  "roguelike.hp": "\u0635\u062D\u0629",
  "roguelike.phase": "\u0627\u0644\u0645\u0631\u062D\u0644\u0629",
  "roguelike.playAgain": "\u0627\u0644\u0644\u0639\u0628 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "roguelike.player": "\u0628\u0637\u0644",
  "roguelike.victory": "\u0627\u0646\u062A\u0635\u0627\u0631!",
  "sequencer.actions": "\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
  "sequencer.dragActions": "\u0627\u0633\u062D\u0628 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0647\u0646\u0627",
  "sequencer.levelComplete": "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u0645\u0633\u062A\u0648\u0649!",
  "sequencer.yourSequence": "\u062A\u0633\u0644\u0633\u0644\u0643",
  "simulator.correct": "\u0635\u062D\u064A\u062D",
  "simulator.incorrect": "\u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "simulator.parameters": "\u0645\u0639\u0627\u0645\u0644\u0627\u062A",
  "simulator.reset": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646",
  "simulator.simulate": "\u0645\u062D\u0627\u0643\u0627\u0629",
  "simulator.target": "\u0627\u0644\u0647\u062F\u0641",
  "stateArchitect.addTransition": "\u0625\u0636\u0627\u0641\u0629 \u0627\u0646\u062A\u0642\u0627\u0644 \u0645\u0646 {{state}}",
  "stateArchitect.addTransitionPrompt": "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u062A\u0647\u062F\u0641\u0629",
  "stateArchitect.allPassed": "\u0646\u062C\u062D\u062A \u062C\u0645\u064A\u0639 \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A!",
  "stateArchitect.clickTarget": "\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u062D\u0627\u0644\u0629 \u0645\u0633\u062A\u0647\u062F\u0641\u0629 (\u0627\u0644\u062D\u0627\u0644\u064A\u0629: {{state}})",
  "stateArchitect.gotState": "\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u0629: {{state}}",
  "stateArchitect.graph": "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A",
  "stateArchitect.hideJson": "\u0625\u062E\u0641\u0627\u0621 JSON",
  "stateArchitect.showJson": "\u0625\u0638\u0647\u0627\u0631 JSON",
  "stateArchitect.testResults": "\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631\u0627\u062A",
  "stateArchitect.transitions": "{{count}} \u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "stateArchitect.variables": "\u0645\u062A\u063A\u064A\u0631\u0627\u062A: {{name}}",
  "stateArchitect.viewCode": "\u0639\u0631\u0636 \u0627\u0644\u0643\u0648\u062F",
  "td.defeat": "\u0647\u0632\u064A\u0645\u0629",
  "td.gold": "\u0630\u0647\u0628",
  "td.lives": "\u0623\u0631\u0648\u0627\u062D",
  "td.livesReachedZero": "\u062A\u0645 \u0627\u062C\u062A\u064A\u0627\u062D \u0642\u0627\u0639\u062F\u062A\u0643",
  "td.placeTower": "\u0636\u0639 \u0628\u0631\u062C\u064B\u0627",
  "td.playAgain": "\u0627\u0644\u0644\u0639\u0628 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
  "td.startWave": "\u0628\u062F\u0621 \u0627\u0644\u0645\u0648\u062C\u0629",
  "td.survivedAllWaves": "\u0646\u062C\u0648\u062A \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u062C\u0627\u062A!",
  "td.victory": "\u0627\u0646\u062A\u0635\u0627\u0631!",
  "td.wave": "\u0645\u0648\u062C\u0629",
  "td.waveInProgress": "\u0627\u0644\u0645\u0648\u062C\u0629 \u0642\u064A\u062F \u0627\u0644\u062A\u0642\u062F\u0645\u2026",
  "documentDetails.title": "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
  "documentPanel.untitled": "\u0628\u062F\u0648\u0646 \u0639\u0646\u0648\u0627\u0646",
  "documentPanel.edit": "\u062A\u062D\u0631\u064A\u0631",
  "documentPanel.done": "\u062A\u0645",
  "documentPanel.autosaveHint": "\u064A\u064F\u062D\u0641\u0638 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628\u0629",
  "documentPanel.placeholder": "\u0627\u0628\u062F\u0623 \u0627\u0644\u0643\u062A\u0627\u0628\u0629\u2026",
  "richTextEditor.editorToolbar": "\u0634\u0631\u064A\u0637 \u0627\u0644\u062A\u0646\u0633\u064A\u0642",
  "richTextEditor.editorSurface": "\u0645\u062D\u0631\u0631 \u0627\u0644\u0646\u0635\u0648\u0635",
  "richTextEditor.bold": "\u063A\u0627\u0645\u0642",
  "richTextEditor.italic": "\u0645\u0627\u0626\u0644",
  "richTextEditor.underline": "\u062A\u0633\u0637\u064A\u0631",
  "richTextEditor.strikethrough": "\u064A\u062A\u0648\u0633\u0637\u0647 \u062E\u0637",
  "richTextEditor.heading1": "\u0639\u0646\u0648\u0627\u0646 1",
  "richTextEditor.heading2": "\u0639\u0646\u0648\u0627\u0646 2",
  "richTextEditor.heading3": "\u0639\u0646\u0648\u0627\u0646 3",
  "richTextEditor.bulletList": "\u0642\u0627\u0626\u0645\u0629 \u0646\u0642\u0637\u064A\u0629",
  "richTextEditor.numberedList": "\u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u0642\u0645\u0629",
  "richTextEditor.quote": "\u0627\u0642\u062A\u0628\u0627\u0633",
  "richTextEditor.code": "\u0634\u064A\u0641\u0631\u0629",
  "richTextEditor.link": "\u0625\u0636\u0627\u0641\u0629 \u0631\u0627\u0628\u0637",
  "richTextEditor.removeLink": "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0631\u0627\u0628\u0637",
  "richTextEditor.divider": "\u0641\u0627\u0635\u0644",
  "richTextEditor.linkPrompt": "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637",
  "richTextEditor.image": "\u0625\u062F\u0631\u0627\u062C \u0635\u0648\u0631\u0629",
  "richTextEditor.imagePrompt": "\u0631\u0627\u0628\u0637 \u0627\u0644\u0635\u0648\u0631\u0629",
  "richTextEditor.placeholder": "\u0627\u0628\u062F\u0623 \u0627\u0644\u0643\u062A\u0627\u0628\u0629\u2026",
  "form.imageUrlFallback": "\u2026\u0623\u0648 \u0627\u0644\u0635\u0642 \u0631\u0627\u0628\u0637 \u0627\u0644\u0635\u0648\u0631\u0629",
  "mermaid.unrenderable": "\u062A\u0639\u0630\u0631 \u0639\u0631\u0636 \u0647\u0630\u0627 \u0627\u0644\u0645\u062E\u0637\u0637. \u064A\u0638\u0647\u0631 \u0645\u0635\u062F\u0631\u0647 \u0623\u062F\u0646\u0627\u0647.",
  "orbPreview.play": "\u062A\u0634\u063A\u064A\u0644 \u2014 \u062A\u0641\u0627\u0639\u0644 \u0645\u0639 \u0647\u0630\u0647 \u0627\u0644\u0634\u0627\u0634\u0629",
  "orbPreview.pause": "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A \u2014 \u062A\u062D\u062F\u064A\u062F \u0648\u062A\u0639\u062F\u064A\u0644",
  "inlineText.boundValue": "\u0647\u0630\u0627 \u0627\u0644\u0646\u0635 \u064A\u0623\u062A\u064A \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u060C \u0644\u0630\u0627 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u062D\u0631\u064A\u0631\u0647 \u0647\u0646\u0627.",
  "designOverlay.layoutVertical": "\u062A\u062E\u0637\u064A\u0637 \u0639\u0645\u0648\u062F\u064A",
  "designOverlay.layoutHorizontal": "\u062A\u062E\u0637\u064A\u0637 \u0623\u0641\u0642\u064A",
  "designOverlay.spaceBetween": "\u062A\u0648\u0632\u064A\u0639 \u0628\u0627\u0644\u062A\u0633\u0627\u0648\u064A",
  "designOverlay.wrap": "\u0627\u0644\u062A\u0641\u0627\u0641",
  "designOverlay.align": "\u0645\u062D\u0627\u0630\u0627\u0629 {{row}} {{column}}",
  "designOverlay.top": "\u0623\u0639\u0644\u0649",
  "designOverlay.middle": "\u0648\u0633\u0637",
  "designOverlay.bottom": "\u0623\u0633\u0641\u0644",
  "designOverlay.left": "\u064A\u0633\u0627\u0631",
  "designOverlay.center": "\u0645\u0646\u062A\u0635\u0641",
  "designOverlay.right": "\u064A\u0645\u064A\u0646",
  "orbInspector.appearance": "\u0627\u0644\u0645\u0638\u0647\u0631",
  "orbInspector.editScope": "\u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0639\u062F\u064A\u0644",
  "orbInspector.scopeLocal": "\u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631",
  "orbInspector.scopeGlobal": "\u0627\u0644\u0633\u0645\u0629",
  "orbInspector.fill": "\u0627\u0644\u062A\u0639\u0628\u0626\u0629",
  "orbInspector.textColor": "\u0627\u0644\u0646\u0635",
  "orbInspector.borderColor": "\u0627\u0644\u062D\u062F",
  "orbInspector.radius": "\u0627\u0644\u0627\u0633\u062A\u062F\u0627\u0631\u0629",
  "orbInspector.width": "\u0627\u0644\u0639\u0631\u0636",
  "orbInspector.height": "\u0627\u0644\u0627\u0631\u062A\u0641\u0627\u0639",
  "orbInspector.minWidth": "\u0623\u062F\u0646\u0649 \u0639\u0631\u0636",
  "orbInspector.maxWidth": "\u0623\u0642\u0635\u0649 \u0639\u0631\u0636",
  "orbInspector.minHeight": "\u0623\u062F\u0646\u0649 \u0627\u0631\u062A\u0641\u0627\u0639",
  "orbInspector.maxHeight": "\u0623\u0642\u0635\u0649 \u0627\u0631\u062A\u0641\u0627\u0639",
  "orbInspector.limitNone": "\u0628\u0644\u0627",
  "orbInspector.absolute": "\u0645\u0648\u0636\u0639 \u0645\u0637\u0644\u0642",
  "orbInspector.constraintHorizontal": "\u0623\u0641\u0642\u064A",
  "orbInspector.constraintVertical": "\u0639\u0645\u0648\u062F\u064A",
  "orbInspector.pinLeft": "\u064A\u0633\u0627\u0631",
  "orbInspector.pinRight": "\u064A\u0645\u064A\u0646",
  "orbInspector.pinLeftRight": "\u064A\u0633\u0627\u0631 \u0648\u064A\u0645\u064A\u0646",
  "orbInspector.pinTop": "\u0623\u0639\u0644\u0649",
  "orbInspector.pinBottom": "\u0623\u0633\u0641\u0644",
  "orbInspector.pinTopBottom": "\u0623\u0639\u0644\u0649 \u0648\u0623\u0633\u0641\u0644",
  "orbInspector.pinCenter": "\u0648\u0633\u0637",
  "orbInspector.pinScale": "\u062A\u0646\u0627\u0633\u0628",
  "orbInspector.auto": "\u062A\u0644\u0642\u0627\u0626\u064A",
  "orbInspector.notThemeBacked": "\u0644\u064A\u0633\u062A \u0642\u064A\u0645\u0629 \u0645\u0646 \u0627\u0644\u0633\u0645\u0629 \u2014 \u0639\u064A\u0651\u0646\u0647\u0627 \u0639\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631",
  "orbInspector.globalAffects": "\u064A\u063A\u064A\u0651\u0631 {{token}} \u0641\u064A \u0643\u0644 \u0645\u0643\u0627\u0646 \u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0641\u064A\u0647",
  "orbInspector.classNameIsBinding": "\u0641\u0626\u0627\u062A \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631 \u062A\u0623\u062A\u064A \u0645\u0646 \u0631\u0628\u0637\u060C \u0644\u0630\u0627 \u0644\u0627 \u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644\u0647\u0627 \u0647\u0646\u0627",
  "orbInspector.sizingHug": "\u0627\u062D\u062A\u0648\u0627\u0621 \u0627\u0644\u0645\u062D\u062A\u0648\u0649",
  "orbInspector.sizingFill": "\u0645\u0644\u0621 \u0627\u0644\u062D\u0627\u0648\u064A\u0629",
  "orbInspector.gap": "\u0627\u0644\u0641\u062C\u0648\u0629",
  "orbInspector.padding": "\u0627\u0644\u062D\u0634\u0648",
  "orbInspector.mixed": "\u0645\u062E\u062A\u0644\u0637",
  "orbInspector.custom": "\u0645\u062E\u0635\u0635",
  "orbInspector.customRefused": "\u0642\u064A\u0645\u0629 \u0645\u062E\u0635\u0635\u0629 \u0648\u0627\u062D\u062F\u0629\u060C \u0645\u062B\u0644 w-[243px] \u0623\u0648 bg-[#e14b2a].",
  "inlineText.fixedValue": "\u200F{{behavior}} \u064A\u062D\u062F\u062F \u0647\u0630\u0627 \u0627\u0644\u0646\u0635 \u2014 \u063A\u064A\u0651\u0631\u0647 \u0645\u0646 \u0625\u0639\u062F\u0627\u062F\u0627\u062A\u0647.",
  "inlineText.loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0645\u0627 \u064A\u0645\u0643\u0646\u0643 \u062A\u063A\u064A\u064A\u0631\u0647 \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u0639\u0646\u0635\u0631.",
  "orbPreview.partOf": "\u062C\u0632\u0621 \u0645\u0646 {{behavior}}",
  "avl.propBound": "\u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A: {{binding}}",
  "avl.propFixed": "\u064A\u062D\u062F\u062F\u0647 {{behavior}}",
  "avl.propChecking": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026",
  "avl.moreProps": "\u0627\u0644\u0645\u0632\u064A\u062F ({{count}})",
  "knobField.addAValue": "\u0623\u0636\u0641 \u0642\u064A\u0645\u0629\u2026",
  "knobField.addField": "\u0625\u0636\u0627\u0641\u0629 \u062D\u0642\u0644",
  "knobField.addItem": "\u0625\u0636\u0627\u0641\u0629 {{label}}",
  "knobField.addOwnField": "\u0623\u0636\u0641 \u062D\u0642\u0644\u0643 \u0627\u0644\u062E\u0627\u0635",
  "knobField.entityFields": "\u062D\u0642\u0648\u0644 \u0627\u0644\u0643\u064A\u0627\u0646",
  "knobField.fieldNamePlaceholder": "\u0627\u0633\u0645 \u0627\u0644\u062D\u0642\u0644",
  "knobField.items": "\u0627\u0644\u0639\u0646\u0627\u0635\u0631",
  "knobField.missingItemSchema": "\u0645\u062E\u0637\u0637 \u0627\u0644\u0639\u0646\u0635\u0631 \u0645\u0641\u0642\u0648\u062F \u2014 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636 \u0645\u062D\u0631\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0646\u0638\u0645\u0629.",
  "knobField.missingObjectSchema": "\u0645\u062E\u0637\u0637 \u0627\u0644\u0643\u0627\u0626\u0646 \u0645\u0641\u0642\u0648\u062F \u2014 \u0644\u0627 \u064A\u0645\u0643\u0646 \u0639\u0631\u0636 \u0627\u0644\u0646\u0645\u0648\u0630\u062C \u0627\u0644\u0645\u0646\u0638\u0645.",
  "knobField.number": "\u0631\u0642\u0645",
  "knobField.other": "\u0623\u062E\u0631\u0649...",
  "knobField.removeItem": "\u0625\u0632\u0627\u0644\u0629",
  "knobField.specifyPlaceholder": "\u062D\u062F\u062F...",
  "knobField.yourAnswer": "\u0625\u062C\u0627\u0628\u062A\u0643\u2026",
  "avl.settings": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
  "avl.settingsOf": "\u0625\u0639\u062F\u0627\u062F\u0627\u062A {{behavior}}",
  "canvas.liveState": "\u0645\u0628\u0627\u0634\u0631",
  "canvas.verifyTransition": "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644",
  "canvas.verifyTrait": "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0633\u0645\u0629 (\u0634\u063A\u0651\u0644 \u0645\u0633\u0627\u0631\u0647\u0627)",
  "canvas.verifyPause": "\u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0624\u0642\u062A\u0627\u064B",
  "canvas.verifyStop": "\u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062A\u062D\u0642\u0642",
  "canvas.verdict.pass": "\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u0642",
  "canvas.verdict.fail": "\u0641\u0634\u0644",
  "canvas.verdict.stale": "\u062A\u063A\u064A\u0651\u0631 \u0645\u0646\u0630 \u0627\u0644\u062A\u062D\u0642\u0642",
  "canvas.verdict.running": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642",
  "canvas.stateOf": "\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u0639\u0631\u0648\u0636\u0629 \u0641\u064A {{orbital}}",
  "canvas.previousOrbital": "\u0627\u0644\u0645\u062F\u0627\u0631 \u0627\u0644\u0633\u0627\u0628\u0642 (Shift+Tab)",
  "canvas.nextOrbital": "\u0627\u0644\u0645\u062F\u0627\u0631 \u0627\u0644\u062A\u0627\u0644\u064A (Tab)",
  "canvas.focusedOrbital": "\u0627\u0644\u0645\u062F\u0627\u0631 \u0627\u0644\u0645\u062D\u062F\u062F",
  "canvas.scopeLocal": "\u062A\u0631\u0643\u064A\u0632",
  "canvas.scopeWorld": "\u0627\u0644\u0643\u0644",
  "canvas.scopeLocalHint": "\u0639\u0631\u0636 \u0627\u0644\u0645\u062F\u0627\u0631 \u0627\u0644\u0645\u062D\u062F\u062F \u0641\u0642\u0637",
  "canvas.scopeWorldHint": "\u0639\u0631\u0636 \u0643\u0644 \u0627\u0644\u0645\u062F\u0627\u0631\u0627\u062A",
  "canvas.screenSize": "\u062D\u062C\u0645 \u0627\u0644\u0634\u0627\u0634\u0629",
  "dockLayout.collapse.sidebar": "\u0637\u064A \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629",
  "dockLayout.expand.sidebar": "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u062C\u0627\u0646\u0628\u064A\u0629",
  "dockLayout.collapse.secondary-sidebar": "\u0637\u064A \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u064A\u0645\u0646\u0649",
  "dockLayout.expand.secondary-sidebar": "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u064A\u0645\u0646\u0649",
  "dockLayout.collapse.bottom-panel": "\u0637\u064A \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u0633\u0641\u0644\u064A\u0629",
  "dockLayout.expand.bottom-panel": "\u062A\u0648\u0633\u064A\u0639 \u0627\u0644\u0644\u0648\u062D\u0629 \u0627\u0644\u0633\u0641\u0644\u064A\u0629",
  "dockLayout.openMenu": "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  "dockLayout.menu": "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  "dockLayout.backToMenu": "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0642\u0627\u0626\u0645\u0629",
  "commitRow.kind.user": "\u062D\u0641\u0638\u0643",
  "commitRow.kind.agent": "\u062A\u063A\u064A\u064A\u0631 \u0645\u0646 \u0627\u0644\u0648\u0643\u064A\u0644",
  "commitRow.kind.restore": "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
  "commitRow.kind.undo": "\u062A\u0631\u0627\u062C\u0639",
  "commitRow.current": "\u0627\u0644\u062D\u0627\u0644\u064A\u0629",
  "commitRow.restore": "\u0627\u0633\u062A\u0639\u0627\u062F\u0629",
  "changeList.added": "\u0623\u064F\u0636\u064A\u0641",
  "changeList.modified": "\u0639\u064F\u062F\u0650\u0651\u0644",
  "changeList.removed": "\u0623\u064F\u0632\u064A\u0644",
  "changeList.before": "\u0642\u0628\u0644",
  "changeList.after": "\u0628\u0639\u062F",
  "changeList.inspect": "\u0641\u062D\u0635",
  "changeList.empty": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u062E\u0629.",
  "commitRow.kind.redo": "\u0625\u0639\u0627\u062F\u0629",
  "commitRow.kind.snapshot": "\u0644\u0642\u0637\u0629",
  "codeAssist.thinking": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0641\u0643\u064A\u0631\u2026",
  "codeAssist.findingFixes": "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0625\u0635\u0644\u0627\u062D\u0627\u062A\u2026",
  "codeAssist.suggested": "{{count}} \u0645\u0642\u062A\u0631\u062D",
  "codeAssist.keys": "Tab \u0644\u0644\u0642\u0628\u0648\u0644 \xB7 \u2318/Ctrl+Enter \u0644\u0642\u0628\u0648\u0644 \u0627\u0644\u0643\u0644 \xB7 Esc \u0644\u0644\u0625\u0644\u063A\u0627\u0621",
  "codeAssist.acceptAll": "\u0642\u0628\u0648\u0644 \u0627\u0644\u0643\u0644",
  "codeAssist.suggestFixes": "\u0627\u0642\u062A\u0631\u0627\u062D \u0625\u0635\u0644\u0627\u062D\u0627\u062A \u0644\u0640 {{count}} \u0645\u0634\u0643\u0644\u0629 \xB7 \u2318/Ctrl+.",
  "codeAssist.line": "\u0627\u0644\u0633\u0637\u0631 {{line}}",
  "avl.play.step": "\u062E\u0637\u0648\u0629",
  "avl.play.play": "\u062A\u0634\u063A\u064A\u0644",
  "avl.play.pause": "\u0625\u064A\u0642\u0627\u0641 \u0645\u0624\u0642\u062A",
  "avl.play.stop": "\u0625\u064A\u0642\u0627\u0641",
  "avl.play.payload": "\u0627\u0644\u062D\u0645\u0648\u0644\u0629",
  "avl.play.fired": "\u0646\u064F\u0641\u0650\u0651\u0630",
  "avl.play.blocked": "\u0645\u064F\u0646\u0650\u0639",
  "avl.play.notReached": "\u0644\u0645 \u064A\u064F\u0633\u0644\u0643",
  "avl.play.guardPassed": "\u0646\u062C\u062D \u0627\u0644\u062D\u0627\u0631\u0633",
  "avl.play.guardFailed": "\u0641\u0634\u0644 \u0627\u0644\u062D\u0627\u0631\u0633",
  "avl.play.notPlayed": "\u0644\u0645 \u064A\u064F\u0634\u063A\u064E\u0651\u0644 \u0628\u0639\u062F. \xAB\u062E\u0637\u0648\u0629\xBB \u062A\u0634\u063A\u0651\u0644\u0647 \u0639\u0644\u0649 \u0627\u0644\u0635\u0641 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A.",
  "avl.play.sceneStep": "\u0627\u0644\u062E\u0637\u0648\u0629 {{n}} \u0645\u0646 {{total}}",
  "avl.play.scene": "\u0627\u0644\u0645\u0634\u0647\u062F",
  "avl.play.effectFailed": "\u0641\u0634\u0644",
  "avl.system.counts": "{{traits}} \u0633\u0645\u0627\u062A \xB7 {{pages}} \u0635\u0641\u062D\u0627\u062A \xB7 {{fields}} \u062D\u0642\u0648\u0644",
  "avl.system.exchanges": "\u064A\u062A\u0628\u0627\u062F\u0644 {{events}}",
  "avl.system.openTraits": "\u0641\u062A\u062D \u0627\u0644\u0633\u0645\u0627\u062A",
  "avl.system.openCode": "\u0641\u062A\u062D \u0627\u0644\u0634\u064A\u0641\u0631\u0629",
  "avl.system.preview": "\u0645\u0639\u0627\u064A\u0646\u0629",
  "avl.system.connected": "\u0645\u062A\u0631\u0627\u0628\u0637\u0629 \xB7 {{count}}",
  "avl.system.standalone": "\u0645\u0633\u062A\u0642\u0644\u0629 \xB7 {{count}} \u2014 \u0628\u0644\u0627 \u0623\u062D\u062F\u0627\u062B \u0645\u0639 \u0645\u062F\u0627\u0631\u064A\u0627\u062A \u0623\u062E\u0631\u0649",
  "avl.system.summary": "{{orbitals}} \u0645\u062F\u0627\u0631\u064A\u0627\u062A \xB7 {{wires}} \u0623\u0633\u0644\u0627\u0643",
  "avl.system.search": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0645\u062F\u0627\u0631\u064A \u0623\u0648 \u062D\u062F\u062B",
  "avl.system.wiresOnly": "\u0627\u0644\u0623\u0633\u0644\u0627\u0643 \u0641\u0642\u0637",
  "avl.system.lensEvents": "\u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "avl.system.lensDependencies": "\u0627\u0644\u062A\u0628\u0639\u064A\u0627\u062A",
  "avl.deps.hint": "\u0627\u0646\u0642\u0631 \u0645\u062F\u0627\u0631\u064A\u064B\u0627 \u0623\u0648 \u0633\u0644\u0648\u0643\u064B\u0627 \u0644\u062A\u0631\u0649 \u0645\u0645\u0651\u0627 \u0628\u064F\u0646\u064A \u0648\u0645\u0627 \u064A\u0639\u062A\u0645\u062F \u0639\u0644\u064A\u0647",
  "avl.deps.selected": "{{name}} \xB7 \u0645\u0628\u0646\u064A \u0645\u0646 {{upstream}} \xB7 {{downstream}} \u064A\u0639\u062A\u0645\u062F \u0639\u0644\u064A\u0647",
  "avl.deps.legendUpstream": "\u0627\u0644\u0645\u0646\u0628\u0639 (\u0645\u0628\u0646\u064A \u0645\u0646)",
  "avl.deps.legendDownstream": "\u0627\u0644\u0645\u0635\u0628 (\u064A\u0639\u062A\u0645\u062F \u0639\u0644\u064A\u0647)",
  "avl.deps.column.app": "\u062A\u0637\u0628\u064A\u0642\u0643 \xB7 \u0627\u0644\u0645\u062F\u0627\u0631\u064A\u0627\u062A",
  "avl.deps.column.io": "io \xB7 \u0627\u0644\u062A\u062C\u0633\u064A\u062F\u0627\u062A",
  "avl.deps.column.std": "std \xB7 \u0627\u0644\u0633\u0644\u0648\u0643\u064A\u0627\u062A",
  "avl.deps.column.primitive": "std \xB7 \u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629",
  "avl.deps.column.unknown": "\u062E\u0627\u0631\u062C \u0627\u0644\u0633\u062C\u0644\u0627\u062A",
  "avl.deps.search": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0645\u062F\u0627\u0631\u064A \u0623\u0648 \u0633\u0644\u0648\u0643",
  "avl.flow.lensFlow": "\u0627\u0644\u062A\u062F\u0641\u0642",
  "avl.flow.lensTraits": "\u0627\u0644\u0633\u0645\u0627\u062A",
  "avl.flow.selected": "{{name}} \xB7 {{into}} \u064A\u0637\u0644\u0642\u0647 \xB7 \u064A\u0637\u0644\u0642 {{out}}",
  "avl.flow.summary": "{{traits}} \u0633\u0645\u0629 \u2190 {{own}} \u062E\u0627\u0635\u0629 + {{composed}} \u0645\u0631\u0643\u0651\u0628\u0629 ({{pieces}} \u0642\u0637\u0639\u0629 \u0639\u0631\u0636 \u0645\u0637\u0648\u064A\u0629) \xB7 \u0627\u0646\u0642\u0631 \u0648\u0627\u062D\u062F\u0629 \u0644\u062A\u0631\u0649 \u0645\u0627 \u064A\u0637\u0644\u0642\u0647\u0627",
  "avl.flow.showTraits": "\u0627\u0639\u0631\u0636 \u0633\u0645\u0627\u062A\u0647\u0627",
  "avl.flow.legendInto": "\u064A\u0637\u0644\u0642\u0647",
  "avl.flow.legendOut": "\u064A\u0637\u0644\u0642",
  "avl.flow.showing": "\u0639\u0631\u0636 {{name}} \xB7 {{count}} \u0633\u0645\u0627\u062A",
  "avl.flow.showAll": "\u0627\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
  "avl.deps.column.own": "\u0627\u0644\u0633\u0645\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629",
  "avl.deps.column.client": "\u0627\u0644\u0639\u0645\u0644\u0627\u0621",
  "avl.deps.column.host": "\u0627\u0644\u062E\u0627\u062F\u0645 \u0627\u0644\u0645\u0636\u064A\u0641",
  "avl.deps.column.service": "\u0627\u0644\u062E\u062F\u0645\u0627\u062A",
  "avl.deps.column.store": "\u0645\u062E\u0627\u0632\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A",
  "avl.deps.column.external": "\u0648\u0627\u062C\u0647\u0627\u062A \u062E\u0627\u0631\u062C\u064A\u0629",
  "avl.unit.status.ok": "\u0633\u0644\u064A\u0645",
  "avl.unit.status.degraded": "\u0645\u062A\u0631\u0627\u062C\u0639",
  "avl.unit.status.down": "\u0645\u062A\u0639\u0637\u0644",
  "avl.unit.status.idle": "\u0644\u0627 \u062D\u0631\u0643\u0629",
  "avl.flow.traitsCount": "{{count}} \u0633\u0645\u0627\u062A",
  "avl.flow.piecesCount": "{{count}} \u0642\u0637\u0639 \u0639\u0631\u0636",
  "avl.flow.traitsCountOne": "\u0633\u0645\u0629 \u0648\u0627\u062D\u062F\u0629",
  "avl.flow.piecesCountOne": "\u0642\u0637\u0639\u0629 \u0639\u0631\u0636 \u0648\u0627\u062D\u062F\u0629",
  "gantt.datesReversed": "\u064A\u0646\u062A\u0647\u064A \u0642\u0628\u0644 \u0623\u0646 \u064A\u0628\u062F\u0623 \u2014 \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E",
  "chatBar.askTheAgentAnything": "\u0627\u0633\u0623\u0644 \u0627\u0644\u0648\u0643\u064A\u0644 \u0623\u064A \u0634\u064A\u0621\u2026",
  "canvas.loadingMessage": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644\u2026",
  "chatBar.cancelGeneration": "\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u0648\u0644\u064A\u062F",
  "chatBar.clearSelection": "\u0645\u0633\u062D \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
  "chatBar.editing": "\u062A\u062D\u0631\u064A\u0631",
  "chatBar.pauseTheAgentYouCanEdit": "\u0623\u0648\u0642\u0641 \u0627\u0644\u0648\u0643\u064A\u0644 \u0645\u0624\u0642\u062A\u064B\u0627 \u2014 \u064A\u0645\u0643\u0646\u0643 \u062A\u062D\u0631\u064A\u0631 \u0627\u0644\u0644\u0648\u062D\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0646\u062A\u0638\u0627\u0631\u0647",
  "chatBar.resume": "\u0627\u0633\u062A\u0626\u0646\u0627\u0641",
  "chatBar.resumeTheAgentYourCanvasEdits": "\u0627\u0633\u062A\u0623\u0646\u0641 \u0627\u0644\u0648\u0643\u064A\u0644 \u2014 \u062A\u064F\u062D\u0641\u0638 \u062A\u0639\u062F\u064A\u0644\u0627\u062A\u0643 \u0639\u0644\u0649 \u0627\u0644\u0644\u0648\u062D\u0629",
  "chatBar.sendMessage": "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
  "openFile.retry": "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
  "subagentTrace.content": "\u0627\u0644\u0645\u062D\u062A\u0648\u0649",
  "subagentTrace.coordinator": "\u0627\u0644\u0645\u0646\u0633\u0651\u0642",
  "subagentTrace.countDone": "{{count}} \u0645\u0643\u062A\u0645\u0644",
  "subagentTrace.countRunning": "{{count}} \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  "subagentTrace.densityCompact": "\u0645\u0636\u063A\u0648\u0637",
  "subagentTrace.densityRich": "\u0645\u0641\u0635\u0651\u0644",
  "subagentTrace.eventsCount": "{{count}} \u062D\u062F\u062B",
  "subagentTrace.messagesCount": "{{count}} \u0631\u0633\u0627\u0644\u0629",
  "subagentTrace.noAgentActivity": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0634\u0627\u0637 \u0644\u0644\u0648\u0643\u064A\u0644 \u0628\u0639\u062F",
  "subagentTrace.noConversationLog": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0633\u062C\u0644 \u0645\u062D\u0627\u062F\u062B\u0629",
  "subagentTrace.noSubagentsActive": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u0643\u0644\u0627\u0621 \u0641\u0631\u0639\u064A\u0648\u0646 \u0646\u0634\u0637\u0648\u0646",
  "subagentTrace.noSubagentsForOrbital": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u0643\u0644\u0627\u0621 \u0641\u0631\u0639\u064A\u0648\u0646 \u0644\u0640 {{orbital}}",
  "subagentTrace.organism": "\u0627\u0644\u0643\u0627\u0626\u0646",
  "subagentTrace.pendingQuestion": "{{count}} \u0633\u0624\u0627\u0644 \u0645\u0639\u0644\u0651\u0642",
  "subagentTrace.pendingQuestions": "{{count}} \u0623\u0633\u0626\u0644\u0629 \u0645\u0639\u0644\u0651\u0642\u0629",
  "subagentTrace.planOrbital": "\u0627\u0644\u062E\u0637\u0629 \xB7 {{count}} \u0645\u062F\u0627\u0631\u064A",
  "subagentTrace.planOrbitals": "\u0627\u0644\u062E\u0637\u0629 \xB7 {{count}} \u0645\u062F\u0627\u0631\u064A\u0627\u062A",
  "subagentTrace.reasoning": "\u0627\u0644\u0627\u0633\u062A\u062F\u0644\u0627\u0644",
  "subagentTrace.subagentCount": "{{count}} \u0648\u0643\u064A\u0644 \u0641\u0631\u0639\u064A",
  "subagentTrace.subagentCountPlural": "{{count}} \u0648\u0643\u0644\u0627\u0621 \u0641\u0631\u0639\u064A\u0648\u0646",
  "subagentTrace.subagents": "\u0627\u0644\u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0641\u0631\u0639\u064A\u0648\u0646",
  "subagentTrace.subagentsWithCount": "\u0627\u0644\u0648\u0643\u0644\u0627\u0621 \u0627\u0644\u0641\u0631\u0639\u064A\u0648\u0646 ({{count}})",
  "subagentTrace.thinking": "\u064A\u0641\u0643\u0651\u0631",
  "subagentTrace.toolCallCount": "{{count}} \u0627\u0633\u062A\u062F\u0639\u0627\u0621 \u0623\u062F\u0627\u0629",
  "subagentTrace.toolCallCountPlural": "{{count}} \u0627\u0633\u062A\u062F\u0639\u0627\u0621\u0627\u062A \u0623\u062F\u0648\u0627\u062A",
  "subagentTrace.toolCalls": "\u0627\u0633\u062A\u062F\u0639\u0627\u0621\u0627\u062A \u0627\u0644\u0623\u062F\u0648\u0627\u062A",
  "subagentTrace.trace": "\u0627\u0644\u062A\u062A\u0628\u0651\u0639",
  "subagentTrace.waitingForProcessData": "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0639\u0645\u0644\u064A\u0629\u2026",
  "subagentTrace.wasOrganism": "\u0643\u0627\u0646 {{organism}}",
  "common.moveUp": "\u0646\u0642\u0644 \u0644\u0623\u0639\u0644\u0649",
  "common.moveDown": "\u0646\u0642\u0644 \u0644\u0623\u0633\u0641\u0644",
  "repeatable.addedIn": "\u0623\u064F\u0636\u064A\u0641 \u0641\u064A:",
  "repeatable.minItemsOne": "\u0645\u0637\u0644\u0648\u0628 \u0639\u0646\u0635\u0631 \u0648\u0627\u062D\u062F \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  "repeatable.minItems": "\u0645\u0637\u0644\u0648\u0628 {{count}} \u0639\u0646\u0627\u0635\u0631 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644",
  "lightbox.counter": "{{current}} / {{total}}",
  "aria.imageViewer": "\u0639\u0627\u0631\u0636 \u0627\u0644\u0635\u0648\u0631",
  "aria.ratingValue": "\u0627\u0644\u062A\u0642\u064A\u064A\u0645: {{value}} \u0645\u0646 {{max}}",
  "pagination.label": "\u062A\u0631\u0642\u064A\u0645 \u0627\u0644\u0635\u0641\u062D\u0627\u062A",
  "pagination.pageOf": "{{page}} / {{total}}",
  "violationAlert.citation": "{{law}} \u0627\u0644\u0645\u0627\u062F\u0629 {{article}}",
  "aria.search": "\u0628\u062D\u062B",
  "form.fixFields": "\u064A\u0631\u062C\u0649 \u062A\u0635\u062D\u064A\u062D {{count}} \u062D\u0642\u0648\u0644",
  "form.invalidValue": "\u0642\u064A\u0645\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  "bloomQuiz.question": "\u0627\u0644\u0633\u0624\u0627\u0644 {{number}}",
  "bloomQuiz.hideAnswer": "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  "bloomQuiz.revealAnswer": "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0625\u062C\u0627\u0628\u0629",
  "bloomQuiz.answer": "\u0627\u0644\u0625\u062C\u0627\u0628\u0629:",
  "bloomQuiz.level.remember": "\u062A\u0630\u0643\u0651\u0631",
  "bloomQuiz.level.understand": "\u0641\u0647\u0645",
  "bloomQuiz.level.apply": "\u062A\u0637\u0628\u064A\u0642",
  "bloomQuiz.level.analyze": "\u062A\u062D\u0644\u064A\u0644",
  "bloomQuiz.level.evaluate": "\u062A\u0642\u064A\u064A\u0645",
  "bloomQuiz.level.create": "\u0627\u0628\u062A\u0643\u0627\u0631",
  "reflection.title": "\u062A\u0648\u0642\u0651\u0641 \u0648\u062A\u0623\u0645\u0651\u0644",
  "reflection.placeholder": "\u0623\u0641\u0643\u0627\u0631\u0643...",
  "reflection.saveContinue": "\u062D\u0641\u0638 \u0648\u0645\u062A\u0627\u0628\u0639\u0629",
  "reflection.answeredEdit": "\u2713 \u062A\u0645\u062A \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \xB7 \u062A\u0639\u062F\u064A\u0644",
  "reflection.answerQuestion": "\u0623\u062C\u0628 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0633\u0624\u0627\u0644",
  "activation.title": "\u0642\u0628\u0644 \u0623\u0646 \u062A\u0628\u062F\u0623...",
  "activation.placeholder": "\u062F\u0648\u0651\u0646 \u0623\u0641\u0643\u0627\u0631\u0643...",
  "activation.continue": "\u062A\u0627\u0628\u0639 \u0625\u0644\u0649 \u0627\u0644\u062F\u0631\u0633 \u2190",
  "activation.skip": "\u062A\u062E\u0637\u064E\u0651 \u0627\u0644\u0622\u0646",
  "activation.answeredEdit": "\u2713 \u062A\u0645\u062A \u0627\u0644\u0625\u062C\u0627\u0628\u0629 \xB7 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u062F",
  "connection.title": "\u0627\u0644\u0628\u0646\u0627\u0621 \u0639\u0644\u0649 \u0645\u0627 \u062A\u0639\u0631\u0641\u0647",
  "likert.stronglyDisagree": "\u0623\u0639\u0627\u0631\u0636 \u0628\u0634\u062F\u0629",
  "likert.disagree": "\u0623\u0639\u0627\u0631\u0636",
  "likert.neutral": "\u0645\u062D\u0627\u064A\u062F",
  "likert.agree": "\u0623\u0648\u0627\u0641\u0642",
  "likert.stronglyAgree": "\u0623\u0648\u0627\u0641\u0642 \u0628\u0634\u062F\u0629",
  "likert.ariaLabel": "\u0645\u0642\u064A\u0627\u0633 \u0644\u064A\u0643\u0631\u062A",
  "dateRange.last7Days": "\u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645",
  "dateRange.last30Days": "\u0622\u062E\u0631 30 \u064A\u0648\u0645\u064B\u0627",
  "dateRange.thisMonth": "\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631",
  "dateRange.thisQuarter": "\u0647\u0630\u0627 \u0627\u0644\u0631\u0628\u0639",
  "dateRange.yearToDate": "\u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0639\u0627\u0645",
  "dateRange.from": "\u0645\u0646",
  "dateRange.to": "\u0625\u0644\u0649",
  "jsonTree.type.text": "\u0646\u0635",
  "jsonTree.type.number": "\u0631\u0642\u0645",
  "jsonTree.type.boolean": "\u0646\u0639\u0645/\u0644\u0627",
  "jsonTree.valueType": "\u0646\u0648\u0639 \u0627\u0644\u0642\u064A\u0645\u0629",
  "jsonTree.itemCountOne": "{{count}} \u0639\u0646\u0635\u0631",
  "jsonTree.itemCountOther": "{{count}} \u0639\u0646\u0627\u0635\u0631",
  "jsonTree.fieldCountOne": "{{count}} \u062D\u0642\u0644",
  "jsonTree.fieldCountOther": "{{count}} \u062D\u0642\u0648\u0644",
  "jsonTree.collapse": "\u0637\u064A\u0651",
  "jsonTree.expand": "\u062A\u0648\u0633\u064A\u0639",
  "jsonTree.addItem": "\u0625\u0636\u0627\u0641\u0629 \u0639\u0646\u0635\u0631",
  "jsonTree.addField": "\u0625\u0636\u0627\u0641\u0629 \u062D\u0642\u0644",
  "import.phase.fetching": "\u062C\u0627\u0631\u064D \u0627\u0644\u062C\u0644\u0628",
  "import.phase.mapping": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0639\u064A\u064A\u0646",
  "import.phase.reviewing": "\u0642\u064A\u062F \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629",
  "import.phase.committing": "\u062C\u0627\u0631\u064D \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F",
  "import.phase.done": "\u062A\u0645",
  "import.phase.failed": "\u0641\u0634\u0644",
  "import.staged": "\u0642\u064A\u062F \u0627\u0644\u062A\u062C\u0647\u064A\u0632 {{count}}",
  "import.committed": "\u062A\u0645 \u0627\u0639\u062A\u0645\u0627\u062F {{count}}",
  "import.failedCount": "\u0641\u0634\u0644 {{count}}",
  "import.noUnitsStaged": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0648\u062D\u062F\u0627\u062A \u0645\u064F\u062C\u0647\u064E\u0651\u0632\u0629.",
  "import.skipped": "\u062A\u0645 \u062A\u062E\u0637\u0651\u064A\u0647\u0627",
  "import.confirmImport": "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u064A\u0631\u0627\u062F",
  "coachmark.skip": "\u062A\u062E\u0637\u0651\u064A",
  "coachmark.gotIt": "\u0641\u0647\u0645\u062A",
  "documentViewer.noDocumentDescription": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0633\u062A\u0646\u062F \u0644\u0639\u0631\u0636\u0647.",
  "documentViewer.iframeTitle": "\u0645\u0633\u062A\u0646\u062F",
  "emojiPicker.addEmoji": "\u0625\u0636\u0627\u0641\u0629 \u0631\u0645\u0632 \u062A\u0639\u0628\u064A\u0631\u064A",
  "emojiPicker.search": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0631\u0645\u0632 \u062A\u0639\u0628\u064A\u0631\u064A\u2026",
  "iconPicker.category": "\u0623\u064A\u0642\u0648\u0646\u0627\u062A",
  "iconPicker.search": "\u0627\u0628\u062D\u062B \u0639\u0646 \u0623\u064A\u0642\u0648\u0646\u0627\u062A\u2026",
  "commandPalette.placeholder": "\u0627\u0643\u062A\u0628 \u0623\u0645\u0631\u064B\u0627...",
  "commandPalette.noMatches": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0623\u0648\u0627\u0645\u0631 \u0645\u0637\u0627\u0628\u0642\u0629",
  "gridPicker.all": "\u0627\u0644\u0643\u0644",
  "gridPicker.moreRefine": "+{{count}} \u0623\u062E\u0631\u0649 \u2014 \u062F\u0642\u0651\u0642 \u0628\u062D\u062B\u0643",
  "graphCanvas.noNodes": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0642\u062F \u0644\u0639\u0631\u0636\u0647\u0627.",
  "codeBlock.noCode": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0643\u0648\u062F \u0644\u0639\u0631\u0636\u0647.",
  "codeBlock.region": "\u0627\u0644\u0634\u064A\u0641\u0631\u0629 \u0627\u0644\u0628\u0631\u0645\u062C\u064A\u0629",
  "fab.action": "\u0625\u062C\u0631\u0627\u0621",
  "fab.closeActions": "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
  "fab.openActions": "\u0641\u062A\u062D \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
  "featureCard.learnMore": "\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F",
  "fileTree.collapse": "\u0637\u064A\u0651",
  "fileTree.expand": "\u062A\u0648\u0633\u064A\u0639",
  "fileTree.nodeAction": "\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u0639\u0642\u062F\u0629",
  "voteStack.ariaLabel": "\u062A\u0635\u0648\u064A\u062A",
  "numberStepper.ariaLabel": "\u0645\u062D\u062F\u062F \u0627\u0644\u0623\u0631\u0642\u0627\u0645",
  "carousel.goToSlide": "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0634\u0631\u064A\u062D\u0629 {{number}}",
  "tagInput.placeholder": "\u0627\u0643\u062A\u0628 \u0648\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 Enter\u2026",
  "tagInput.removeTag": "\u0625\u0632\u0627\u0644\u0629 {{tag}}",
  "nodeSlot.none": "\u2014 \u0644\u0627 \u0634\u064A\u0621 \u2014",
  "nodeSlot.props": "\u0627\u0644\u062E\u0635\u0627\u0626\u0635",
  "positionedCanvas.status.empty": "\u0641\u0627\u0631\u063A",
  "positionedCanvas.status.seated": "\u062C\u0627\u0644\u0633",
  "positionedCanvas.status.ordered": "\u062A\u0645 \u0627\u0644\u0637\u0644\u0628",
  "positionedCanvas.status.awaitingBill": "\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629",
  "positionedCanvas.status.cleaning": "\u0642\u064A\u062F \u0627\u0644\u062A\u0646\u0638\u064A\u0641",
  "positionedCanvas.capacity": "\u0627\u0644\u0633\u0639\u0629 {{count}}",
  "propertyInspector.editInSource": "{{type}} \u2014 \u0639\u062F\u0651\u0644 \u0641\u064A \u0627\u0644\u0645\u0635\u062F\u0631",
  "propertyInspector.config": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
  "propertyInspector.noProperties": "\u0644\u0627 \u062A\u0648\u062C\u062F \u062E\u0635\u0627\u0626\u0635 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0636\u0628\u0637.",
  "propertyInspector.tier.presentation": "\u0627\u0644\u0639\u0631\u0636",
  "propertyInspector.tier.domain": "\u0627\u0644\u0645\u062C\u0627\u0644",
  "propertyInspector.tier.policy": "\u0627\u0644\u0633\u064A\u0627\u0633\u0629",
  "propertyInspector.tier.infra": "\u0627\u0644\u0628\u0646\u064A\u0629 \u0627\u0644\u062A\u062D\u062A\u064A\u0629",
  "propertyInspector.tier.internal": "\u062F\u0627\u062E\u0644\u064A",
  "upload.error.readFailed": "\u062A\u0639\u0630\u0651\u0631\u062A \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0645\u0644\u0641 \u0627\u0644\u0645\u062D\u062F\u062F",
  "selection.ask": "\u0627\u0633\u0623\u0644",
  "selection.note": "\u0645\u0644\u0627\u062D\u0638\u0629",
  "selection.toolbar": "\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
  "qrScanner.apiUnavailable": "\u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0643\u0627\u0645\u064A\u0631\u0627 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0626\u0629",
  "themeToggle.switchToLight": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D",
  "themeToggle.switchToDark": "\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0625\u0644\u0649 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062F\u0627\u0643\u0646",
  "themeToggle.light": "\u0641\u0627\u062A\u062D",
  "themeToggle.dark": "\u062F\u0627\u0643\u0646",
  "avatar.alt": "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0631\u0645\u0632\u064A\u0629",
  "avatar.status": "\u0627\u0644\u062D\u0627\u0644\u0629: {{status}}",
  "avatar.status.online": "\u0645\u062A\u0635\u0644",
  "avatar.status.offline": "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644",
  "avatar.status.away": "\u0628\u0639\u064A\u062F",
  "avatar.status.busy": "\u0645\u0634\u063A\u0648\u0644",
  "avatar.badge": "\u0627\u0644\u0634\u0627\u0631\u0629: {{badge}}",
  "progressBar.ariaLabel": "\u0627\u0644\u062A\u0642\u062F\u0645: {{percent}}",
  "rangeSlider.ariaLabel": "\u0634\u0631\u064A\u0637 \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u0646\u0637\u0627\u0642",
  "select.nSelected": "\u062A\u0645 \u062A\u062D\u062F\u064A\u062F {{count}}",
  "select.searchPlaceholder": "\u0628\u062D\u062B\u2026",
  "statusDot.online": "\u0645\u062A\u0635\u0644",
  "statusDot.offline": "\u063A\u064A\u0631 \u0645\u062A\u0635\u0644",
  "statusDot.away": "\u0628\u0639\u064A\u062F",
  "statusDot.busy": "\u0645\u0634\u063A\u0648\u0644",
  "statusDot.warning": "\u062A\u062D\u0630\u064A\u0631",
  "statusDot.critical": "\u062D\u0631\u062C",
  "trendIndicator.up": "\u0627\u0631\u062A\u0641\u0627\u0639",
  "trendIndicator.down": "\u0627\u0646\u062E\u0641\u0627\u0636",
  "trendIndicator.flat": "\u062B\u0627\u0628\u062A",
  "trendIndicator.withValue": "{{direction}} {{value}}",
  "chart.weekOf": "\u0623\u0633\u0628\u0648\u0639 {{date}}",
  "chart.quarterOf": "\u0627\u0644\u0631\u0628\u0639 {{quarter}} {{year}}",
  "detailPanel.section.overview": "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
  "detailPanel.section.metrics": "\u0627\u0644\u0645\u0642\u0627\u064A\u064A\u0633",
  "detailPanel.section.timeline": "\u0627\u0644\u062C\u062F\u0648\u0644 \u0627\u0644\u0632\u0645\u0646\u064A",
  "detailPanel.section.details": "\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644",
  "codeRunner.run": "\u062A\u0634\u063A\u064A\u0644",
  "codeRunner.output": "\u0627\u0644\u0645\u062E\u0631\u062C\u0627\u062A",
  "codeRunner.exit": "\u0627\u0644\u062E\u0631\u0648\u062C {{code}}",
  "codeRunner.noOutput": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062E\u0631\u062C\u0627\u062A",
  "codeRunner.testPassed": "\u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 {{number}}: \u0646\u062C\u062D",
  "codeRunner.testFailed": "\u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631 {{number}}: \u0641\u0634\u0644",
  "codeRunner.input": "\u0627\u0644\u0645\u062F\u062E\u0644\u0627\u062A: {{value}}",
  "codeRunner.expected": "\u0627\u0644\u0645\u062A\u0648\u0642\u0639: {{value}}",
  "codeRunner.actual": "\u0627\u0644\u0641\u0639\u0644\u064A: {{value}}",
  "toast.notification": "\u0625\u0634\u0639\u0627\u0631",
  "subagentTrace.errorMessage": "\u062E\u0637\u0623: {{message}}",
  "subagentTrace.role.system": "\u0627\u0644\u0646\u0638\u0627\u0645",
  "subagentTrace.role.user": "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  "subagentTrace.role.assistant": "\u0627\u0644\u0645\u0633\u0627\u0639\u062F",
  "subagentTrace.role.tool": "\u0623\u062F\u0627\u0629",
  "subagentTrace.subagent": "\u0648\u0643\u064A\u0644 \u0641\u0631\u0639\u064A",
  "subagentTrace.activityType.tool_call": "\u0627\u0633\u062A\u062F\u0639\u0627\u0621 \u0623\u062F\u0627\u0629",
  "subagentTrace.activityType.tool_result": "\u0646\u062A\u064A\u062C\u0629 \u0623\u062F\u0627\u0629",
  "subagentTrace.activityType.message": "\u0631\u0633\u0627\u0644\u0629",
  "subagentTrace.activityType.error": "\u062E\u0637\u0623",
  "subagentTrace.activityType.file_operation": "\u0639\u0645\u0644\u064A\u0629 \u0645\u0644\u0641",
  "subagentTrace.activityType.schema_diff": "\u0641\u0631\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062E\u0637\u0637",
  "subagentTrace.fileOperation.ls": "\u0639\u0631\u0636",
  "subagentTrace.fileOperation.read_file": "\u0642\u0631\u0627\u0621\u0629",
  "subagentTrace.fileOperation.write_file": "\u0643\u062A\u0627\u0628\u0629",
  "subagentTrace.fileOperation.edit_file": "\u062A\u0639\u062F\u064A\u0644",
  "subagentTrace.diffPreview": "\u0641\u0631\u0648\u0642\u0627\u062A {{path}}",
  "subagentTrace.success": "\u0646\u062C\u0627\u062D",
  "subagentTrace.fail": "\u0641\u0634\u0644",
  "subagentTrace.badgeError": "\u062E\u0637\u0623",
  "subagentTrace.badgeFile": "\u0645\u0644\u0641",
  "subagentTrace.badgeDiff": "\u0641\u0631\u0648\u0642\u0627\u062A",
  "subagentTrace.unattached": "(\u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0637)",
  "dashboard.defaultAppName": "\u0627\u0644\u062A\u0637\u0628\u064A\u0642",
  "dashboard.defaultUserName": "\u0645\u0633\u062A\u062E\u062F\u0645",
  "auth.defaultAppName": "\u062A\u0637\u0628\u064A\u0642\u064A",
  "counter.title": "\u0627\u0644\u0639\u062F\u0627\u062F",
  "counter.resetToZero": "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u064A\u064A\u0646 \u0625\u0644\u0649 0",
  "subagentTrace.activityType.milestone": "\u0645\u0631\u062D\u0644\u0629",
  "subagentTrace.activityType.analysis": "\u062A\u062D\u0644\u064A\u0644",
  "subagentTrace.activityType.cancelled": "\u0623\u064F\u0644\u063A\u064A",
  "subagentTrace.activityType.clarification_question": "\u0633\u0624\u0627\u0644 \u062A\u0648\u0636\u064A\u062D\u064A",
  "subagentTrace.activityType.coordinator_decision": "\u0642\u0631\u0627\u0631 \u0627\u0644\u0645\u0646\u0633\u0642",
  "subagentTrace.activityType.done": "\u062A\u0645",
  "subagentTrace.activityType.llm_response": "\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
  "subagentTrace.activityType.orbital_done": "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u0645\u062F\u0627\u0631",
  "subagentTrace.activityType.orbital_started": "\u0628\u062F\u0623 \u0627\u0644\u0645\u062F\u0627\u0631",
  "subagentTrace.activityType.pending_question": "\u0633\u0624\u0627\u0644 \u0645\u0639\u0644\u0642",
  "subagentTrace.activityType.plan_committed": "\u062A\u0645 \u0627\u0639\u062A\u0645\u0627\u062F \u0627\u0644\u062E\u0637\u0629",
  "subagentTrace.activityType.schema_change": "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u062E\u0637\u0637",
  "gameMenu.defaultTitle": "\u0627\u0644\u0645\u0647\u0645\u0629 \u0627\u0644\u0645\u0644\u062D\u0645\u064A\u0629",
  "gameMenu.newGame": "\u0644\u0639\u0628\u0629 \u062C\u062F\u064A\u062F\u0629",
  "gameMenu.continue": "\u0645\u062A\u0627\u0628\u0639\u0629",
  "gameMenu.settings": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
  "choiceButton.defaultText": "\u0627\u0646\u062F\u0641\u0639 \u0625\u0644\u0649 \u0642\u0644\u0628 \u0627\u0644\u0645\u0639\u0631\u0643\u0629",
  "dialogueBubble.defaultSpeaker": "\u0627\u0644\u0628\u0637\u0644",
  "dialogueBubble.defaultText": "\u0627\u0644\u0632\u0646\u0632\u0627\u0646\u0629 \u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631\u0643. \u0627\u062E\u062A\u0631 \u0637\u0631\u064A\u0642\u0643 \u0628\u062D\u0643\u0645\u0629.",
  "gameShell.defaultName": "\u0644\u0639\u0628\u0629",
  "gameHud.health": "\u0627\u0644\u0635\u062D\u0629",
  "gameHud.score": "\u0627\u0644\u0646\u062A\u064A\u062C\u0629",
  "gameHud.lives": "\u0627\u0644\u0623\u0631\u0648\u0627\u062D",
  "gameHud.time": "\u0627\u0644\u0648\u0642\u062A",
  "gameHud.hp": "\u0646\u0642\u0627\u0637 \u0627\u0644\u0635\u062D\u0629",
  "gameHud.mp": "\u0646\u0642\u0627\u0637 \u0627\u0644\u0633\u062D\u0631",
  "gameHud.level": "\u0627\u0644\u0645\u0633\u062A\u0648\u0649",
  "controlGrid.jump": "\u0642\u0641\u0632",
  "controlGrid.attack": "\u0647\u062C\u0648\u0645",
  "controlGrid.dodge": "\u0645\u0631\u0627\u0648\u063A\u0629",
  "gameAudio.muted": "\u0627\u0644\u0635\u0648\u062A \u0645\u0643\u062A\u0648\u0645",
  "gameAudio.soundOn": "\u0627\u0644\u0635\u0648\u062A \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  "timerDisplay.seconds": "{{count}} \u062B",
  "learningCanvas.loading": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0644\u0648\u062D\u0629\u2026",
  "physicsPreset.projectileMotion": "\u062D\u0631\u0643\u0629 \u0627\u0644\u0645\u0642\u0630\u0648\u0641\u0627\u062A",
  "physicsPreset.simplePendulum": "\u0627\u0644\u0628\u0646\u062F\u0648\u0644 \u0627\u0644\u0628\u0633\u064A\u0637",
  "physicsPreset.springOscillator": "\u0627\u0644\u0645\u062A\u0630\u0628\u0630\u0628 \u0627\u0644\u0632\u0646\u0628\u0631\u0643\u064A",
  "physicsPreset.projectileMotionDescription": "\u0623\u0637\u0644\u0642 \u0643\u0631\u0629 \u0648\u0644\u0627\u062D\u0638 \u0627\u0644\u0645\u0633\u0627\u0631 \u0627\u0644\u0642\u0637\u0639\u064A \u062A\u062D\u062A \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u062C\u0627\u0630\u0628\u064A\u0629.",
  "physicsPreset.simplePendulumDescription": "\u0643\u062A\u0644\u0629 \u0645\u0639\u0644\u0642\u0629 \u0628\u062E\u064A\u0637 \u062A\u062A\u0623\u0631\u062C\u062D \u062A\u062D\u062A \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u062C\u0627\u0630\u0628\u064A\u0629.",
  "physicsPreset.springOscillatorDescription": "\u0643\u062A\u0644\u0629 \u062A\u0647\u062A\u0632 \u0639\u0644\u0649 \u0632\u0646\u0628\u0631\u0643 \u2014 \u062D\u0631\u0643\u0629 \u062A\u0648\u0627\u0641\u0642\u064A\u0629 \u0628\u0633\u064A\u0637\u0629.",
  "physicsPreset.launchAngle": "\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0625\u0637\u0644\u0627\u0642 (\u062F\u0631\u062C\u0629)",
  "physicsPreset.initialVelocity": "\u0627\u0644\u0633\u0631\u0639\u0629 \u0627\u0644\u0627\u0628\u062A\u062F\u0627\u0626\u064A\u0629 (\u0645/\u062B)",
  "physicsPreset.gravity": "\u0627\u0644\u062C\u0627\u0630\u0628\u064A\u0629 (\u0645/\u062B\xB2)",
  "physicsPreset.stringLength": "\u0637\u0648\u0644 \u0627\u0644\u062E\u064A\u0637 (\u0628\u0643\u0633\u0644)",
  "physicsPreset.mass": "\u0627\u0644\u0643\u062A\u0644\u0629 (\u0643\u063A)",
  "physicsPreset.springStiffness": "\u0635\u0644\u0627\u0628\u0629 \u0627\u0644\u0632\u0646\u0628\u0631\u0643 (k)",
  "physicsPreset.damping": "\u0627\u0644\u062A\u062E\u0645\u064A\u062F",
  "editor.tile": "\u0627\u0644\u0645\u0631\u0628\u0639: {{position}}",
  "editor.grid": "\u0627\u0644\u0634\u0628\u0643\u0629: {{width}}x{{height}}",
  "editor.units": "\u0627\u0644\u0648\u062D\u062F\u0627\u062A: {{count}}",
  "editor.features": "\u0627\u0644\u0645\u064A\u0632\u0627\u062A: {{count}}",
  "editor.modeSelect": "\u062A\u062D\u062F\u064A\u062F",
  "editor.modePaint": "\u0631\u0633\u0645",
  "editor.modeUnit": "\u0648\u062D\u062F\u0629",
  "editor.modeFeature": "\u0645\u064A\u0632\u0629",
  "editor.modeErase": "\u0645\u0633\u062D",
  "canvas3d.errorTitle": "\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0634\u0647\u062F \u062B\u0644\u0627\u062B\u064A \u0627\u0644\u0623\u0628\u0639\u0627\u062F",
  "canvas3d.errorMessage": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0623\u062B\u0646\u0627\u0621 \u0639\u0631\u0636 \u0627\u0644\u0645\u0634\u0647\u062F \u062B\u0644\u0627\u062B\u064A \u0627\u0644\u0623\u0628\u0639\u0627\u062F.",
  "canvas3d.errorDetails": "\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062E\u0637\u0623",
  "canvas3d.reloadPage": "\u0625\u0639\u0627\u062F\u0629 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0641\u062D\u0629",
  "canvas3d.loadingScene": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0634\u0647\u062F \u062B\u0644\u0627\u062B\u064A \u0627\u0644\u0623\u0628\u0639\u0627\u062F...",
  "canvas3d.errorWithMessage": "\u062E\u0637\u0623: {{message}}",
  "orbPreview.serverUnreachable": "\u062A\u0639\u0630\u0631 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u062E\u0627\u062F\u0645 \u0627\u0644\u0645\u0639\u0627\u064A\u0646\u0629 \u2014 \u064A\u062C\u0631\u064A \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0645\u062D\u0644\u064A\u064B\u0627. \u062D\u0627\u0644\u0629 \u0627\u0644\u062E\u0627\u062F\u0645 \u0648\u0627\u0644\u062D\u0641\u0638 \u0627\u0644\u062F\u0627\u0626\u0645 \u0645\u0639\u0637\u0644\u0627\u0646.",
  "verification.unknownError": "\u062E\u0637\u0623 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641",
  "debug.ticksHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u062F\u0642\u0627\u062A \u0639\u0646\u062F \u062A\u0634\u063A\u064A\u0644 \u0645\u0639\u0627\u0644\u062C\u0627\u062A \u0627\u0644\u062F\u0642\u0627\u062A \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u0633\u0645\u0627\u062A",
  "debug.justNow": "\u0627\u0644\u0622\u0646",
  "debug.secondsAgo": "\u0642\u0628\u0644 {{count}} \u062B",
  "debug.minutesAgo": "\u0642\u0628\u0644 {{count}} \u062F",
  "debug.tickInterval": "{{count}} \u0645\u0644\u0644\u064A \u062B\u0627\u0646\u064A\u0629",
  "debug.tickRunOne": "{{count}} \u062A\u0634\u063A\u064A\u0644",
  "debug.tickRunOther": "{{count}} \u0639\u0645\u0644\u064A\u0627\u062A \u062A\u0634\u063A\u064A\u0644",
  "debug.tickExec": "\u062A\u0646\u0641\u064A\u0630 {{count}} \u0645\u0644\u0644\u064A \u062B\u0627\u0646\u064A\u0629",
  "debug.activeCount": "\u0646\u0634\u0637\u0629 ({{count}})",
  "debug.inactiveCount": "\u063A\u064A\u0631 \u0646\u0634\u0637\u0629 ({{count}})",
  "debug.verificationHint": "\u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0641\u062D\u0648\u0635\u0627\u062A \u0623\u062B\u0646\u0627\u0621 \u062A\u0646\u0641\u064A\u0630 \u0627\u0644\u062A\u0637\u0628\u064A\u0642 \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0648\u0627\u0644\u062A\u0623\u062B\u064A\u0631\u0627\u062A",
  "debug.passedCount": "{{count}} \u0646\u0627\u062C\u062D\u0629",
  "debug.warningsCount": "{{count}} \u062A\u062D\u0630\u064A\u0631\u0627\u062A",
  "debug.pendingCount": "{{count}} \u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
  "debug.totalChecksCount": "{{count}} \u0641\u062D\u0648\u0635\u0627\u062A \u0625\u062C\u0645\u0627\u0644\u064B\u0627",
  "walkMinimap.engineProgress": "\u0627\u0644\u0645\u062D\u0631\u0643: {{done}}/{{total}}",
  "walkMinimap.domCount": "DOM: {{count}}",
  "walkMinimap.engine": "\u0627\u0644\u0645\u062D\u0631\u0643",
  "walkMinimap.dom": "DOM",
  "avlLegend.eventFlow": "\u062A\u062F\u0641\u0642 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "avlLegend.orbitalBoundary": "\u062D\u062F\u0648\u062F \u0627\u0644\u0645\u062F\u0627\u0631",
  "avlLegend.entityNucleus": "\u0627\u0644\u0643\u064A\u0627\u0646 (\u0627\u0644\u0646\u0648\u0627\u0629)",
  "avlLegend.traitRing": "\u062D\u0644\u0642\u0629 \u0627\u0644\u0633\u0645\u0629",
  "avlLegend.externalLink": "\u0631\u0627\u0628\u0637 \u062E\u0627\u0631\u062C\u064A",
  "avlLegend.initialState": "\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u0628\u062A\u062F\u0627\u0626\u064A\u0629",
  "avlLegend.eventEffects": "\u0627\u0644\u062D\u062F\u062B + \u0627\u0644\u062A\u0623\u062B\u064A\u0631\u0627\u062A",
  "avlLegend.emitExternal": "\u0625\u0635\u062F\u0627\u0631 (\u062E\u0627\u0631\u062C\u064A)",
  "avlLegend.slotTarget": "\u0647\u062F\u0641 \u0627\u0644\u0641\u062A\u062D\u0629",
  "avlLegend.bindingPath": "\u0627\u0644\u0631\u0628\u0637 (@path)",
  "zoomLegend.legend": "\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0631\u0645\u0648\u0632",
  "zoomLegend.hide": "\u0625\u062E\u0641\u0627\u0621",
  "zoomLegend.fieldTypes": "\u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u062D\u0642\u0648\u0644",
  "zoomLegend.stateChain": "\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
  "zoomLegend.eventWire": "\u0633\u0644\u0643 \u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "zoomLegend.stateMachine": "\u0622\u0644\u0629 \u0627\u0644\u062D\u0627\u0644\u0627\u062A",
  "zoomLegend.emitListen": "\u0625\u0635\u062F\u0627\u0631/\u0627\u0633\u062A\u0645\u0627\u0639",
  "zoomLegend.terminalState": "\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629",
  "zoomLegend.hubState": "\u062D\u0627\u0644\u0629 \u0627\u0644\u0645\u062D\u0648\u0631",
  "zoomLegend.triggerEvent": "\u062D\u062F\u062B \u0627\u0644\u062A\u0634\u063A\u064A\u0644",
  "zoomLegend.guardDiamond": "\u0645\u0639\u064A\u0651\u0646 \u0627\u0644\u062D\u0627\u0631\u0633",
  "zoomBreadcrumb.system": "\u0627\u0644\u0646\u0638\u0627\u0645",
  "zoomBreadcrumb.module": "\u0627\u0644\u0648\u062D\u062F\u0629",
  "zoomBreadcrumb.behavior": "\u0627\u0644\u0633\u0644\u0648\u0643",
  "zoomBreadcrumb.detail": "\u0627\u0644\u062A\u0641\u0635\u064A\u0644",
  "avlSwimLane.listens": "\u064A\u0633\u062A\u0645\u0639",
  "avlSwimLane.emits": "\u064A\u064F\u0635\u062F\u0631",
  "avlTransitionScene.slots": "\u0627\u0644\u0641\u062A\u062D\u0627\u062A",
  "avl3d.type": "\u0627\u0644\u0646\u0648\u0639",
  "avl3d.typeInitial": "\u0627\u0628\u062A\u062F\u0627\u0626\u064A\u0629",
  "avl3d.typeTerminal": "\u0646\u0647\u0627\u0626\u064A\u0629",
  "avl3d.typeStandard": "\u0639\u0627\u062F\u064A\u0629",
  "avl3d.incoming": "\u0627\u0644\u0648\u0627\u0631\u062F\u0629",
  "avl3d.outgoing": "\u0627\u0644\u0635\u0627\u062F\u0631\u0629",
  "avl3d.status": "\u0627\u0644\u062D\u0627\u0644\u0629",
  "avl3d.pages": "\u0627\u0644\u0635\u0641\u062D\u0627\u062A",
  "avl3d.fieldCountOne": "{{count}} \u062D\u0642\u0644",
  "avl3d.fieldCountOther": "{{count}} \u062D\u0642\u0648\u0644",
  "avl3d.states": "\u0627\u0644\u062D\u0627\u0644\u0627\u062A",
  "avl3d.events": "\u0627\u0644\u0623\u062D\u062F\u0627\u062B",
  "avl3d.transitions": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "avl3d.effectCountOne": "{{count}} \u062A\u0623\u062B\u064A\u0631",
  "avl3d.effectCountOther": "{{count}} \u062A\u0623\u062B\u064A\u0631\u0627\u062A",
  "avlBehaviorGlyph.ariaLabel": "\u0631\u0645\u0632 \u0633\u0644\u0648\u0643 {{name}}",
  "orbPreview.layer.infrastructure": "\u0627\u0644\u0628\u0646\u064A\u0629 \u0627\u0644\u062A\u062D\u062A\u064A\u0629",
  "orbPreview.layer.services": "\u0627\u0644\u062E\u062F\u0645\u0627\u062A",
  "orbPreview.layer.uiPatterns": "\u0623\u0646\u0645\u0627\u0637 \u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  "orbPreview.layer.game": "\u0627\u0644\u0644\u0639\u0628\u0629",
  "orbPreview.layer.ml": "\u062A\u0639\u0644\u0651\u0645 \u0627\u0644\u0622\u0644\u0629",
  "orbPreview.layer.domain": "\u0627\u0644\u0645\u062C\u0627\u0644",
  "orbPreview.layer.community": "\u0627\u0644\u0645\u062C\u062A\u0645\u0639",
  "screenSize.mobile": "\u0627\u0644\u062C\u0648\u0627\u0644",
  "screenSize.tablet": "\u0627\u0644\u0644\u0648\u062D\u064A",
  "screenSize.laptop": "\u0627\u0644\u062D\u0627\u0633\u0648\u0628 \u0627\u0644\u0645\u062D\u0645\u0648\u0644",
  "screenSize.wide": "\u0639\u0631\u064A\u0636",
  "flowCanvas.presetSize": "{{label}} ({{width}}\u0628\u0643\u0633\u0644)",
  "avl.breadcrumb.transitionNumber": "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 #{{n}}",
  "orbInspector.pattern": "\u0627\u0644\u0646\u0645\u0637",
  "orbInspector.slotLabel": "\u0627\u0644\u0641\u062A\u062D\u0629: {{slot}}",
  "detailPanel.section.activity": "\u0627\u0644\u0646\u0634\u0627\u0637",
  "detailPanel.section.lineItems": "\u0627\u0644\u0628\u0646\u0648\u062F",
  "detailPanel.tab.overview": "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629",
  "detailPanel.thread.empty": "\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0633\u0627\u0626\u0644 \u0628\u0639\u062F",
  "detailPanel.openImage": "\u0641\u062A\u062D \u0627\u0644\u0635\u0648\u0631\u0629",
  "detailPanel.showImage": "\u0639\u0631\u0636 \u0627\u0644\u0635\u0648\u0631\u0629 {{index}}",
  "aria.clearSelection": "\u0645\u0633\u062D \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
  "aria.searchOptions": "\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
  "aria.zoomIn": "\u062A\u0643\u0628\u064A\u0631",
  "aria.zoomOut": "\u062A\u0635\u063A\u064A\u0631",
  "aria.previousPage": "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  "aria.nextPage": "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  "aria.downloadDocument": "\u062A\u0646\u0632\u064A\u0644 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
  "aria.printDocument": "\u0637\u0628\u0627\u0639\u0629 \u0627\u0644\u0645\u0633\u062A\u0646\u062F",
  "aria.wrapLines": "\u0627\u0644\u062A\u0641\u0627\u0641 \u0627\u0644\u0623\u0633\u0637\u0631",
  "aria.copyCode": "\u0646\u0633\u062E \u0627\u0644\u0634\u064A\u0641\u0631\u0629",
  "aria.clearInput": "\u0645\u0633\u062D \u0627\u0644\u0625\u062F\u062E\u0627\u0644",
  "aria.skipToContent": "\u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0627\u0644\u0645\u062D\u062A\u0648\u0649",
  "aria.mainNavigation": "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A",
  "aria.carouselSlides": "\u0627\u0644\u0634\u0631\u0627\u0626\u062D",
  "aria.minimap": "\u0627\u0644\u062E\u0631\u064A\u0637\u0629 \u0627\u0644\u0645\u0635\u063A\u0631\u0629",
  "aria.canvasScene": "\u0645\u0634\u0647\u062F \u0627\u0644\u0644\u0639\u0628\u0629",
  "aria.learningCanvas": "\u0631\u0633\u0645 \u062A\u0641\u0627\u0639\u0644\u064A",
  "aria.scene3d": "\u0645\u0634\u0647\u062F \u062B\u0644\u0627\u062B\u064A \u0627\u0644\u0623\u0628\u0639\u0627\u062F",
  "aria.graphCanvas": "\u0631\u0633\u0645 \u0628\u064A\u0627\u0646\u064A",
  "aria.positionedCanvas": "\u0645\u062E\u0637\u0637 \u0627\u0644\u0645\u0648\u0642\u0639",
  "aria.walkTraitDone": "\u0645\u0643\u062A\u0645\u0644",
  "aria.walkTraitPending": "\u0642\u064A\u062F \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
  "aria.walkGraph": "\u0645\u062E\u0637\u0637 \u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0644\u0640 {{trait}}: \u0645\u0646 {{from}} \u0625\u0644\u0649 {{to}}",
  "aria.loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
  "agentActivity.toolCall": "\u0627\u0633\u062A\u062F\u0639\u0627\u0621 {{tool}}",
  "agentActivity.toolResult": "\u0646\u062A\u064A\u062C\u0629 {{tool}}",
  "agentActivity.toolRows": "{{count}} \u0635\u0641\u0648\u0641",
  "agentActivity.thinking": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u0641\u0643\u064A\u0631\u2026",
  "agentActivity.analyzed": "\u062A\u0645 \u062A\u062D\u0644\u064A\u0644 \u0637\u0644\u0628\u0643 \u2014 {{organism}}",
  "agentActivity.renamed": "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629 {{from}} \u2190 {{to}}",
  "agentActivity.deleted": "\u0625\u0632\u0627\u0644\u0629 {{orbitalName}}",
  "agentActivity.roster": "\u062A\u062E\u0637\u064A\u0637 {{count}} \u0645\u0646 \u0627\u0644\u0648\u062D\u062F\u0627\u062A",
  "agentActivity.orbitalStarted": "\u062C\u0627\u0631\u064D \u0627\u0644\u0639\u0645\u0644 \u0639\u0644\u0649 {{orbitalName}}\u2026",
  "agentActivity.orbitalStartedSettled": "\u0628\u062F\u0623 \u0627\u0644\u0639\u0645\u0644 \u0639\u0644\u0649 {{orbitalName}}",
  "agentActivity.orbitalDone": "{{orbitalName}} \u062C\u0627\u0647\u0632",
  "agentActivity.orbitalCounts": "{{traitCount}} \u0633\u0645\u0627\u062A\u060C {{transitionCount}} \u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A",
  "agentActivity.change.orbital-added": "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 {{orbitalName}}",
  "agentActivity.change.orbital-removed": "\u062A\u0645\u062A \u0625\u0632\u0627\u0644\u0629 {{orbitalName}}",
  "agentActivity.change.entity-fields-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u062D\u0642\u0648\u0644 \u0628\u064A\u0627\u0646\u0627\u062A {{orbitalName}}",
  "agentActivity.change.trait-added": "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0648\u0643 \u0625\u0644\u0649 {{orbitalName}}",
  "agentActivity.change.trait-removed": "\u062A\u0645\u062A \u0625\u0632\u0627\u0644\u0629 \u0633\u0644\u0648\u0643 \u0645\u0646 {{orbitalName}}",
  "agentActivity.change.state-machine-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u062A\u062F\u0641\u0642 {{orbitalName}}",
  "agentActivity.change.guard-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0642\u0627\u0639\u062F\u0629 \u0641\u064A {{orbitalName}}",
  "agentActivity.change.effect-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0645\u0627 \u064A\u0641\u0639\u0644\u0647 {{orbitalName}}",
  "agentActivity.change.render-ui-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u062A\u0635\u0645\u064A\u0645 {{orbitalName}}",
  "agentActivity.change.event-wiring-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0627\u062A\u0635\u0627\u0644\u0627\u062A {{orbitalName}}",
  "agentActivity.change.page-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0635\u0641\u062D\u0627\u062A {{orbitalName}}",
  "agentActivity.change.behavior-composed": "\u062A\u0645 \u062F\u0645\u062C \u0633\u0644\u0648\u0643 \u0641\u064A {{orbitalName}}",
  "agentActivity.done": "\u062A\u0645 \u2014 {{count}} \u0645\u0646 \u0627\u0644\u0648\u062D\u062F\u0627\u062A \u062C\u0627\u0647\u0632\u0629",
  "agentActivity.cancelled": "\u062A\u0645 \u0627\u0644\u0625\u0644\u063A\u0627\u0621",
  "agentActivity.jump": "\u0639\u0631\u0636",
  "agentActivity.emptyTitle": "\u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0634\u0627\u0637 \u0628\u0639\u062F",
  "agentActivity.emptyDescription": "\u0623\u0631\u0633\u0644 \u0631\u0633\u0627\u0644\u0629 \u0648\u0633\u064A\u0638\u0647\u0631 \u0639\u0645\u0644 \u0627\u0644\u0648\u0643\u064A\u0644 \u0647\u0646\u0627.",
  "agentActivity.fileOperation": "{{operation}}",
  "agentActivity.schemaDiff": "\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 {{filePath}}",
  "agentActivity.coordinatorDecision": "\u062A\u0645 \u0627\u062E\u062A\u064A\u0627\u0631 {{organism}}",
  "agentActivity.change.trait-config-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0625\u0639\u062F\u0627\u062F\u0627\u062A {{orbitalName}}",
  "agentActivity.change.theme-changed": "\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0633\u0645\u0629 {{orbitalName}}",
  "agentActivity.llmResponse": "\u0627\u0633\u062A\u062C\u0627\u0628\u0629 LLM \u062E\u0627\u0645",
  "agentActivity.llmDuration": "{{seconds}} \u062B",
  "agentActivity.llmTokens": "{{prompt}} \u062F\u0627\u062E\u0644 / {{completion}} \u062E\u0627\u0631\u062C",
  "agentActivity.llmResponseLabel": "\u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629",
  "agentActivity.llmSystemPrompt": "\u0645\u0648\u062C\u0651\u0647 \u0627\u0644\u0646\u0638\u0627\u0645",
  "agentActivity.llmUserPrompt": "\u0645\u0648\u062C\u0651\u0647 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  "agentActivity.llmToolCalls": "\u0627\u0633\u062A\u062F\u0639\u0627\u0621\u0627\u062A \u0627\u0644\u0623\u062F\u0648\u0627\u062A",
  "agentActivity.showRawLlm": "LLM \u062E\u0627\u0645",
  "agentActivity.earlierConversations": "\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0627\u0644\u0633\u0627\u0628\u0642\u0629 ({{count}})",
  "agentActivity.earlierActivity": "\u0646\u0634\u0627\u0637 \u0633\u0627\u0628\u0642",
  "tabs.scrollStart": "\u0645\u0631\u0651\u0631 \u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0644\u0644\u062E\u0644\u0641",
  "tabs.scrollEnd": "\u0645\u0631\u0651\u0631 \u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0644\u0644\u0623\u0645\u0627\u0645",
  "agentChat.workedThrough": "\u0623\u0646\u062C\u0632 {{count}} \u062E\u0637\u0648\u0627\u062A",
  "agentChat.newMessages": "\u0631\u0633\u0627\u0626\u0644 \u062C\u062F\u064A\u062F\u0629",
  "agentChat.copy": "\u0646\u0633\u062E \u0627\u0644\u0631\u062F",
  "agentChat.copied": "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E",
  "agentChat.today": "\u0627\u0644\u064A\u0648\u0645",
  "agentChat.yesterday": "\u0623\u0645\u0633",
  "agentChat.emptyDescription": "\u0627\u0633\u0623\u0644 \u0628\u0643\u0644\u0645\u0627\u062A\u0643 \u2014 \u064A\u0633\u062A\u0637\u064A\u0639 \u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0648\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0646\u064A\u0627\u0628\u0629\u064B \u0639\u0646\u0643.",
  "avl.effectCategory.ui": "\u0627\u0644\u0634\u0627\u0634\u0629 \u2014 \u062A\u063A\u064A\u0651\u0631 \u0645\u0627 \u064A\u0631\u0627\u0647 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
  "avl.effectCategory.data": "\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u2014 \u062A\u0642\u0631\u0623 \u0627\u0644\u0633\u062C\u0644\u0627\u062A \u0623\u0648 \u062A\u063A\u064A\u0651\u0631\u0647\u0627 \u0623\u0648 \u062A\u062D\u0641\u0638\u0647\u0627",
  "avl.effectCategory.communication": "\u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u2014 \u062A\u0631\u0633\u0644 \u062D\u062F\u062B\u064B\u0627 \u0623\u0648 \u0625\u0634\u0639\u0627\u0631\u064B\u0627 \u0623\u0648 \u0637\u0644\u0628\u064B\u0627",
  "avl.effectCategory.lifecycle": "\u062F\u0648\u0631\u0629 \u0627\u0644\u062D\u064A\u0627\u0629 \u2014 \u062A\u0628\u062F\u0623 \u0646\u0633\u062E\u064B\u0627 \u0642\u064A\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0623\u0648 \u062A\u0632\u064A\u0644\u0647\u0627",
  "avl.effectCategory.control": "\u0627\u0644\u062A\u062F\u0641\u0642 \u2014 \u062A\u0642\u0631\u0651\u0631 \u0645\u0627 \u064A\u064F\u0646\u0641\u064E\u0651\u0630 \u0628\u0639\u062F \u0630\u0644\u0643",
  "avl.effectCategory.async": "\u0627\u0644\u062A\u0648\u0642\u064A\u062A \u2014 \u062A\u0646\u062A\u0638\u0631 \u0623\u0648 \u062A\u0624\u062E\u0651\u0631 \u0623\u0648 \u062A\u0634\u063A\u0651\u0644 \u0627\u0644\u0623\u0634\u064A\u0627\u0621 \u0645\u0639\u064B\u0627",
  "avl.effectCategory.compute": "\u0627\u0644\u062D\u0648\u0633\u0628\u0629 \u2014 \u062A\u0634\u063A\u0651\u0644 \u0646\u0645\u0648\u0630\u062C\u064B\u0627 \u0623\u0648 \u0639\u0645\u0644\u064A\u0629 \u062D\u0633\u0627\u0628\u064A\u0629",
  "avl.effectCategory.system": "\u0627\u0644\u0646\u0638\u0627\u0645 \u2014 \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639 \u0627\u0644\u0645\u0646\u0635\u0629 \u0648\u0623\u062F\u0648\u0627\u062A\u0647\u0627",
  "avl.stateInitial": "\u0627\u0644\u0628\u062F\u0627\u064A\u0629",
  "avl.stateTerminal": "\u0627\u0644\u0646\u0647\u0627\u064A\u0629",
  "avl.guardCaption": "\u0644\u0627 \u064A\u062D\u062F\u062B \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0627 \u0639\u0646\u062F\u0645\u0627 \u064A\u0643\u0648\u0646 \u0647\u0630\u0627 \u0627\u0644\u0634\u0631\u0637 \u0635\u062D\u064A\u062D\u064B\u0627.",
  "avl.effectsCaption": "\u0645\u0627 \u064A\u064F\u0646\u0641\u064E\u0651\u0630\u060C \u0628\u0627\u0644\u062A\u0631\u062A\u064A\u0628\u060C \u0639\u0646\u062F \u062D\u062F\u0648\u062B \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644."
};

// locales/sl.json
var sl_default = {
  $meta: {
    locale: "sl",
    direction: "ltr"
  },
  "common.save": "Shrani",
  "common.cancel": "Prekli\u010Di",
  "common.delete": "Izbri\u0161i",
  "common.close": "Zapri",
  "common.confirm": "Ali ste prepri\u010Dani?",
  "common.create": "Ustvari",
  "common.edit": "Uredi",
  "common.clear": "Po\u010Disti",
  "common.title": "Naslov",
  "common.view": "Prika\u017Ei",
  "common.add": "Dodaj",
  "common.remove": "Odstrani",
  "common.search": "Iskanje...",
  "common.filter": "Filtriraj",
  "common.actions": "Dejanja",
  "common.yes": "Da",
  "common.no": "Ne",
  "common.ok": "V redu",
  "common.done": "Kon\u010Dano",
  "common.apply": "Uporabi",
  "common.reset": "Ponastavi",
  "common.refresh": "Osve\u017Ei",
  "common.export": "Izvozi",
  "common.import": "Uvozi",
  "common.copy": "Kopiraj",
  "common.settings": "Nastavitve",
  "nav.previous": "Prej\u0161nji",
  "nav.next": "Naslednji",
  "nav.back": "Nazaj",
  "nav.home": "Domov",
  "form.submit": "Po\u0161lji",
  "form.saving": "Shranjujem...",
  "form.required": "To polje je obvezno",
  "form.invalidEmail": "Vnesite veljaven e-po\u0161tni naslov",
  "form.selectPlaceholder": "Izberite {{label}}...",
  "form.searchPlaceholder": "Iskanje {{entity}}...",
  "table.empty.title": "Ni najdenih elementov",
  "table.empty.description": "Ni elementov za prikaz.",
  "table.search.placeholder": "Iskanje...",
  "table.pagination.showing": "Prikazujem {{start}} do {{end}} od {{total}} rezultatov",
  "table.pagination.page": "Stran {{page}} od {{totalPages}}",
  "table.bulk.selected": "{{count}} izbranih",
  "table.loading": "Nalagam...",
  "status.loading": "Nalagam...",
  "status.scheduled": "Na\u010Drtovano",
  "status.inProgress": "V izvajanju",
  "status.completed": "Zaklju\u010Deno",
  "status.cancelled": "Preklicano",
  "status.pending": "V \u010Dakanju",
  "status.active": "Aktivno",
  "status.inactive": "Neaktivno",
  "status.draft": "Osnutek",
  "status.archived": "Arhivirano",
  "error.generic": "Nekaj je \u0161lo narobe",
  "error.traitMountFailed": "{{trait}} se ni zagnal",
  "error.retry": "Poskusite znova",
  "error.notFound": "Ni najdeno",
  "error.loadFailed": "Nalaganje ni uspelo: {{message}}",
  "error.configMissing": "Konfiguracija ni najdena za: {{id}}",
  "common.loading": "Nalagam...",
  "common.saveChanges": "Shrani spremembe",
  "common.retry": "Poskusi znova",
  "common.open": "Odpri",
  "common.back": "Nazaj",
  "empty.noItems": "Ni elementov",
  "empty.noData": "Ni podatkov",
  "empty.noItemsYet": "\u0160e ni elementov",
  "empty.noItemsAdded": "\u0160e ni dodanih elementov",
  "empty.noOptionsFound": "Ni najdenih mo\u017Enosti",
  "list.addItemPlaceholder": "Dodaj nov element...",
  "error.occurred": "Pri\u0161lo je do napake",
  "error.failedToLoad": "Nalaganje podatkov ni uspelo",
  "wizard.back": "Nazaj",
  "wizard.next": "Naprej",
  "wizard.complete": "Zaklju\u010Di",
  "wizard.stepOf": "Korak {{current}} od {{total}}",
  "pagination.previous": "Prej\u0161nji",
  "pagination.next": "Naslednji",
  "pagination.total": "Skupaj:",
  "pagination.show": "Prika\u017Ei:",
  "pagination.goTo": "Pojdi na:",
  "pagination.go": "Pojdi",
  "auth.signIn": "Prijava",
  "auth.signOut": "Odjava",
  "auth.welcomeTo": "Dobrodo\u0161li v {{appName}}",
  "auth.brandingSubtitle": "Prijavite se za dostop do nadzorne plo\u0161\u010De in upravljanje ra\u010Duna.",
  "dialog.confirm": "Potrdi",
  "dialog.cancel": "Prekli\u010Di",
  "dialog.loading": "Nalagam...",
  "dialog.delete.title": "Izbrisati {{item}}?",
  "dialog.delete.message": "Tega dejanja ni mogo\u010De razveljaviti.",
  "trait.availableActions": "Razpolo\u017Eljive akcije",
  "trait.transitions": "Prehodi",
  "trait.availableNow": "Trenutno na voljo",
  "book.startReading": "Za\u010Dni brati",
  "book.tableOfContents": "Kazalo vsebine",
  "book.partNumber": "Del {{number}}",
  "book.print": "Natisni",
  "book.previousPage": "Prej\u0161nja stran",
  "book.nextPage": "Naslednja stran",
  "quiz.showAnswer": "Prika\u017Ei odgovor",
  "quiz.hideAnswer": "Skrij odgovor",
  "aria.closeModal": "Zapri okno",
  "aria.closeToast": "Zapri obvestilo",
  "aria.closeAlert": "Zapri opozorilo",
  "aria.removeFilter": "Odstrani filter",
  "aria.closeDrawer": "Zapri predal",
  "aria.closePanel": "Zapri plo\u0161\u010Do",
  "aria.dockPanel": "Stranska plo\u0161\u010Da",
  "aria.previousImage": "Prej\u0161nja slika",
  "aria.nextImage": "Naslednja slika",
  "aria.dismiss": "Opusti",
  "aria.previousSlide": "Prej\u0161nji diapozitiv",
  "aria.nextSlide": "Naslednji diapozitiv",
  "aria.previousDays": "Prej\u0161nji dnevi",
  "aria.nextDays": "Naslednji dnevi",
  "aria.decrease": "Zmanj\u0161aj",
  "aria.increase": "Pove\u010Daj",
  "aria.breadcrumb": "Drobtine",
  "aria.tableOfContents": "Kazalo vsebine",
  "aria.docsSidebar": "Dokumentacijska stranska vrstica",
  "aria.selectAllRows": "Izberi vse vrstice",
  "aria.selectAll": "Izberi vse",
  "aria.upvote": "Glasuj za",
  "aria.downvote": "Glasuj proti",
  "aria.qrScanner": "QR skener",
  "aria.openMenu": "Odpri meni",
  "aria.closeMenu": "Zapri meni",
  "aria.openSidebar": "Odpri stransko vrstico",
  "aria.openRow": "Odpri element {{position}}",
  "sidebar.expand": "Raz\u0161iri stransko vrstico",
  "sidebar.collapse": "Strni stransko vrstico",
  "sidebar.close": "Zapri stransko vrstico",
  "loading.items": "Nalaganje elementov...",
  "card.imageAlt": "Slika",
  "canvas.emptyMessage": "Brez vsebine",
  "canvas.errorTitle": "Napaka na platnu",
  "book.noData": "Ni podatkov",
  "common.notifications": "Obvestila",
  "common.remaining": "\u0161e {{count}}",
  "error.somethingWentWrong": "Nekaj je \u0161lo narobe",
  "error.loadingItems": "Nalaganje elementov...",
  "error.noItemsFound": "Ni najdenih elementov",
  "debug.noEntityData": "Ni podatkov o entiteti",
  "debug.noEntities": "Ni entitet",
  "debug.noTicks": "Ni registriranih ticks",
  "debug.noActiveTraits": "Ni aktivnih lastnosti",
  "debug.noGuardEvaluations": "Ni ocen varovanj",
  "debug.noBridgeData": "Ni podatkov bridge",
  "debug.status": "Status",
  "debug.eventsForwarded": "Posredovani dogodki (Klient \u2192 Stre\u017Enik)",
  "debug.eventsReceived": "Prejeti dogodki (Stre\u017Enik \u2192 Klient)",
  "debug.lastHeartbeat": "Zadnji heartbeat",
  "debug.noEventsYet": "\u0160e ni dogodkov",
  "debug.noTransitionsRecorded": "Ni posnetih prehodov",
  "debug.noVerificationChecks": "\u0160e ni preverjanj",
  "display.chartError": "Napaka v grafikonu",
  "display.codeViewerError": "Napaka v pregledovalniku kode",
  "display.noCode": "Brez kode",
  "display.documentError": "Napaka v dokumentu",
  "display.noDocument": "Brez dokumenta",
  "display.graphError": "Napaka v grafu",
  "display.noGraphData": "Brez podatkov za graf",
  "display.galleryError": "Napaka v galeriji",
  "display.noMedia": "Brez medijev",
  "display.meterError": "Napaka v merilniku",
  "display.signaturePadError": "Napaka v podpisni plo\u0161\u010Di",
  "display.timelineError": "Napaka v \u010Dasovnici",
  "display.noEvents": "Brez dogodkov",
  "display.details": "Podrobnosti",
  "display.itemNotFound": "Zahtevanega elementa ni bilo mogo\u010De najti.",
  "display.noTimelineEvents": "Ni dogodkov na \u010Dasovnici za prikaz.",
  "template.features": "Funkcije",
  "template.howItWorks": "Kako deluje",
  "template.showcase": "Predstavitev",
  "template.faq": "Pogosta vpra\u0161anja",
  "template.ourTeam": "Na\u0161a ekipa",
  "template.caseStudies": "Primeri uporabe",
  "versionDiff.compare": "Primerjaj",
  "versionDiff.changes": "Spremembe",
  "versionDiff.to": "z",
  "versionDiff.beforeRevision": "Prej\u0161nja revizija",
  "versionDiff.afterRevision": "Naslednja revizija",
  "versionDiff.switchToInline": "Preklopi na vrsti\u010Dni pogled",
  "versionDiff.switchToSideBySide": "Preklopi na vzporedni pogled",
  "versionDiff.revert": "Povrni",
  "versionDiff.byAuthor": " avtor {{author}}",
  "versionDiff.unchangedLines": "{{count}} nespremenjenih vrstic",
  "versionDiff.noChanges": "V tej razli\u010Dici ni sprememb.",
  "violationAlert.actionType.measure": "Korektivni ukrep",
  "violationAlert.actionType.admin": "Upravni ukrep",
  "violationAlert.actionType.penalty": "Postopek za sankcijo",
  "violationAlert.fallbackMessage": "Kr\u0161itev",
  "violationAlert.adminLabel": "Upravni:",
  "violationAlert.penaltyLabel": "Sankcija:",
  "violationAlert.goToField": "Pojdi na polje",
  "branchingLogic.title": "Logika razvejanja",
  "branchingLogic.if": "\u010Ce",
  "branchingLogic.goTo": "pojdi na",
  "branchingLogic.rules": "Pravila",
  "branchingLogic.logicGraph": "Graf logike",
  "branchingLogic.addRule": "Dodaj pravilo",
  "branchingLogic.deleteRule": "Izbri\u0161i pravilo",
  "branchingLogic.endOfSurvey": "Konec ankete",
  "branchingLogic.brokenReference": "Pokvarjena referenca",
  "branchingLogic.selectQuestion": "Izberi vpra\u0161anje",
  "branchingLogic.selectTarget": "Izberi cilj",
  "branchingLogic.selectValue": "Izberi vrednost",
  "branchingLogic.addValue": "Dodaj vrednost",
  "branchingLogic.value": "Vrednost",
  "branchingLogic.typeValuePressEnter": "Vnesite vrednost, pritisnite Enter",
  "branchingLogic.operatorEquals": "je enako",
  "branchingLogic.operatorNotEquals": "ni enako",
  "branchingLogic.operatorContains": "vsebuje",
  "branchingLogic.operatorIn": "je eden od",
  "branchingLogic.graphAriaLabel": "Graf logike razvejanja",
  "branchingLogic.ruleCountOne": "{{count}} pravilo",
  "branchingLogic.ruleCountOther": "{{count}} pravil",
  "branchingLogic.brokenCount": "{{count}} pokvarjenih",
  "branchingLogic.emptyNoQuestions": "Dodajte vpra\u0161anja, preden zgradite pravila razvejanja.",
  "branchingLogic.emptyNoRules": "\u0160e ni pravil. Dodajte pravilo za dolo\u010Ditev logike razvejanja.",
  "filterGroup.filters": "Filtri",
  "filterGroup.all": "Vse",
  "filterGroup.clear": "Po\u010Disti",
  "filterGroup.clearAll": "Po\u010Disti vse",
  "filterGroup.from": "Od",
  "filterGroup.to": "Do",
  "filterGroup.allOf": "Vse {{label}}",
  "filterGroup.activeCount": "{{count}} aktivnih",
  "debug.guardEvaluationsHint": "Vrednotenja varovala se prika\u017Eejo, ko se izvedejo prehodi ali utripi z varovali",
  "debug.expression": "Izraz",
  "debug.inputs": "Vhodi",
  "debug.trait": "Lastnost",
  "debug.filterAll": "Vse",
  "debug.filterPassed": "Uspe\u0161no",
  "debug.filterFailed": "Neuspe\u0161no",
  "debug.traitsInitHint": "Lastnosti se prika\u017Eejo ob inicializaciji stroja stanj",
  "debug.traitsMountHint": "Lastnosti se prika\u017Eejo, ko so komponente, ki jih uporabljajo, vpete",
  "debug.activeStates": "Aktivna stanja",
  "debug.availableEvents": "Razpolo\u017Eljivi dogodki",
  "debug.noTransitionsFromState": "Ni prehodov iz trenutnega stanja",
  "debug.guarded": "varovan",
  "debug.otherEvents": "Drugi dogodki (niso na voljo iz trenutnega stanja)",
  "debug.recentTransitions": "Nedavni prehodi",
  "debug.transitionsCount": "{{count}} prehodov",
  "debug.states": "Stanja",
  "debug.transitions": "Prehodi",
  "debug.guards": "Varovala",
  "debug.debugModeHint": "Na\u010Din razhro\u0161\u010Devanja morda ni omogo\u010Den",
  "debug.entitiesSpawnHint": "Entitete se prika\u017Eejo ob ustvarjanju",
  "debug.singleton": "Singleton",
  "debug.singletonsCount": "Singletoni ({{count}})",
  "debug.runtimeCount": "Izvajalno okolje ({{count}})",
  "debug.moreEntities": "+{{count}} dodatnih entitet",
  "debug.persistent": "Trajno",
  "debug.loadedCount": "{{count}} nalo\u017Eenih",
  "debug.notLoaded": "ni nalo\u017Eeno",
  "debug.eventsExecuteHint": "Dogodki se prika\u017Eejo med izvajanjem lastnosti, utripov in drugih sistemov",
  "debug.allCount": "Vse ({{count}})",
  "debug.autoScroll": "Samodejno drsenje",
  "debug.transitionsProcessHint": "Prehodi se prika\u017Eejo, ko stroj stanj obdeluje dogodke",
  "debug.transitionsRecorded": "Zabele\u017Eenih {{count}} prehodov",
  "debug.guardLabel": "varovalo:",
  "debug.effectsCount": "{{count}} u\u010Dinkov",
  "debug.bridgeInitHint": "Stre\u017Eni\u0161ki most ni bil inicializiran. Stanje mostu se prika\u017Ee, ko se izvajalno okolje pove\u017Ee s stre\u017Enikom.",
  "debug.never": "Nikoli",
  "debug.connected": "Povezano",
  "debug.disconnected": "Nepovezano",
  "debug.lastError": "Zadnja napaka",
  "debug.totalEventsProcessed": "Skupaj obdelanih {{count}} dogodkov",
  "debug.server": "stre\u017Enik",
  "debug.clientEffectsCount": "{{count}} u\u010Dinkov odjemalca",
  "debug.emitLabel": "oddaja:",
  "debug.rowsCount": "{{count}} vrstic",
  "debug.serverResponse": "odziv stre\u017Enika",
  "debug.collapseVerificationTimeline": "Strni \u010Dasovnico preverjanja",
  "debug.expandVerificationTimeline": "Raz\u0161iri \u010Dasovnico preverjanja",
  "debug.failCount": "{{count}} neuspeh",
  "debug.ok": "V redu",
  "debug.localCount": "{{count}} lokalnih",
  "debug.serverCount": "{{count}} stre\u017Eni\u0161kih",
  "debug.waitingForTransitions": "\u010Cakanje na prehode ...",
  "debug.tabDispatch": "Po\u0161iljanje",
  "debug.tabVerify": "Preveri",
  "debug.tabVerifyAlert": "Preveri (!)",
  "debug.tabTimeline": "\u010Casovnica",
  "debug.tabBridge": "Most",
  "debug.tabTraits": "Lastnosti",
  "debug.tabTicks": "Utripi",
  "debug.tabEntities": "Entitete",
  "debug.tabEvents": "Dogodki",
  "debug.tabGuards": "Varovala",
  "debug.debugger": "Razhro\u0161\u010Devalnik",
  "debug.failedCount": "{{count}} neuspe\u0161nih",
  "debug.traitsCount": "{{count}} lastnosti",
  "debug.idle": "Nedejavno",
  "debug.openDebugger": "Odpri razhro\u0161\u010Devalnik (`)",
  "debug.kflowVerifier": "KFlow preverjevalnik",
  "debug.allPassing": "Vse uspe\u0161no",
  "debug.runtime": "Izvajalno okolje",
  "debug.close": "Zapri (`)",
  "debug.toggleHint": "Pritisnite ` za preklop | window.__orbitalVerification za avtomatizacijo",
  "replyTree.expandReplies": "Raz\u0161iri odgovore",
  "replyTree.collapseReplies": "Strni odgovore",
  "replyTree.voteOnReplyBy": "Glasuj o odgovoru uporabnika {{author}}",
  "replyTree.replyTo": "Odgovori uporabniku {{author}}",
  "replyTree.replyToPlaceholder": "Odgovori uporabniku {{author}}\u2026",
  "replyTree.reply": "Odgovori",
  "replyTree.flagReplyBy": "Ozna\u010Di odgovor uporabnika {{author}}",
  "replyTree.flag": "Ozna\u010Di",
  "replyTree.send": "Po\u0161lji",
  "replyTree.continueThread": "Nadaljuj nit",
  "replyTree.noRepliesYet": "\u0160e ni odgovorov.",
  "signaturePad.label": "Podpis",
  "signaturePad.helperText": "Nari\u0161ite svoj podpis zgoraj",
  "signaturePad.clear": "Po\u010Disti",
  "signaturePad.confirm": "Potrdi",
  "qrScanner.cameraUnavailable": "Kamera ni na voljo",
  "qrScanner.paused": "Za\u010Dasno ustavljeno",
  "qrScanner.resumeScanning": "Nadaljuj skeniranje",
  "qrScanner.pauseScanning": "Za\u010Dasno ustavi skeniranje",
  "qrScanner.switchToFrontCamera": "Preklopi na sprednjo kamero",
  "qrScanner.switchToRearCamera": "Preklopi na zadnjo kamero",
  "docSearch.placeholder": "Iskanje po dokumentaciji...",
  "stateMachine.loading": "Nalaganje stanjskega stroja\u2026",
  "stateMachine.noStateMachine": "Ni stanjskega stroja za prikaz",
  "avl.trigger": "Spro\u017Eilec",
  "avl.guard": "Varovalo",
  "avl.effects": "U\u010Dinki",
  "avl.props": "Lastnosti",
  "avl.entity": "Entiteta",
  "avl.traits": "Lastnosti vedenja",
  "avl.transition": "Prehod",
  "avl.onEntity": "na {{entity}}",
  "avl.linkedTo": "povezano z {{entity}}",
  "avl.pressEscToZoomOut": "Pritisnite Esc za pomanj\u0161anje",
  "avl.zoomIn": "Pove\u010Daj",
  "avl.zoomOut": "Pomanj\u0161aj",
  "avl.orbitalLabel": "Orbital: {{name}}",
  "avl.orbitalLabelHighlighted": "Orbital: {{name}} (poudarjen)",
  "avl.noTraitData": "Ni podatkov o lastnosti vedenja",
  "avl.computingLayout": "Ra\u010Dunanje postavitve ...",
  "avl.noStateMachine": "Ni stanjskega stroja",
  "avl.listensFor": "poslu\u0161a za {{event}}",
  "avl.emits": "oddaja {{event}}",
  "avl.pageLayout": "Postavitev strani",
  "avl.overlaySuffix": "(prekrivni sloj)",
  "avl.stateCount": "stanja: {{count}}",
  "avl.transitionCount": "prehodi: {{count}}",
  "avl.listensRail": "poslu\u0161a",
  "avl.emitsRail": "odda",
  "avl.now": "zdaj",
  "avl.circuit.zone.entity": "entiteta",
  "avl.circuit.zone.store": "shramba",
  "avl.circuit.zone.bus": "vodilo",
  "avl.circuit.zone.screen": "zaslon",
  "avl.circuit.zone.route": "pot",
  "avl.circuit.zone.toast": "obvestilo",
  "avl.circuit.zone.remote": "oddaljeno",
  "avl.circuit.zone.instances": "primerki",
  "avl.circuit.zone.flow": "tok",
  "avl.circuit.zone.timer": "\u010Dasovnik",
  "avl.circuit.zone.model": "model",
  "avl.circuit.zone.system": "sistem",
  "avl.circuit.evaluating": "vrednotenje {{code}}",
  "avl.circuit.returned": "{{code}} \u2192 {{value}}",
  "avl.circuit.failed": "{{code}} ni uspel: {{error}}",
  "avl.circuit.skipped": "{{code}} se ni izvedel",
  "avl.circuit.nextItem": "naslednji element skozi {{code}}",
  "avl.circuit.step": "Korak {{n}} / {{total}}",
  "avl.circuit.stack": "sklad",
  "avl.glyph.application": "Aplikacija",
  "avl.glyph.orbital": "Orbital",
  "avl.glyph.entity": "Entiteta",
  "avl.glyph.trait": "Lastnost",
  "avl.glyph.page": "Stran",
  "avl.glyph.state": "Stanje",
  "avl.glyph.transition": "Prehod",
  "avl.glyph.event": "Dogodek",
  "avl.glyph.guard": "Pogoj",
  "avl.glyph.effect": "U\u010Dinek",
  "avl.glyph.field": "Polje",
  "avl.glyph.fieldType": "Tip polja",
  "avl.glyph.binding": "Vezava",
  "avl.glyph.bindingRef": "Sklic vezave",
  "avl.glyph.persistence": "Obstojnost",
  "avl.glyph.operator": "Operator",
  "avl.glyph.sexpr": "Izraz",
  "avl.glyph.literal": "Literal",
  "orbPreview.previewBadge": "Predogled",
  "orbPreview.doubleClickToOpen": "Dvokliknite za odpiranje",
  "orbPreview.dropToAddAndOpen": "Spustite za dodajanje in odpiranje",
  "orbPreview.hasProblems": "Ta orbital ima te\u017Eave \u2014 odpri opozorilo zgoraj desno in jih odpravi",
  "orbPreview.dispatching": "Koordinator po\u0161ilja temu orbitalu",
  "orbPreview.noPreview": "Predogled ni na voljo",
  "detailView.noTransitionData": "Ni podatkov o prehodu",
  "orbInspector.required": "obv.",
  "orbInspector.addField": "Dodaj polje",
  "orbInspector.serviceMode": "Na\u010Din storitve",
  "orbInspector.standalone": "Samostojen",
  "orbInspector.embedded": "Vgrajen",
  "orbInspector.rendersOwnUi": "Izri\u0161e svoj lasten vmesnik",
  "orbInspector.headless": "Brez vmesnika, povezan z drugimi vedenji",
  "orbInspector.addEffect": "Dodaj u\u010Dinek",
  "orbInspector.guardExpression": "Izraz varovala",
  "orbInspector.selectPatternForStyles": "Izberite vzorec za ogled njegovih slogovnih \u017Eetonov.",
  "orbInspector.tokens": "\u017Detoni",
  "orbInspector.noTokenContract": "Za ta vzorec ni razgla\u0161ene pogodbe \u017Eetonov.",
  "orbInspector.variant": "Razli\u010Dica",
  "orbInspector.size": "Velikost",
  "orbInspector.statesCount": "{{count}} stanj",
  "orbInspector.onEntity": " na {{entity}}",
  "orbInspector.projectThemeTokens": "\u017Detoni teme projekta",
  "orbInspector.tokenGroup.colors": "Barve",
  "orbInspector.tokenGroup.radii": "Polmeri",
  "orbInspector.tokenGroup.spacing": "Razmik",
  "orbInspector.tokenGroup.shadows": "Sence",
  "orbInspector.tab.inspector": "Pregledovalnik",
  "orbInspector.tab.styles": "Slogi",
  "orbInspector.tab.design": "Oblikovanje",
  "orbInspector.tab.prototype": "Prototip",
  "orbInspector.tab.code": "Koda",
  "canvas.overview": "Pregled",
  "canvas.modulesCount": "{{count}} modulov",
  "canvas.switchToView": "Preklopi na pogled {{label}}",
  "lawReference.viewFullText": "Prika\u017Ei celotno besedilo zakona",
  "statCard.defaultLabel": "Statistika",
  "statCard.vsLastPeriod": "glede na prej\u0161nje obdobje",
  "mediaGallery.upload": "Nalo\u017Ei",
  "mediaGallery.noMediaDescription": "Ni medijskih elementov za prikaz.",
  "pagination.jumpPlaceholder": "Stran",
  "table.selectRow": "Izberi vrstico {{id}}",
  "card.selectItem": "Izberi {{item}}",
  "card.itemFallback": "element",
  "fileTree.noFiles": "Ni datotek",
  "masterDetail.selectItem": "Izberite element za ogled podrobnosti",
  "empty.createFirst": "Ustvarite svoj prvi element za za\u010Detek.",
  "upload.dropOrBrowse": "Spustite datoteke sem ali kliknite za brskanje",
  "upload.dropFilesHere": "Spustite datoteke sem",
  "upload.accepted": "Sprejeto: {{accept}}",
  "upload.maxSize": "Najve\u010Dja velikost: {{size}}",
  "upload.maxFiles": "Do {{count}} datotek",
  "upload.error.maxFiles": "Dovoljenih je najve\u010D {{count}} datotek",
  "upload.error.invalidType": "Neveljavna vrsta datoteke: {{name}}",
  "upload.error.tooLarge": "Datoteka prevelika: {{name}} (najve\u010D {{size}})",
  "optionConstraint.requiredOne": "Obvezno, izberite 1",
  "optionConstraint.optionalOne": "Neobvezno, izberite do 1",
  "optionConstraint.pickExactly": "Izberite natanko {{count}}",
  "optionConstraint.pickRange": "Izberite {{min}}-{{max}}",
  "optionConstraint.pickAtLeast": "Izberite vsaj {{count}}",
  "optionConstraint.pickUpTo": "Izberite do {{count}}",
  "optionConstraint.optional": "Neobvezno",
  "optionConstraint.outOfStock": "Ni na zalogi",
  "optionConstraint.error.pickOne": "Izberite 1 mo\u017Enost",
  "optionConstraint.error.pickOnlyOne": "Izberite samo 1 mo\u017Enost",
  "optionConstraint.error.pickMore": "Izberite vsaj \u0161e {{count}}",
  "optionConstraint.error.removeOptions": "Odstranite {{count}} mo\u017Enosti",
  "stateMachine.pinned": "Pripeto",
  "stateMachine.eventCount": "{{count}} dogodkov",
  "stateMachine.externalEffects": "Zunanji u\u010Dinki",
  "stateMachine.legend.initial": "Za\u010Detno",
  "stateMachine.legend.final": "Kon\u010Dno",
  "stateMachine.legend.state": "Stanje",
  "stateMachine.legend.multiEvent": "Ve\u010D dogodkov",
  "common.selected": "Izbrano",
  "common.showMore": "Poka\u017Ei ve\u010D",
  "common.showLess": "Poka\u017Ei manj",
  "common.noResults": "Ni rezultatov",
  "relationSelect.selectPlaceholder": "Izberi...",
  "battle.cancel": "Prekli\u010Di",
  "battle.defeat": "Poraz",
  "battle.endTurn": "Kon\u010Daj potezo",
  "battle.playAgain": "Igraj znova",
  "battle.turnsPlayed": "Odigrane poteze",
  "battle.victory": "Zmaga",
  "builder.allPlaced": "Vse postavljeno",
  "builder.blueprint": "Na\u010Drt",
  "builder.build": "Zgradi",
  "builder.components": "Komponente",
  "builder.empty": "Prazno",
  "builder.reset": "Ponastavi",
  "builder.success": "Uspeh",
  "classifier.allCorrect": "Vse pravilno!",
  "classifier.check": "Preveri",
  "classifier.correct": "pravilno",
  "classifier.itemsToSort": "Elementi za razvr\u0161\u010Danje",
  "classifier.reset": "Ponastavi",
  "common.error": "Napaka",
  "debugger.allFound": "Vsi hro\u0161\u010Di najdeni!",
  "debugger.bugsFound": "najdenih hro\u0161\u010Dev",
  "debugger.findBugs": "Poi\u0161\u010Di {{count}} hro\u0161\u010Dev",
  "debugger.reset": "Ponastavi",
  "debugger.submit": "Po\u0161lji",
  "error.genericLoad": "Nalaganje ni uspelo",
  "error.loadingData": "Nalaganje podatkov",
  "eventHandler.addRule": "Dodaj pravilo",
  "eventHandler.chainComplete": "Veriga zaklju\u010Dena!",
  "eventHandler.clickObject": "Klikni predmete",
  "eventHandler.eventLog": "Dnevnik dogodkov",
  "eventHandler.heardEvent": "{{object}} je sli\u0161al {{event}} \u2192 {{action}}",
  "eventHandler.noEvents": "\u0160e ni dogodkov",
  "eventHandler.noListeners": "Ni poslu\u0161alcev za {{event}}",
  "eventHandler.rules": "{{count}}/{{max}} pravil",
  "eventHandler.simulationStarted": "Simulacija: {{events}}",
  "eventHandler.state": "Stanje",
  "eventHandler.then": "potem",
  "eventHandler.when": "Ko",
  "game.goal": "Cilj",
  "game.hint": "Namig",
  "game.play": "Predvajaj",
  "game.reset": "Ponastavi",
  "game.runTests": "Za\u017Eeni preizkuse",
  "negotiator.chooseAction": "Izberi dejanje",
  "negotiator.failed": "Pogajanje ni uspelo",
  "negotiator.finalScore": "Kon\u010Dni rezultat",
  "negotiator.history": "Zgodovina",
  "negotiator.opponent": "Nasprotnik",
  "negotiator.playAgain": "Igraj znova",
  "negotiator.round": "Krog {{current}} od {{total}}",
  "negotiator.success": "Pogajanje uspe\u0161no",
  "negotiator.target": "Cilj",
  "negotiator.you": "Ti",
  "platformer.level": "Raven",
  "platformer.lost": "Konec igre",
  "platformer.nextLevel": "Naslednja raven",
  "platformer.noLives": "Ni ve\u010D \u017Eivljenj",
  "platformer.playAgain": "Igraj znova",
  "platformer.score": "To\u010Dke",
  "platformer.won": "Zmagal si!",
  "puzzle.tryAgainButton": "Poskusi znova",
  "roguelike.atk": "NAP",
  "roguelike.cleared": "Klet o\u010Di\u0161\u010Dena! Dose\u017Eena globina: {{depth}}",
  "roguelike.defeat": "Pora\u017Een!",
  "roguelike.depth": "Globina",
  "roguelike.enemy": "Sovra\u017Enik",
  "roguelike.hp": "\u017DP",
  "roguelike.phase": "Faza",
  "roguelike.playAgain": "Igraj znova",
  "roguelike.player": "Junak",
  "roguelike.victory": "Zmaga!",
  "sequencer.actions": "Dejanja",
  "sequencer.dragActions": "Povleci dejanja sem",
  "sequencer.levelComplete": "Raven zaklju\u010Dena!",
  "sequencer.yourSequence": "Tvoje zaporedje",
  "simulator.correct": "Pravilno",
  "simulator.incorrect": "Nepravilno",
  "simulator.parameters": "Parametri",
  "simulator.reset": "Ponastavi",
  "simulator.simulate": "Simuliraj",
  "simulator.target": "Cilj",
  "stateArchitect.addTransition": "Dodaj prehod iz {{state}}",
  "stateArchitect.addTransitionPrompt": "Klikni ciljno stanje",
  "stateArchitect.allPassed": "Vsi preizkusi uspe\u0161ni!",
  "stateArchitect.clickTarget": "Klikni ciljno stanje (trenutno: {{state}})",
  "stateArchitect.gotState": "Prejeto stanje: {{state}}",
  "stateArchitect.graph": "Graf",
  "stateArchitect.hideJson": "Skrij JSON",
  "stateArchitect.showJson": "Poka\u017Ei JSON",
  "stateArchitect.testResults": "Rezultati preizkusov",
  "stateArchitect.transitions": "{{count}} prehodov",
  "stateArchitect.variables": "Spremenljivke: {{name}}",
  "stateArchitect.viewCode": "Prika\u017Ei kodo",
  "td.defeat": "Poraz",
  "td.gold": "Zlato",
  "td.lives": "\u017Divljenja",
  "td.livesReachedZero": "Va\u0161a baza je bila preplavljena",
  "td.placeTower": "Postavi stolp",
  "td.playAgain": "Igraj znova",
  "td.startWave": "Za\u010Dni val",
  "td.survivedAllWaves": "Pre\u017Eiveli vse valove!",
  "td.victory": "Zmaga!",
  "td.wave": "Val",
  "td.waveInProgress": "Val v teku\u2026",
  "documentDetails.title": "Podrobnosti",
  "documentPanel.untitled": "Brez naslova",
  "documentPanel.edit": "Uredi",
  "documentPanel.done": "Konec",
  "documentPanel.autosaveHint": "Shranjuje se med tipkanjem",
  "documentPanel.placeholder": "Za\u010Dni pisati\u2026",
  "richTextEditor.editorToolbar": "Orodna vrstica za oblikovanje",
  "richTextEditor.editorSurface": "Urejevalnik obogatenega besedila",
  "richTextEditor.bold": "Krepko",
  "richTextEditor.italic": "Le\u017Ee\u010De",
  "richTextEditor.underline": "Pod\u010Drtano",
  "richTextEditor.strikethrough": "Pre\u010Drtano",
  "richTextEditor.heading1": "Naslov 1",
  "richTextEditor.heading2": "Naslov 2",
  "richTextEditor.heading3": "Naslov 3",
  "richTextEditor.bulletList": "Seznam z oznakami",
  "richTextEditor.numberedList": "O\u0161tevil\u010Den seznam",
  "richTextEditor.quote": "Citat",
  "richTextEditor.code": "Koda",
  "richTextEditor.link": "Dodaj povezavo",
  "richTextEditor.removeLink": "Odstrani povezavo",
  "richTextEditor.divider": "Lo\u010Dilo",
  "richTextEditor.linkPrompt": "Naslov povezave",
  "richTextEditor.image": "Vstavi sliko",
  "richTextEditor.imagePrompt": "URL slike",
  "richTextEditor.placeholder": "Za\u010Dnite pisati \u2026",
  "form.imageUrlFallback": "\u2026ali prilepite naslov slike",
  "mermaid.unrenderable": "Tega diagrama ni bilo mogo\u010De prikazati. Njegova izvorna koda je prikazana spodaj.",
  "orbPreview.play": "Predvajaj \u2014 uporabljaj ta zaslon",
  "orbPreview.pause": "Premor \u2014 izberi in uredi",
  "inlineText.boundValue": "To besedilo prihaja iz podatkov, zato ga tukaj ni mogo\u010De urejati.",
  "designOverlay.layoutVertical": "Navpi\u010Dna postavitev",
  "designOverlay.layoutHorizontal": "Vodoravna postavitev",
  "designOverlay.spaceBetween": "Enakomeren razmik",
  "designOverlay.wrap": "Prelom",
  "designOverlay.align": "Poravnaj {{row}} {{column}}",
  "designOverlay.top": "zgoraj",
  "designOverlay.middle": "sredina",
  "designOverlay.bottom": "spodaj",
  "designOverlay.left": "levo",
  "designOverlay.center": "sredina",
  "designOverlay.right": "desno",
  "orbInspector.appearance": "Videz",
  "orbInspector.editScope": "Obseg urejanja",
  "orbInspector.scopeLocal": "Ta element",
  "orbInspector.scopeGlobal": "Tema",
  "orbInspector.fill": "Polnilo",
  "orbInspector.textColor": "Besedilo",
  "orbInspector.borderColor": "Obroba",
  "orbInspector.radius": "Zaobljenost",
  "orbInspector.width": "\u0160irina",
  "orbInspector.height": "Vi\u0161ina",
  "orbInspector.minWidth": "Min \u0160",
  "orbInspector.maxWidth": "Maks \u0160",
  "orbInspector.minHeight": "Min V",
  "orbInspector.maxHeight": "Maks V",
  "orbInspector.limitNone": "Brez",
  "orbInspector.absolute": "Absolutni polo\u017Eaj",
  "orbInspector.constraintHorizontal": "Vodoravno",
  "orbInspector.constraintVertical": "Navpi\u010Dno",
  "orbInspector.pinLeft": "Levo",
  "orbInspector.pinRight": "Desno",
  "orbInspector.pinLeftRight": "Levo in desno",
  "orbInspector.pinTop": "Zgoraj",
  "orbInspector.pinBottom": "Spodaj",
  "orbInspector.pinTopBottom": "Zgoraj in spodaj",
  "orbInspector.pinCenter": "Sredina",
  "orbInspector.pinScale": "Skaliraj",
  "orbInspector.auto": "Samodejno",
  "orbInspector.notThemeBacked": "Ni vrednost teme \u2014 nastavite jo na tem elementu",
  "orbInspector.globalAffects": "Spremeni {{token}} povsod, kjer je uporabljen",
  "orbInspector.classNameIsBinding": "Razredi tega elementa prihajajo iz vezave, zato jih tu ni mogo\u010De urejati",
  "orbInspector.sizingHug": "Prilagodi vsebini",
  "orbInspector.sizingFill": "Zapolni vsebnik",
  "orbInspector.gap": "Razmik",
  "orbInspector.padding": "Odmik",
  "orbInspector.mixed": "Me\u0161ano",
  "orbInspector.custom": "Po meri",
  "orbInspector.customRefused": "Ena vrednost po meri, npr. w-[243px] ali bg-[#e14b2a].",
  "inlineText.fixedValue": "To besedilo dolo\u010Da {{behavior}} \u2014 spremenite ga v njegovih nastavitvah.",
  "inlineText.loading": "\u0160e preverjam, kaj lahko v tem elementu spremenite.",
  "orbPreview.partOf": "Del {{behavior}}",
  "avl.propBound": "Iz podatkov: {{binding}}",
  "avl.propFixed": "Dolo\u010Da {{behavior}}",
  "avl.propChecking": "Preverjam\u2026",
  "avl.moreProps": "Ve\u010D ({{count}})",
  "knobField.addAValue": "Dodaj vrednost\u2026",
  "knobField.addField": "Dodaj polje",
  "knobField.addItem": "Dodaj {{label}}",
  "knobField.addOwnField": "Dodaj lastno polje",
  "knobField.entityFields": "Polja entitete",
  "knobField.fieldNamePlaceholder": "Ime polja",
  "knobField.items": "Elementi",
  "knobField.missingItemSchema": "Manjka shema elementa \u2014 strukturiranega urejevalnika seznama ni mogo\u010De prikazati.",
  "knobField.missingObjectSchema": "Manjka shema objekta \u2014 strukturiranega obrazca ni mogo\u010De prikazati.",
  "knobField.number": "\u0160tevilo",
  "knobField.other": "Drugo ...",
  "knobField.removeItem": "Odstrani",
  "knobField.specifyPlaceholder": "Dolo\u010Di...",
  "knobField.yourAnswer": "Va\u0161 odgovor\u2026",
  "avl.settings": "Nastavitve",
  "avl.settingsOf": "Nastavitve {{behavior}}",
  "canvas.liveState": "V \u017Eivo",
  "canvas.verifyTransition": "Preveri ta prehod",
  "canvas.verifyTrait": "Preveri to lastnost (predvajaj njen potek)",
  "canvas.verifyPause": "Za\u010Dasno ustavi preverjanje",
  "canvas.verifyStop": "Ustavi preverjanje",
  "canvas.verdict.pass": "Preverjeno",
  "canvas.verdict.fail": "Ni uspelo",
  "canvas.verdict.stale": "Spremenjeno od preverjanja",
  "canvas.verdict.running": "Preverjanje",
  "canvas.stateOf": "Stanje, prikazano na {{orbital}}",
  "canvas.previousOrbital": "Prej\u0161nji orbital (Shift+Tab)",
  "canvas.nextOrbital": "Naslednji orbital (Tab)",
  "canvas.focusedOrbital": "Izbrani orbital",
  "canvas.scopeLocal": "Fokus",
  "canvas.scopeWorld": "Vse",
  "canvas.scopeLocalHint": "Prika\u017Ei samo izbrani orbital",
  "canvas.scopeWorldHint": "Prika\u017Ei vse orbitale",
  "canvas.screenSize": "Velikost zaslona",
  "dockLayout.collapse.sidebar": "Strni stransko plo\u0161\u010Do",
  "dockLayout.expand.sidebar": "Raz\u0161iri stransko plo\u0161\u010Do",
  "dockLayout.collapse.secondary-sidebar": "Strni desno plo\u0161\u010Do",
  "dockLayout.expand.secondary-sidebar": "Raz\u0161iri desno plo\u0161\u010Do",
  "dockLayout.collapse.bottom-panel": "Strni spodnjo plo\u0161\u010Do",
  "dockLayout.expand.bottom-panel": "Raz\u0161iri spodnjo plo\u0161\u010Do",
  "dockLayout.openMenu": "Meni",
  "dockLayout.menu": "Meni",
  "dockLayout.backToMenu": "Nazaj na meni",
  "commitRow.kind.user": "Va\u0161e shranjevanje",
  "commitRow.kind.agent": "Sprememba agenta",
  "commitRow.kind.restore": "Obnovitev",
  "commitRow.kind.undo": "Razveljavitev",
  "commitRow.current": "Trenutna",
  "commitRow.restore": "Obnovi",
  "changeList.added": "Dodano",
  "changeList.modified": "Spremenjeno",
  "changeList.removed": "Odstranjeno",
  "changeList.before": "Prej",
  "changeList.after": "Potem",
  "changeList.inspect": "Preglej",
  "changeList.empty": "V tej razli\u010Dici ni sprememb.",
  "commitRow.kind.redo": "Uveljavitev",
  "commitRow.kind.snapshot": "Posnetek",
  "codeAssist.thinking": "Razmi\u0161ljam\u2026",
  "codeAssist.findingFixes": "I\u0161\u010Dem popravke\u2026",
  "codeAssist.suggested": "{{count}} predlogov",
  "codeAssist.keys": "Tab sprejmi \xB7 \u2318/Ctrl+Enter sprejmi vse \xB7 Esc opusti",
  "codeAssist.acceptAll": "Sprejmi vse",
  "codeAssist.suggestFixes": "Predlagaj popravke za {{count}} te\u017Eav \xB7 \u2318/Ctrl+.",
  "codeAssist.line": "Vrstica {{line}}",
  "avl.play.step": "Korak",
  "avl.play.play": "Predvajaj",
  "avl.play.pause": "Premor",
  "avl.play.stop": "Ustavi",
  "avl.play.payload": "Podatki",
  "avl.play.fired": "Izvedeno",
  "avl.play.blocked": "Blokirano",
  "avl.play.notReached": "Ni izbrano",
  "avl.play.guardPassed": "Varovalo je pre\u0161lo",
  "avl.play.guardFailed": "Varovalo ni pre\u0161lo",
  "avl.play.notPlayed": "\u0160e ni predvajano. Korak ga za\u017Eene na vzor\u010Dni vrstici.",
  "avl.play.sceneStep": "Korak {{n}} od {{total}}",
  "avl.play.scene": "Prizor",
  "avl.play.effectFailed": "Napaka",
  "avl.system.counts": "{{traits}} lastnosti \xB7 {{pages}} strani \xB7 {{fields}} polj",
  "avl.system.exchanges": "Izmenjuje {{events}}",
  "avl.system.openTraits": "Odpri lastnosti",
  "avl.system.openCode": "Odpri kodo",
  "avl.system.preview": "Predogled",
  "avl.system.connected": "Povezani \xB7 {{count}}",
  "avl.system.standalone": "Samostojni \xB7 {{count}} \u2014 brez dogodkov z drugimi orbitali",
  "avl.system.summary": "{{orbitals}} orbitalov \xB7 {{wires}} povezav",
  "avl.system.search": "Poi\u0161\u010Di orbital ali dogodek",
  "avl.system.wiresOnly": "Samo povezave",
  "avl.system.lensEvents": "Dogodki",
  "avl.system.lensDependencies": "Odvisnosti",
  "avl.deps.hint": "Klikni orbital ali vedenje, da vidi\u0161, iz \u010Desa je zgrajeno in kaj je odvisno od njega",
  "avl.deps.selected": "{{name}} \xB7 zgrajeno iz {{upstream}} \xB7 {{downstream}} odvisnih",
  "avl.deps.legendUpstream": "Navzgor (zgrajeno iz)",
  "avl.deps.legendDownstream": "Navzdol (odvisno od njega)",
  "avl.deps.column.app": "Tvoja aplikacija \xB7 orbitali",
  "avl.deps.column.io": "io \xB7 realizacije",
  "avl.deps.column.std": "std \xB7 vedenja",
  "avl.deps.column.primitive": "std \xB7 gradniki vmesnika",
  "avl.deps.column.unknown": "Zunaj registrov",
  "avl.deps.search": "Poi\u0161\u010Di orbital ali vedenje",
  "avl.flow.lensFlow": "Tok",
  "avl.flow.lensTraits": "Lastnosti",
  "avl.flow.selected": "{{name}} \xB7 {{into}} ga spro\u017Ei \xB7 spro\u017Ei {{out}}",
  "avl.flow.summary": "{{traits}} lastnosti \u2192 {{own}} lastnih + {{composed}} sestavljenih ({{pieces}} izrisov zlo\u017Eenih) \xB7 klikni eno, da vidi\u0161, kaj jo spro\u017Ei",
  "avl.flow.showTraits": "Poka\u017Ei njene lastnosti",
  "avl.flow.legendInto": "Ga spro\u017Ei",
  "avl.flow.legendOut": "Spro\u017Ei",
  "avl.flow.showing": "Prikazano {{name}} \xB7 {{count}} lastnosti",
  "avl.flow.showAll": "Poka\u017Ei vse",
  "avl.deps.column.own": "Lastne lastnosti",
  "avl.deps.column.client": "Odjemalci",
  "avl.deps.column.host": "Gostitelj",
  "avl.deps.column.service": "Storitve",
  "avl.deps.column.store": "Shrambe podatkov",
  "avl.deps.column.external": "Zunanji API-ji",
  "avl.unit.status.ok": "Zdravo",
  "avl.unit.status.degraded": "Oslabljeno",
  "avl.unit.status.down": "Ne deluje",
  "avl.unit.status.idle": "Brez prometa",
  "avl.flow.traitsCount": "{{count}} lastnosti",
  "avl.flow.piecesCount": "{{count}} izrisov",
  "avl.flow.traitsCountOne": "1 lastnost",
  "avl.flow.piecesCountOne": "1 izris",
  "gantt.datesReversed": "Kon\u010Da se pred za\u010Detkom \u2014 preverite datuma",
  "chatBar.askTheAgentAnything": "Vpra\u0161ajte agenta karkoli \u2026",
  "canvas.loadingMessage": "Nalaganje \u2026",
  "chatBar.cancelGeneration": "Prekli\u010Di generiranje",
  "chatBar.clearSelection": "Po\u010Disti izbor",
  "chatBar.editing": "Urejanje",
  "chatBar.pauseTheAgentYouCanEdit": "Zaustavi agenta \u2014 med \u010Dakanjem lahko urejate platno",
  "chatBar.resume": "Nadaljuj",
  "chatBar.resumeTheAgentYourCanvasEdits": "Nadaljuj z agentom \u2014 va\u0161i popravki platna ostanejo",
  "chatBar.sendMessage": "Po\u0161lji sporo\u010Dilo",
  "openFile.retry": "Poskusi znova",
  "subagentTrace.content": "Vsebina",
  "subagentTrace.coordinator": "Koordinator",
  "subagentTrace.countDone": "{{count}} kon\u010Danih",
  "subagentTrace.countRunning": "{{count}} v teku",
  "subagentTrace.densityCompact": "Strnjeno",
  "subagentTrace.densityRich": "Podrobno",
  "subagentTrace.eventsCount": "{{count}} dogodkov",
  "subagentTrace.messagesCount": "{{count}} sporo\u010Dil",
  "subagentTrace.noAgentActivity": "\u0160e ni dejavnosti agenta",
  "subagentTrace.noConversationLog": "Ni dnevnika pogovora",
  "subagentTrace.noSubagentsActive": "Ni aktivnih podagentov",
  "subagentTrace.noSubagentsForOrbital": "Ni podagentov za {{orbital}}",
  "subagentTrace.organism": "Organizem",
  "subagentTrace.pendingQuestion": "{{count}} odprto vpra\u0161anje",
  "subagentTrace.pendingQuestions": "{{count}} odprtih vpra\u0161anj",
  "subagentTrace.planOrbital": "Na\u010Drt \xB7 {{count}} orbital",
  "subagentTrace.planOrbitals": "Na\u010Drt \xB7 {{count}} orbitalov",
  "subagentTrace.reasoning": "Razmi\u0161ljanje",
  "subagentTrace.subagentCount": "{{count}} podagent",
  "subagentTrace.subagentCountPlural": "{{count}} podagentov",
  "subagentTrace.subagents": "Podagenti",
  "subagentTrace.subagentsWithCount": "Podagenti ({{count}})",
  "subagentTrace.thinking": "razmi\u0161lja",
  "subagentTrace.toolCallCount": "{{count}} klic orodja",
  "subagentTrace.toolCallCountPlural": "{{count}} klicev orodij",
  "subagentTrace.toolCalls": "Klici orodij",
  "subagentTrace.trace": "Sled",
  "subagentTrace.waitingForProcessData": "\u010Cakanje na podatke procesa \u2026",
  "subagentTrace.wasOrganism": "prej {{organism}}",
  "common.moveUp": "Premakni gor",
  "common.moveDown": "Premakni dol",
  "repeatable.addedIn": "Dodano v:",
  "repeatable.minItemsOne": "Zahtevan je vsaj 1 element",
  "repeatable.minItems": "Zahtevanih je vsaj {{count}} elementov",
  "lightbox.counter": "{{current}} / {{total}}",
  "aria.imageViewer": "Pregledovalnik slik",
  "aria.ratingValue": "Ocena: {{value}} od {{max}}",
  "pagination.label": "\u0160tevil\u010Denje strani",
  "pagination.pageOf": "{{page}} / {{total}}",
  "violationAlert.citation": "{{law}} \u010Dl. {{article}}",
  "aria.search": "Iskanje",
  "form.fixFields": "Popravite {{count}} polj",
  "form.invalidValue": "Neveljavna vrednost",
  "bloomQuiz.question": "Vpra\u0161anje {{number}}",
  "bloomQuiz.hideAnswer": "Skrij odgovor",
  "bloomQuiz.revealAnswer": "Razkrij odgovor",
  "bloomQuiz.answer": "Odgovor:",
  "bloomQuiz.level.remember": "Zapomni si",
  "bloomQuiz.level.understand": "Razumi",
  "bloomQuiz.level.apply": "Uporabi",
  "bloomQuiz.level.analyze": "Analiziraj",
  "bloomQuiz.level.evaluate": "Vrednoti",
  "bloomQuiz.level.create": "Ustvari",
  "reflection.title": "Ustavi se in razmisli",
  "reflection.placeholder": "Tvoje misli ...",
  "reflection.saveContinue": "Shrani in nadaljuj",
  "reflection.answeredEdit": "\u2713 Odgovorjeno \xB7 Uredi",
  "reflection.answerQuestion": "Odgovori na to vpra\u0161anje",
  "activation.title": "Preden za\u010Dne\u0161 ...",
  "activation.placeholder": "Zapi\u0161i svoje misli ...",
  "activation.continue": "Nadaljuj na lekcijo \u2192",
  "activation.skip": "Presko\u010Di za zdaj",
  "activation.answeredEdit": "\u2713 Odgovorjeno \xB7 Uredi odgovor",
  "connection.title": "Gradimo na tem, kar \u017Ee ve\u0161",
  "likert.stronglyDisagree": "Sploh se ne strinjam",
  "likert.disagree": "Ne strinjam se",
  "likert.neutral": "Nevtralno",
  "likert.agree": "Strinjam se",
  "likert.stronglyAgree": "Popolnoma se strinjam",
  "likert.ariaLabel": "Likertova lestvica",
  "dateRange.last7Days": "Zadnjih 7 dni",
  "dateRange.last30Days": "Zadnjih 30 dni",
  "dateRange.thisMonth": "Ta mesec",
  "dateRange.thisQuarter": "To \u010Detrtletje",
  "dateRange.yearToDate": "Od za\u010Detka leta",
  "dateRange.from": "Od",
  "dateRange.to": "Do",
  "jsonTree.type.text": "bes",
  "jsonTree.type.number": "\u0161tev",
  "jsonTree.type.boolean": "da/ne",
  "jsonTree.valueType": "Vrsta vrednosti",
  "jsonTree.itemCountOne": "{{count}} element",
  "jsonTree.itemCountOther": "{{count}} elementov",
  "jsonTree.fieldCountOne": "{{count}} polje",
  "jsonTree.fieldCountOther": "{{count}} polj",
  "jsonTree.collapse": "Strni",
  "jsonTree.expand": "Raz\u0161iri",
  "jsonTree.addItem": "Dodaj element",
  "jsonTree.addField": "Dodaj polje",
  "import.phase.fetching": "Pridobivanje",
  "import.phase.mapping": "Preslikava",
  "import.phase.reviewing": "Pregledovanje",
  "import.phase.committing": "Potrjevanje",
  "import.phase.done": "Kon\u010Dano",
  "import.phase.failed": "Ni uspelo",
  "import.staged": "Pripravljeno {{count}}",
  "import.committed": "Potrjeno {{count}}",
  "import.failedCount": "Neuspelo {{count}}",
  "import.noUnitsStaged": "Ni pripravljenih enot.",
  "import.skipped": "Presko\u010Deno",
  "import.confirmImport": "Potrdi uvoz",
  "coachmark.skip": "Presko\u010Di",
  "coachmark.gotIt": "Razumem",
  "documentViewer.noDocumentDescription": "Ni dokumenta za prikaz.",
  "documentViewer.iframeTitle": "Dokument",
  "emojiPicker.addEmoji": "Dodaj emoji",
  "emojiPicker.search": "I\u0161\u010Di emoji \u2026",
  "iconPicker.category": "ikone",
  "iconPicker.search": "I\u0161\u010Di ikone \u2026",
  "commandPalette.placeholder": "Vnesi ukaz ...",
  "commandPalette.noMatches": "Ni ustreznih ukazov",
  "gridPicker.all": "Vse",
  "gridPicker.moreRefine": "+\u0161e {{count}} \u2014 zo\u017Eite iskanje",
  "graphCanvas.noNodes": "Ni vozli\u0161\u010D za prikaz.",
  "codeBlock.noCode": "Ni kode za prikaz.",
  "codeBlock.region": "Koda",
  "fab.action": "Dejanje",
  "fab.closeActions": "Zapri dejanja",
  "fab.openActions": "Odpri dejanja",
  "featureCard.learnMore": "Izvedi ve\u010D",
  "fileTree.collapse": "Strni",
  "fileTree.expand": "Raz\u0161iri",
  "fileTree.nodeAction": "Dejanje vozli\u0161\u010Da",
  "voteStack.ariaLabel": "Glas",
  "numberStepper.ariaLabel": "\u0160tevni izbirnik",
  "carousel.goToSlide": "Pojdi na diapozitiv {{number}}",
  "tagInput.placeholder": "Vnesi in pritisni Enter \u2026",
  "tagInput.removeTag": "Odstrani {{tag}}",
  "nodeSlot.none": "\u2014 brez \u2014",
  "nodeSlot.props": "lastnosti",
  "positionedCanvas.status.empty": "Prazno",
  "positionedCanvas.status.seated": "Sedi",
  "positionedCanvas.status.ordered": "Naro\u010Deno",
  "positionedCanvas.status.awaitingBill": "\u010Caka ra\u010Dun",
  "positionedCanvas.status.cleaning": "\u010Ci\u0161\u010Denje",
  "positionedCanvas.capacity": "Kap. {{count}}",
  "propertyInspector.editInSource": "{{type}} \u2014 uredi v izvoru",
  "propertyInspector.config": "Konfiguracija",
  "propertyInspector.noProperties": "Ni nastavljivih lastnosti.",
  "propertyInspector.tier.presentation": "predstavitev",
  "propertyInspector.tier.domain": "domena",
  "propertyInspector.tier.policy": "pravilnik",
  "propertyInspector.tier.infra": "infrastruktura",
  "propertyInspector.tier.internal": "notranje",
  "upload.error.readFailed": "Izbrane datoteke ni bilo mogo\u010De prebrati",
  "selection.ask": "Vpra\u0161aj",
  "selection.note": "Opomba",
  "selection.toolbar": "Dejanja izbora",
  "qrScanner.apiUnavailable": "API kamere v tem okolju ni na voljo",
  "themeToggle.switchToLight": "Preklopi na svetli na\u010Din",
  "themeToggle.switchToDark": "Preklopi na temni na\u010Din",
  "themeToggle.light": "Svetlo",
  "themeToggle.dark": "Temno",
  "avatar.alt": "Avatar",
  "avatar.status": "Stanje: {{status}}",
  "avatar.status.online": "na spletu",
  "avatar.status.offline": "brez povezave",
  "avatar.status.away": "odsoten",
  "avatar.status.busy": "zaseden",
  "avatar.badge": "Zna\u010Dka: {{badge}}",
  "progressBar.ariaLabel": "Napredek: {{percent}}",
  "rangeSlider.ariaLabel": "Drsnik obsega",
  "select.nSelected": "Izbranih: {{count}}",
  "select.searchPlaceholder": "Iskanje\u2026",
  "statusDot.online": "na spletu",
  "statusDot.offline": "brez povezave",
  "statusDot.away": "odsoten",
  "statusDot.busy": "zaseden",
  "statusDot.warning": "opozorilo",
  "statusDot.critical": "kriti\u010Dno",
  "trendIndicator.up": "navzgor",
  "trendIndicator.down": "navzdol",
  "trendIndicator.flat": "nespremenjeno",
  "trendIndicator.withValue": "{{direction}} {{value}}",
  "chart.weekOf": "Teden od {{date}}",
  "chart.quarterOf": "{{quarter}}. \u010Detrtletje {{year}}",
  "detailPanel.section.overview": "Pregled",
  "detailPanel.section.metrics": "Metrika",
  "detailPanel.section.timeline": "\u010Casovnica",
  "detailPanel.section.details": "Podrobnosti",
  "codeRunner.run": "Za\u017Eeni",
  "codeRunner.output": "Izhod",
  "codeRunner.exit": "Izhod {{code}}",
  "codeRunner.noOutput": "Brez izhoda",
  "codeRunner.testPassed": "Test {{number}}: uspel",
  "codeRunner.testFailed": "Test {{number}}: ni uspel",
  "codeRunner.input": "Vhod: {{value}}",
  "codeRunner.expected": "Pri\u010Dakovano: {{value}}",
  "codeRunner.actual": "Dejansko: {{value}}",
  "toast.notification": "Obvestilo",
  "subagentTrace.errorMessage": "Napaka: {{message}}",
  "subagentTrace.role.system": "sistem",
  "subagentTrace.role.user": "uporabnik",
  "subagentTrace.role.assistant": "asistent",
  "subagentTrace.role.tool": "orodje",
  "subagentTrace.subagent": "podagent",
  "subagentTrace.activityType.tool_call": "klic orodja",
  "subagentTrace.activityType.tool_result": "rezultat orodja",
  "subagentTrace.activityType.message": "sporo\u010Dilo",
  "subagentTrace.activityType.error": "napaka",
  "subagentTrace.activityType.file_operation": "datote\u010Dna operacija",
  "subagentTrace.activityType.schema_diff": "razlika sheme",
  "subagentTrace.fileOperation.ls": "seznam",
  "subagentTrace.fileOperation.read_file": "branje",
  "subagentTrace.fileOperation.write_file": "pisanje",
  "subagentTrace.fileOperation.edit_file": "urejanje",
  "subagentTrace.diffPreview": "razlika {{path}}",
  "subagentTrace.success": "uspeh",
  "subagentTrace.fail": "neuspeh",
  "subagentTrace.badgeError": "napaka",
  "subagentTrace.badgeFile": "datoteka",
  "subagentTrace.badgeDiff": "razlika",
  "subagentTrace.unattached": "(nepovezano)",
  "dashboard.defaultAppName": "Aplikacija",
  "dashboard.defaultUserName": "Uporabnik",
  "auth.defaultAppName": "Moja aplikacija",
  "counter.title": "\u0160tevec",
  "counter.resetToZero": "Ponastavi na 0",
  "subagentTrace.activityType.milestone": "mejnik",
  "subagentTrace.activityType.analysis": "analiza",
  "subagentTrace.activityType.cancelled": "preklicano",
  "subagentTrace.activityType.clarification_question": "vpra\u0161anje za pojasnitev",
  "subagentTrace.activityType.coordinator_decision": "odlo\u010Ditev koordinatorja",
  "subagentTrace.activityType.done": "kon\u010Dano",
  "subagentTrace.activityType.llm_response": "odgovor modela",
  "subagentTrace.activityType.orbital_done": "orbital kon\u010Dan",
  "subagentTrace.activityType.orbital_started": "orbital za\u010Det",
  "subagentTrace.activityType.pending_question": "\u010Dakajo\u010De vpra\u0161anje",
  "subagentTrace.activityType.plan_committed": "na\u010Drt potrjen",
  "subagentTrace.activityType.schema_change": "sprememba sheme",
  "gameMenu.defaultTitle": "Epska odprava",
  "gameMenu.newGame": "Nova igra",
  "gameMenu.continue": "Nadaljuj",
  "gameMenu.settings": "Nastavitve",
  "choiceButton.defaultText": "Juri\u0161aj naprej v boj",
  "dialogueBubble.defaultSpeaker": "Junak",
  "dialogueBubble.defaultText": "Je\u010Da \u010Daka. Svojo pot izberi modro.",
  "gameShell.defaultName": "Igra",
  "gameHud.health": "Zdravje",
  "gameHud.score": "Rezultat",
  "gameHud.lives": "\u017Divljenja",
  "gameHud.time": "\u010Cas",
  "gameHud.hp": "\u017DT",
  "gameHud.mp": "MT",
  "gameHud.level": "Stopnja",
  "controlGrid.jump": "Skok",
  "controlGrid.attack": "Napad",
  "controlGrid.dodge": "Izmik",
  "gameAudio.muted": "Izklopljen zvok",
  "gameAudio.soundOn": "Zvok vklopljen",
  "timerDisplay.seconds": "{{count}} s",
  "learningCanvas.loading": "Nalaganje platna \u2026",
  "physicsPreset.projectileMotion": "Gibanje izstrelka",
  "physicsPreset.simplePendulum": "Preprosto nihalo",
  "physicsPreset.springOscillator": "Vzmetno nihalo",
  "physicsPreset.projectileMotionDescription": "Izstreli \u017Eogo in opazuj paraboli\u010Dno pot pod vplivom te\u017Enosti.",
  "physicsPreset.simplePendulumDescription": "Masa na vrvici, ki niha pod vplivom te\u017Enosti.",
  "physicsPreset.springOscillatorDescription": "Masa, ki poskakuje na vzmeti \u2014 enostavno harmoni\u010Dno nihanje.",
  "physicsPreset.launchAngle": "Kot izstrelitve (\xB0)",
  "physicsPreset.initialVelocity": "Za\u010Detna hitrost (m/s)",
  "physicsPreset.gravity": "Te\u017Enost (m/s\xB2)",
  "physicsPreset.stringLength": "Dol\u017Eina vrvice (px)",
  "physicsPreset.mass": "Masa (kg)",
  "physicsPreset.springStiffness": "Togost vzmeti (k)",
  "physicsPreset.damping": "Du\u0161enje",
  "editor.tile": "Plo\u0161\u010Dica: {{position}}",
  "editor.grid": "Mre\u017Ea: {{width}}x{{height}}",
  "editor.units": "Enote: {{count}}",
  "editor.features": "Objekti: {{count}}",
  "editor.modeSelect": "Izberi",
  "editor.modePaint": "Barvaj",
  "editor.modeUnit": "Enota",
  "editor.modeFeature": "Objekt",
  "editor.modeErase": "Bri\u0161i",
  "canvas3d.errorTitle": "Napaka 3D prizora",
  "canvas3d.errorMessage": "Pri izrisu 3D prizora je pri\u0161lo do napake.",
  "canvas3d.errorDetails": "Podrobnosti napake",
  "canvas3d.reloadPage": "Znova nalo\u017Ei stran",
  "canvas3d.loadingScene": "Nalaganje 3D prizora ...",
  "canvas3d.errorWithMessage": "Napaka: {{message}}",
  "orbPreview.serverUnreachable": "Predogledni stre\u017Enik ni dosegljiv \u2014 izvajanje poteka lokalno. Stanje na stre\u017Eniku in trajna shramba sta onemogo\u010Dena.",
  "verification.unknownError": "Neznana napaka",
  "debug.ticksHint": "Tiki se bodo prikazali, ko bodo tekli obdelovalniki tikov lastnosti",
  "debug.justNow": "pravkar",
  "debug.secondsAgo": "pred {{count}} s",
  "debug.minutesAgo": "pred {{count}} min",
  "debug.tickInterval": "{{count}} ms",
  "debug.tickRunOne": "{{count}} zagon",
  "debug.tickRunOther": "{{count}} zagonov",
  "debug.tickExec": "izvedba {{count}} ms",
  "debug.activeCount": "Aktivni ({{count}})",
  "debug.inactiveCount": "Neaktivni ({{count}})",
  "debug.verificationHint": "Preverjanja se bodo prikazala, ko bo aplikacija izvajala prehode in u\u010Dinke",
  "debug.passedCount": "{{count}} uspe\u0161nih",
  "debug.warningsCount": "{{count}} opozoril",
  "debug.pendingCount": "{{count}} v teku",
  "debug.totalChecksCount": "skupaj {{count}} preverjanj",
  "walkMinimap.engineProgress": "Pogon: {{done}}/{{total}}",
  "walkMinimap.domCount": "DOM: {{count}}",
  "walkMinimap.engine": "Pogon",
  "walkMinimap.dom": "DOM",
  "avlLegend.eventFlow": "Tok dogodkov",
  "avlLegend.orbitalBoundary": "Meja orbitale",
  "avlLegend.entityNucleus": "Entiteta (jedro)",
  "avlLegend.traitRing": "Obro\u010D lastnosti",
  "avlLegend.externalLink": "Zunanja povezava",
  "avlLegend.initialState": "Za\u010Detno stanje",
  "avlLegend.eventEffects": "Dogodek + u\u010Dinki",
  "avlLegend.emitExternal": "Oddaja (zunanja)",
  "avlLegend.slotTarget": "Cilj re\u017Ee",
  "avlLegend.bindingPath": "Vezava (@path)",
  "zoomLegend.legend": "Legenda",
  "zoomLegend.hide": "Skrij",
  "zoomLegend.fieldTypes": "Tipi polj",
  "zoomLegend.stateChain": "Veriga stanj",
  "zoomLegend.eventWire": "Povezava dogodkov",
  "zoomLegend.stateMachine": "Stroj stanj",
  "zoomLegend.emitListen": "Oddaja/poslu\u0161anje",
  "zoomLegend.terminalState": "Kon\u010Dno stanje",
  "zoomLegend.hubState": "Sredi\u0161\u010Dno stanje",
  "zoomLegend.triggerEvent": "Spro\u017Eilni dogodek",
  "zoomLegend.guardDiamond": "Romb varovala",
  "zoomBreadcrumb.system": "Sistem",
  "zoomBreadcrumb.module": "Modul",
  "zoomBreadcrumb.behavior": "Vedenje",
  "zoomBreadcrumb.detail": "Podrobnost",
  "avlSwimLane.listens": "Poslu\u0161a",
  "avlSwimLane.emits": "Oddaja",
  "avlTransitionScene.slots": "Re\u017Ee",
  "avl3d.type": "Tip",
  "avl3d.typeInitial": "Za\u010Detno",
  "avl3d.typeTerminal": "Kon\u010Dno",
  "avl3d.typeStandard": "Standardno",
  "avl3d.incoming": "Dohodni",
  "avl3d.outgoing": "Odhodni",
  "avl3d.status": "Stanje",
  "avl3d.pages": "Strani",
  "avl3d.fieldCountOne": "{{count}} polje",
  "avl3d.fieldCountOther": "{{count}} polj",
  "avl3d.states": "Stanja",
  "avl3d.events": "Dogodki",
  "avl3d.transitions": "Prehodi",
  "avl3d.effectCountOne": "{{count}} u\u010Dinek",
  "avl3d.effectCountOther": "{{count}} u\u010Dinkov",
  "avlBehaviorGlyph.ariaLabel": "Simbol vedenja {{name}}",
  "orbPreview.layer.infrastructure": "Infrastruktura",
  "orbPreview.layer.services": "Storitve",
  "orbPreview.layer.uiPatterns": "Vzorci uporabni\u0161kega vmesnika",
  "orbPreview.layer.game": "Igra",
  "orbPreview.layer.ml": "Strojno u\u010Denje",
  "orbPreview.layer.domain": "Domena",
  "orbPreview.layer.community": "Skupnost",
  "screenSize.mobile": "Mobilno",
  "screenSize.tablet": "Tablica",
  "screenSize.laptop": "Prenosnik",
  "screenSize.wide": "\u0160iroko",
  "flowCanvas.presetSize": "{{label}} ({{width}} px)",
  "avl.breadcrumb.transitionNumber": "Prehod #{{n}}",
  "orbInspector.pattern": "Vzorec",
  "orbInspector.slotLabel": "re\u017Ea: {{slot}}",
  "detailPanel.section.activity": "Dejavnost",
  "detailPanel.section.lineItems": "Postavke",
  "detailPanel.tab.overview": "Pregled",
  "detailPanel.thread.empty": "\u0160e ni sporo\u010Dil",
  "detailPanel.openImage": "Odpri sliko",
  "detailPanel.showImage": "Prika\u017Ei sliko {{index}}",
  "aria.clearSelection": "Po\u010Disti izbor",
  "aria.searchOptions": "I\u0161\u010Di mo\u017Enosti",
  "aria.zoomIn": "Pove\u010Daj",
  "aria.zoomOut": "Pomanj\u0161aj",
  "aria.previousPage": "Prej\u0161nja stran",
  "aria.nextPage": "Naslednja stran",
  "aria.downloadDocument": "Prenesi dokument",
  "aria.printDocument": "Natisni dokument",
  "aria.wrapLines": "Prelomi vrstice",
  "aria.copyCode": "Kopiraj kodo",
  "aria.clearInput": "Po\u010Disti vnos",
  "aria.skipToContent": "Presko\u010Di na vsebino",
  "aria.mainNavigation": "Glavna navigacija",
  "aria.carouselSlides": "Diapozitivi",
  "aria.minimap": "Pomanj\u0161ani zemljevid",
  "aria.canvasScene": "Prizor igre",
  "aria.learningCanvas": "Interaktivni diagram",
  "aria.scene3d": "3D prizor",
  "aria.graphCanvas": "Graf",
  "aria.positionedCanvas": "Tloris",
  "aria.walkTraitDone": "kon\u010Dano",
  "aria.walkTraitPending": "\u010Daka",
  "aria.walkGraph": "Graf stanj za {{trait}}: od {{from}} do {{to}}",
  "aria.loading": "Nalaganje",
  "agentActivity.toolCall": "Klic {{tool}}",
  "agentActivity.toolResult": "{{tool}} je vrnil",
  "agentActivity.toolRows": "Vrstic: {{count}}",
  "agentActivity.thinking": "Razmi\u0161ljam\u2026",
  "agentActivity.analyzed": "Zahteva analizirana \u2014 {{organism}}",
  "agentActivity.renamed": "Preimenuj {{from}} \u2192 {{to}}",
  "agentActivity.deleted": "Odstrani {{orbitalName}}",
  "agentActivity.roster": "Na\u010Drtovanje {{count}} orbital",
  "agentActivity.orbitalStarted": "Delo na {{orbitalName}}\u2026",
  "agentActivity.orbitalStartedSettled": "Za\u010Deto: {{orbitalName}}",
  "agentActivity.orbitalDone": "{{orbitalName}} pripravljen",
  "agentActivity.orbitalCounts": "{{traitCount}} lastnosti, {{transitionCount}} prehodov",
  "agentActivity.change.orbital-added": "Dodan {{orbitalName}}",
  "agentActivity.change.orbital-removed": "Odstranjen {{orbitalName}}",
  "agentActivity.change.entity-fields-changed": "Spremenjena podatkovna polja {{orbitalName}}",
  "agentActivity.change.trait-added": "Dodano vedenje v {{orbitalName}}",
  "agentActivity.change.trait-removed": "Odstranjeno vedenje iz {{orbitalName}}",
  "agentActivity.change.state-machine-changed": "Spremenjen tok {{orbitalName}}",
  "agentActivity.change.guard-changed": "Spremenjeno pravilo v {{orbitalName}}",
  "agentActivity.change.effect-changed": "Spremenjeno delovanje {{orbitalName}}",
  "agentActivity.change.render-ui-changed": "Spremenjen videz {{orbitalName}}",
  "agentActivity.change.event-wiring-changed": "Spremenjene povezave {{orbitalName}}",
  "agentActivity.change.page-changed": "Spremenjene strani {{orbitalName}}",
  "agentActivity.change.behavior-composed": "Vedenje vgrajeno v {{orbitalName}}",
  "agentActivity.done": "Kon\u010Dano \u2014 {{count}} orbital pripravljenih",
  "agentActivity.cancelled": "Preklicano",
  "agentActivity.jump": "Poka\u017Ei",
  "agentActivity.emptyTitle": "\u0160e ni dejavnosti",
  "agentActivity.emptyDescription": "Po\u0161ljite sporo\u010Dilo in tukaj se bo prikazalo delo agenta.",
  "agentActivity.fileOperation": "{{operation}}",
  "agentActivity.schemaDiff": "Urejeno {{filePath}}",
  "agentActivity.coordinatorDecision": "Izbrano {{organism}}",
  "agentActivity.change.trait-config-changed": "Spremenjene nastavitve {{orbitalName}}",
  "agentActivity.change.theme-changed": "Spremenjena tema {{orbitalName}}",
  "agentActivity.llmResponse": "Surov odgovor LLM",
  "agentActivity.llmDuration": "{{seconds}} s",
  "agentActivity.llmTokens": "{{prompt}} vhodnih / {{completion}} izhodnih \u017Eetonov",
  "agentActivity.llmResponseLabel": "Odgovor",
  "agentActivity.llmSystemPrompt": "Sistemski poziv",
  "agentActivity.llmUserPrompt": "Uporabni\u0161ki poziv",
  "agentActivity.llmToolCalls": "Klici orodij",
  "agentActivity.showRawLlm": "Surovi LLM",
  "agentActivity.earlierConversations": "Prej\u0161nji pogovori ({{count}})",
  "agentActivity.earlierActivity": "Prej\u0161nja dejavnost",
  "tabs.scrollStart": "Pomakni zavihke nazaj",
  "tabs.scrollEnd": "Pomakni zavihke naprej",
  "agentChat.workedThrough": "Opravil {{count}} korakov",
  "agentChat.newMessages": "Nova sporo\u010Dila",
  "agentChat.copy": "Kopiraj odgovor",
  "agentChat.copied": "Kopirano",
  "agentChat.today": "Danes",
  "agentChat.yesterday": "V\u010Deraj",
  "agentChat.emptyDescription": "Vpra\u0161ajte s svojimi besedami \u2014 pomo\u010Dnik lahko poi\u0161\u010De podatke in namesto vas naredi spremembe.",
  "avl.effectCategory.ui": "Zaslon \u2014 spremeni, kar vidi uporabnik",
  "avl.effectCategory.data": "Podatki \u2014 bere, spreminja ali shranjuje zapise",
  "avl.effectCategory.communication": "Sporo\u010Dila \u2014 po\u0161lje dogodek, obvestilo ali zahtevo",
  "avl.effectCategory.lifecycle": "\u017Divljenjski cikel \u2014 za\u017Eene ali odstrani delujo\u010De primerke",
  "avl.effectCategory.control": "Tok \u2014 odlo\u010Di, kaj se izvede naslednje",
  "avl.effectCategory.async": "\u010Casovanje \u2014 \u010Daka, zamakne ali izvaja stvari hkrati",
  "avl.effectCategory.compute": "Izra\u010Dun \u2014 za\u017Eene model ali izra\u010Dun",
  "avl.effectCategory.system": "Sistem \u2014 dela s platformo in njenimi orodji",
  "avl.stateInitial": "za\u010Detek",
  "avl.stateTerminal": "konec",
  "avl.guardCaption": "Prehod se zgodi le, ko je ta pogoj izpolnjen.",
  "avl.effectsCaption": "Kaj se izvede, po vrsti, ko se prehod zgodi."
};

export { ar_default, sl_default };
